// Auto-generated from es.json - DO NOT EDIT DIRECTLY
// Edit src/assets/i18n/es.json instead, then run: npm run i18n:sync
// Or let the build watch mode auto-sync on changes.

import type { Translation } from '../i18n-types';

const es = {
	meals: {
		breakfast: 'Desayuno',
		lunch: 'Almuerzo',
		dinner: 'Cena',
		supper: 'Cena ligera',
		snack: 'Tentempié',
		snackNumbered: 'Tentempié {number}',
	},
	editWeighIn: {
		title: 'Registrar peso',
		skinfolds: {
			suprailiac: 'Suprailíaco',
			umbilical: 'Umbilical',
			thigh: 'Muslo',
			chest: 'Pecho',
			tricep: 'Tríceps',
		},
		validation: {
			weight: 'Indica tu peso actual.',
			skinfolds: 'Mide tus pliegues cutáneos de 3 a 5 veces en cada punto y calcularemos el promedio.',
		},
		labels: {
			bodyWeight: 'Peso corporal',
			bodyFat: 'Grasa corporal',
			skinfolds: 'Pliegues cutáneos',
			waist: 'Cintura',
		},
		notes: {
			bodyFatTracking: 'Activa el método o los métodos que quieras usar para hacer seguimiento de la grasa corporal.',
			logWeightInstructions: 'Registra tu peso cada mañana antes de desayunar y después de ir al baño.',
			measureSkinfolds: 'Mide tus pliegues cutáneos de 3 a 5 veces en cada punto y calcularemos tu promedio.',
			measureWaist: 'Mide tu cintura antes de desayunar y después de ir al baño. Exhala por completo, contrae los abdominales y coloca la cinta plana alrededor del ombligo con una tensión constante. Para mejores resultados, usa una cinta con autotensado como la AccuFitness MyoTape.',
		},
		buttons: {
			save: 'Guardar',
		},
		warnings: {
			weightNotMeasured: 'Han pasado {days} días desde tu último pesaje. Intenta adquirir el hábito de pesarte a diario para mejorar la constancia y el seguimiento.',
			weightNotMeasuredWeeks: 'Han pasado {weeks} semanas desde tu último pesaje. Intenta adquirir el hábito de pesarte a diario para mejorar la constancia y el seguimiento.',
			weightNotMeasuredLongTime: 'Intenta adquirir el hábito de pesarte a diario para mejorar la constancia y el seguimiento.',
			bodyFatNotMeasured: 'Han pasado {days} días desde que mediste tus pliegues cutáneos o tu cintura. Para mejores resultados, mídelos cada {frequency} días.',
			bodyFatNotMeasuredWeeks: 'Han pasado {weeks} semanas desde que mediste tus pliegues cutáneos o tu cintura. Para mejores resultados, mídelos cada {frequency} días.',
			bodyFatNotMeasuredLongTime: 'Hace tiempo que no mides tus pliegues cutáneos o tu cintura. Para mejores resultados, mídelos cada {frequency} días.',
		},
		info: {
			futureWeighIn: 'No puedes introducir pesos para fechas futuras.',
			neverMeasuredBodyFat: 'Deberías medir tu composición de grasa corporal cada {frequency} días. Elige qué métodos quieres usar. Los plicómetros son más precisos, pero las cintas métricas son más fáciles de usar.',
			bodyFatNeededForProgressCheck: 'Tu revisión de progreso necesita algunas mediciones más de pliegues cutáneos o de cintura para valorar tu tendencia. Medir hoy ayuda.',
			bodyFatCooldownTomorrow: 'Podrás volver a medir tus pliegues cutáneos o tu cintura mañana.',
			bodyFatCooldownDays: 'Podrás volver a medir tus pliegues cutáneos o tu cintura dentro de {days} días, el {date}.',
		},
		links: {
			howToMeasureSkinfolds: '¿Cómo medir los pliegues cutáneos?',
		},
	},
	weeklyCheckup: {
		dailyAvgWithDelta: '{avg} kcal ({sign}{diff})',
		loading: {
			processingData: 'Procesando datos. Espera un momento...',
			finishingCheckup: 'Finalizando la revisión semanal, espera un momento...',
		},
		errors: {
			couldNotProcess: 'No pudimos actualizar tu programa en este momento. Inténtalo de nuevo o contacta con soporte si el problema continúa.',
			progressCheckFailed: 'No pudimos calcular cómo va tu progreso en este momento, así que no podemos hacer tu revisión. Inténtalo de nuevo más tarde o contacta con soporte si el problema continúa.',
		},
		bodyfatEstimation: {
			timeForEstimate: 'Hace tiempo que no estimamos tu porcentaje de grasa corporal, así que vamos a hacerlo ahora.',
			bestEstimate: '¿Cuál es la mejor estimación de tu porcentaje de grasa corporal que puedes obtener (solo necesitas una)?',
			skipOk: 'No pasa nada si lo omites: seguiremos usando la última estimación.',
		},
		nutritionLogging: {
			nextSection: 'A continuación, revisaremos tu ingesta de calorías de la última semana para actualizar tu programa de cara a la próxima semana.',
			deselectIncomplete: 'Desmarca los días que parezcan incompletos o registrados en parte y los excluiremos de nuestros cálculos.',
		},
		calorieBaseline: {
			beforeAdjust: 'Antes de ajustar tu ingesta de calorías para la próxima semana, necesitamos hacernos una idea precisa de tu ingesta de energía actual.',
			whichOption: '¿Cuál de estas opciones refleja mejor tu ingesta media de calorías de la última semana?',
			logged: 'Registrado',
			loggedNote: 'Este es el promedio de calorías registradas por día durante la semana anterior, excluyendo los días que marcaste como incompletos.',
			target: 'Objetivo',
			targetNote: 'Esta es tu ingesta media diaria de calorías objetivo recomendada de la semana anterior.',
			custom: 'Personalizado',
			customNote: 'Si consumiste un número de calorías distinto al de las opciones anteriores, introdúcelo aquí.',
		},
		programUpdate: {
			basedOnProgress: 'Según tus datos de progreso, te recomendamos las siguientes actualizaciones para tu programa:',
			progressOnTrack: '¡Tu progreso va por buen camino! No hace falta ningún ajuste por ahora.',
			notEnoughData: 'Todavía no hay suficientes datos de progreso. Por ahora no se recomiendan cambios. Sigue registrando tus pesajes y tus medidas corporales para que podamos hacer seguimiento de tu progreso.',
			notEnoughDataCompleted: 'No había suficientes datos de progreso en el momento de esta revisión. No se recomendaron cambios.',
			undeterminedMeasureMoreOften: 'Necesitamos más mediciones para valorar tu progreso, así que esta semana no se recomiendan cambios. Sigue registrando tu peso cada día y añade mediciones de pliegues cutáneos o de cintura cuando la pantalla de pesaje te las pida.',
			undeterminedBodyFatTrendUnclear: 'Tu tendencia de grasa corporal aún no está clara, así que esta semana no se recomiendan cambios. Añade algunas mediciones más de pliegues cutáneos o de cintura en los próximos días. La pantalla de pesaje te las pedirá.',
			undeterminedDataErratic: 'Tus mediciones fluctúan mucho, así que no se puede encontrar una tendencia clara y esta semana no se recomiendan cambios. Intenta medir siempre en las mismas condiciones.',
			undeterminedWeightTooFlat: 'Tus últimas lecturas de peso han sido exactamente iguales, así que esta semana no se recomiendan cambios. Comprueba que tu báscula funcione correctamente.',
			atMinimum: 'Tu progreso indica que deberías comer un poco menos, pero tu objetivo diario de calorías ya está en el mínimo que la app establece para tu peso corporal. No puede bajar más, así que no se hace ningún cambio.',
			atMinimumCompleted: 'El progreso indicaba que debías comer menos, pero tu objetivo diario de calorías ya estaba en el mínimo que la app establece para tu peso corporal, así que no se hizo ningún cambio.',
			lowestTarget: 'Este es el objetivo diario de calorías más bajo que la app establece para tu peso corporal.',
			changeTooSmall: 'Según tus datos de progreso, tu objetivo diario de calorías apenas cambiaría. La diferencia es demasiado pequeña para importar, así que no se hace ningún cambio.',
			changeTooSmallCompleted: 'El cambio de calorías recomendado era demasiado pequeño para importar, así que no se hizo ningún cambio.',
		},
		bfMethods: {
			calipers: 'Plicómetros',
			tape: 'Cinta',
			visual: 'Visual',
			unknown: 'Método desconocido',
		},
		headers: {
			bodyfatEstimation: 'Estimación de grasa corporal',
			programUpdate: 'Actualización del programa',
			checkupStatus: 'Estado de la revisión',
		},
		descriptions: {
			intro: 'Para mantener tu programa óptimo y al día, ahora revisaremos tu progreso de la última semana y haremos actualizaciones si es necesario.',
			futureCheckup: 'Esta revisión semanal está programada para una fecha futura. Espera hasta la fecha programada para empezar la revisión.',
			outdatedCheckup: 'Esta revisión está desactualizada y ya no se puede completar. En su lugar, completa la revisión de la semana actual.',
			weightTrendingWell: 'Tu peso y tus medidas corporales están evolucionando en la dirección correcta a buen ritmo. ¡Sigue así, buen trabajo!',
			weightNotEnoughData: 'No tenemos suficientes datos para determinar si tu peso y tus medidas corporales están evolucionando en la dirección correcta. Registra más pesajes y medidas corporales.',
			noWorkoutsLoggedLastWeek: 'La semana pasada no registraste ningún entrenamiento.',
			workoutProgressionSummary: 'La semana pasada, progresaste en ejercicios {progressions} {{vez|veces}} y retrocediste {regressions} {{vez|veces}}.',
		},
		charts: {
			weightTrend: 'Tendencia del peso',
			skinfoldTrend: 'Tendencia de los pliegues cutáneos',
			waistTrend: 'Tendencia de la cintura',
			exerciseProgressions: 'Progreso de ejercicios',
		},
		tooltips: {
			weightTrend: 'Mediciones diarias de peso con su línea de tendencia estimada de los últimos 7 días.',
			skinfoldTrend: 'Mediciones diarias de pliegues cutáneos con su línea de tendencia estimada de los últimos 7 días.',
			waistTrend: 'Mediciones diarias de cintura con su línea de tendencia estimada de los últimos 7 días.',
			exerciseProgressions: 'Número de ejercicios que progresaron por entrenamiento durante los últimos 7 días.',
		},
		labels: {
			estimationMethod: 'Método de estimación:',
			estimatedBodyfat: 'Grasa corporal estimada:',
			completionStatus: 'Estado de finalización:',
		},
		buttons: {
			start: 'Empezar',
			decline: 'Rechazar',
			accept: 'Aceptar',
		},
		ownTarget: {
			intakeYouReported: 'Ingesta que indicaste',
			recommendedTarget: 'Objetivo recomendado',
			valueWithChange: '{value} ({change})',
			nothingToChange: 'Ese es el objetivo que recomienda la app, así que no hay nada que cambiar.',
			completedOwn: 'Fijaste tu propio objetivo. La app recomendaba {kcal} kcal.',
			completedCoach: 'Tu entrenador fijó este objetivo. La app recomendaba {kcal} kcal.',
		},
		step: 'Paso {current} de {total}',
		steps: {
			intro: 'Revisión semanal',
			progressReview: 'Revisión del progreso',
			bodyfatEstimation: 'Estimación de grasa corporal',
			nutritionLogging: 'Registro de nutrición',
			calorieBaseline: 'Referencia de calorías',
			programUpdate: 'Actualización del programa',
		},
		completionActions: {
			accepted: 'Ajustes aceptados',
			declined: 'Ajustes rechazados',
			finished: 'Completado',
		},
		validation: {
			selectOption: 'Selecciona una de las opciones.',
			customCalorieIntake: 'Introduce un valor personalizado de calorías.',
			unknownField: 'Campo desconocido',
		},
		finalChoice: {
			acceptApp: 'Aceptar el nuevo objetivo',
			acceptAppHelp: 'La recomendación de la app, calculada a partir de tu progreso.',
			keepAppTarget: 'Mantener el objetivo de la app',
			keepAppTargetHelp: 'Vas por buen camino, así que tu objetivo se queda como está.',
			setOwn: 'Fijar mi propio objetivo',
			setOwnHelp: 'Elige tú mismo un número, en kcal o como un cambio en porcentaje.',
			keepCurrent: 'Mantener mi objetivo actual',
			keepCurrentHelp: 'Nada de tu plan cambia esta semana.',
		},
	},
	nutrientList: {
		logged: 'Registrado',
		targets: 'Objetivos',
		nutrients: 'Nutrientes',
		food: 'Ítem',
		meal: 'Comida',
		day: 'Día',
		total: 'Total',
		left: 'Restante',
		protein: 'Proteína',
		carbs: 'Carbohidratos',
		fat: 'Grasa',
		fiber: 'Fibra',
		cholesterol: 'Colesterol',
		short: {
			protein: 'Pro',
			carbs: 'Car',
			fat: 'Gra',
			fiber: 'Fib',
		},
		oneLetter: {
			protein: 'P',
			carbs: 'C',
			fat: 'G',
			fiber: 'F',
		},
	},
	common: {
		reconnecting: 'Reconectando...',
		offlineBadge: 'Sin conexión',
		linkCopied: 'Enlace copiado al portapapeles. Pégalo en tu navegador.',
		options: {
			yes: 'Sí',
			no: 'No',
		},
		ui: {
			recommended: 'Recomendado',
			default: 'Predeterminado',
		},
		states: {
			skipped: 'Omitido',
		},
		messages: {
			backOnline: 'Ya estás de nuevo en línea.',
			imageQueuedOffline: 'Foto guardada en este dispositivo. Se subirá automáticamente cuando vuelvas a tener conexión.',
			scanAppCapacityReached: 'La app ha alcanzado su límite de escaneos por hoy. Inténtalo de nuevo mañana.',
		},
		toast: {
			dontShowAgain: 'No mostrar nunca',
		},
		words: {
			or: 'o',
			and: 'y',
		},
		measureNames: {
			portion: 'porción',
			piece: 'pieza',
			slice: 'rebanada',
			whole: 'entero',
			prepared: 'porción',
			large: 'grande',
			medium: 'mediano',
			small: 'pequeño',
			can: 'lata',
			bottle: 'botella',
			quart: 'cuarto de galón',
			pint: 'pinta',
			cup: 'taza',
			tbsp: 'cda',
			tablespoon: 'cucharada',
			tsp: 'cdta',
			teaspoon: 'cucharadita',
		},
		measureUnits: {
			descriptions: {
				none: 'ninguna',
				genericNumber: 'Número genérico',
				repetitions: 'Repeticiones',
				sets: 'Series',
				pairs: 'Pares',
				plates: 'Discos',
				percent: 'Porcentaje',
				millimeters: 'milímetros',
				centimeters: 'centímetros',
				feetAndInches: 'pies y pulgadas',
				inches: 'pulgadas',
				kilograms: 'kilogramos',
				pounds: 'libras',
				micrograms: 'microgramos',
				milligrams: 'miligramos',
				grams: 'gramos',
				ounces: 'onzas',
				stonesAndPounds: 'stones y libras',
				kilocalories: 'kilocalorías',
				kilojoules: 'kilojulios',
				internationalUnits: 'unidades internacionales',
				milliliters: 'mililitros',
				fluidOunces: 'onzas líquidas',
				quarts: 'cuartos de galón',
				pints: 'pintas',
				cups: 'tazas',
				tablespoons: 'cucharadas',
				teaspoons: 'cucharaditas',
			},
		},
		pickerTitles: {
			servingSize: 'Tamaño de la porción',
			selectUnit: 'Seleccionar unidad',
			timeFormat: 'Formato de hora',
		},
		scanModels: {
			allModels: 'Todos los modelos',
			costEstimate: '{displayName} (~${cost}/1k)',
		},
		errors: {
			unknownField: 'Campo desconocido',
			generic: 'Algo salió mal. Inténtalo de nuevo.',
		},
		offTrack: {
			tooMuchWeightLoss: {
				cutting: {
					summary: 'Tu peso está bajando más rápido de lo esperado.',
					action: 'Tenemos que ajustar tu plan de nutrición para conservar músculo mientras pierdes grasa.',
				},
				bulking: {
					summary: 'Estás perdiendo peso cuando deberías estar ganándolo.',
					action: 'Tenemos que ajustar tu plan de nutrición para favorecer el crecimiento muscular.',
				},
			},
			tooMuchFatGain: {
				cutting: {
					summary: 'Estás ganando grasa corporal cuando deberías estar perdiéndola.',
					action: 'Tenemos que ajustar tu plan de nutrición para retomar la pérdida de grasa.',
				},
				bulking: {
					summary: 'Tus mediciones de grasa corporal están subiendo más rápido de lo esperado.',
					action: 'Tenemos que ajustar tu plan de nutrición para evitar un aumento excesivo de grasa.',
				},
			},
			notEnoughFatLoss: {
				cutting: {
					summary: 'Tus mediciones de grasa corporal no están bajando como se esperaba.',
					action: 'Tenemos que ajustar tu plan de nutrición para ayudarte a perder grasa.',
				},
			},
			notEnoughWeightGain: {
				bulking: {
					summary: 'Tu peso no está aumentando como se esperaba.',
					action: 'Tenemos que ajustar tu plan de nutrición para ayudarte a ganar masa magra.',
				},
			},
			generic: {
				summary: 'Te has saltado algunos entrenamientos u objetivos de volumen. Mantén la constancia para seguir progresando.',
			},
		},
		buttons: {
			save: 'Guardar',
			select: 'Seleccionar',
			cancel: 'Cancelar',
			delete: 'Eliminar',
			ok: 'Aceptar',
			today: 'Hoy',
			yes: 'Sí',
			accept: 'Aceptar',
			no: 'No',
			back: 'Atrás',
			next: 'Siguiente',
			edit: 'Editar',
			remove: 'Quitar',
			report: 'Informar',
			dismiss: 'Descartar',
			ignore: 'Ignorar',
			learnMore: 'Más información',
			discard: 'Descartar',
			optimize: 'Optimizar',
			saveAsNew: 'Guardar como nuevo',
			split: 'Dividir',
			addPlates: 'Añadir discos',
			cleanUp: 'Limpiar',
			finish: 'Finalizar',
			skip: 'Omitir',
			restoreTask: 'Restaurar tarea',
			autoTune: 'Ajuste automático',
			uncacheFoods: 'Vaciar caché de alimentos',
			testSurvey: 'Probar encuesta',
			apply: 'Aplicar',
			log: 'Registrar',
			undo: 'Deshacer',
			keep: 'Mantener',
			saving: 'Guardando...',
			tryAgain: 'Intentar de nuevo',
			continue: 'Continuar',
			confirm: 'Confirmar',
		},
		weekdays: {
			monday: 'Lunes',
			tuesday: 'Martes',
			wednesday: 'Miércoles',
			thursday: 'Jueves',
			friday: 'Viernes',
			saturday: 'Sábado',
			sunday: 'Domingo',
		},
		weekdayInitials: {
			monday: 'L',
			tuesday: 'M',
			wednesday: 'X',
			thursday: 'J',
			friday: 'V',
			saturday: 'S',
			sunday: 'D',
		},
		placeholders: {
			enterFoodName: 'Introduce el nombre del alimento',
			selectMeasure: 'Selecciona una medida...',
			day: 'DD',
			month: 'MM',
			year: 'AAAA',
			reps: 'Repeticiones',
			enterText: 'Introduce el texto',
			select: 'Seleccionar...',
			selectAnOption: 'Selecciona una opción',
		},
		measurements: {
			weight: 'Peso',
			waist: 'Cintura',
			skinfold: 'Pliegue cutáneo',
			skinfolds: 'Pliegues cutáneos',
		},
		labelStyles: {
			us: 'EE. UU.',
			eu: 'UE',
		},
		programTypes: {
			intensified: 'Intensificado',
			dup: 'DUP',
			tup: 'TUP',
		},
		loading: {
			pleaseWait: 'Espera un momento...',
			sendingReport: 'Enviando informe...',
			registeringPayment: 'Registrando el pago...',
			signingIn: 'Iniciando sesión...',
			loggingInWithGoogle: 'Iniciando sesión con Google...',
			loggingInWithFacebook: 'Iniciando sesión con Facebook...',
			loggingInWithApple: 'Iniciando sesión con Apple...',
		},
		relativeDay: {
			today: 'hoy',
			yesterday: 'ayer',
			tomorrow: 'mañana',
		},
	},
	navigation: {
		home: 'Inicio',
		nutrition: 'Nutrición',
		settings: 'Ajustes',
		training: 'Entrenamiento',
	},
	workouts: {
		restTimer: {
			title: 'Temporizador de descanso',
			defaultLabel: 'Descanso predeterminado',
			exerciseOverrideTitle: 'Anular temporizador de descanso',
			adjustMinus: '-15 s',
			adjustPlus: '+15 s',
			skip: 'Omitir',
			done: '¡Listo!',
			rollerLabel: 'DESCANSO',
			notificationBody: 'Descanso terminado',
			autoStartLabel: 'Iniciar automáticamente',
			infoNative: 'El temporizador de descanso cuenta el tiempo entre series del mismo ejercicio y solo funciona en la app móvil instalada (iOS o Android). Con «Iniciar automáticamente» activado, se inicia cuando registras una serie. Si no, inícialo con el botón «Iniciar temporizador de descanso» debajo de la primera serie. Los ajustes están disponibles en todos los dispositivos.',
			infoOverride: 'Se aplica solo en la app móvil instalada (iOS o Android).',
		},
		detail: {
			weightExplanations: {
				addedWeightExplanation: 'Este es el peso <i>añadido</i> total, <i>sin</i> incluir tu propio peso corporal.',
				totalWeightExplanation: 'Este es el peso <i>total</i> (incluido el peso de la barra).',
			},
			buttons: {
				yesAgree: 'Sí, estoy de acuerdo.',
				noKeepIntensity: 'No, déjame mantener esta intensidad por ahora.',
				noKeepExercise: 'No, déjame mantener este ejercicio por ahora.',
				noKeepProgram: 'No, déjame mantener este programa por ahora.',
				decideLater: 'Lo decidiré más tarde.',
			},
			resolve: 'Resolver',
			workoutComplete: '¡Buen trabajo! Has completado tu entrenamiento.',
			workoutCompleteFirstTest: '¡Entrenamiento de prueba completado! El próximo entrenamiento autorregulará tus repeticiones objetivo.',
			workoutCompleteSecondTest: '¡Pesos iniciales y repeticiones objetivo fijados! Próximo entrenamiento: sobrecarga progresiva.',
			plan: 'Plan',
			skipped: 'Omitido',
			setOrdinal: 'Serie {number}',
			setInstructionsToggle: 'Instrucciones de la serie',
			collapseSet: 'Contraer serie',
			repsLabel: 'Repeticiones',
			bwHelpText: 'Introduce solo el peso añadido. Introduce 0 si usaste tu peso corporal (sin peso añadido).',
			myoReps: 'Myo-reps',
			lastWorkout: 'Último entrenamiento',
			lastWorkoutSameIntensity: 'Mostrando el último entrenamiento con el mismo nivel de intensidad.',
			selectEquipmentHere: 'Selecciona el equipamiento aquí.',
			equipmentWarning: {
				title: 'Mejora tu equipamiento',
				messagePart1: 'Tu equipamiento seleccionado no admite el peso que has elegido ({error}). ',
				messageLink: 'Actualiza tu equipamiento',
				messagePart2: ' para asegurar sugerencias de progresión precisas.',
				mobileMessage: 'Tu equipamiento seleccionado no admite el peso que has elegido ({error}). Actualiza tu equipamiento para asegurar sugerencias de progresión precisas.',
				button: 'Actualizar equipamiento',
			},
			equipmentFloor: {
				hintEmptyBar: 'Barra vacía · tu objetivo es {target}',
				hintLightestFixed: 'Tu peso más ligero · tu objetivo es {target}',
				hintLightestStackPlate: 'Placa más ligera de esta máquina · tu objetivo es {target}',
				hintLightestSetting: 'Ajuste más ligero · tu objetivo es {target}',
				title: '¿Por qué {floor}?',
				bodyEmptyBar: 'El peso objetivo de tu plan para este ejercicio es {target}. En una barra, el peso que introduces es el total, incluida la barra. Una barra vacía ya pesa {floor}, así que es lo más ligero que permite este equipamiento. ¿Querías {target}? Elige un equipamiento más ligero. ¿Entrenas con {floor} a propósito? No pasa nada. Tu próximo objetivo se calculará a partir de lo que registres aquí.',
				bodyOther: 'El peso objetivo de tu plan para este ejercicio es {target}. Este equipamiento no permite menos de {floor}. ¿Querías {target}? Elige un equipamiento más ligero. ¿Entrenas con {floor} a propósito? No pasa nada. Tu próximo objetivo se calculará a partir de lo que registres aquí.',
				lighterEmptyBar: 'Barra vacía · no se puede bajar más',
				lighterLightestFixed: 'Tu peso más ligero · no se puede bajar más',
				lighterLightestStackPlate: 'Placa más ligera de esta máquina · no se puede bajar más',
				lighterLightestSetting: 'Ajuste más ligero · no se puede bajar más',
				lighterBodyEmptyBar: 'Esta serie debería ser más ligera: unos {wanted}. En una barra, el peso que introduces es el total, incluida la barra. Una barra vacía ya pesa {floor}, así que es lo más ligero que permite este equipamiento. ¿La quieres más ligera? Elige un equipamiento más ligero e introduce unos {wanted}. ¿Sigues con la barra? Haz las repeticiones con {floor}.',
				lighterBodyOther: 'Esta serie debería ser más ligera: unos {wanted}. Este equipamiento no permite menos de {floor}. ¿La quieres más ligera? Elige un equipamiento más ligero e introduce unos {wanted}. ¿Sigues con este equipamiento? Haz las repeticiones con {floor}.',
				button: 'Cambiar equipo',
			},
			badges: {
				myoReps: 'Myo-reps',
				strengthTest: 'Prueba de fuerza',
				repTest: 'Prueba de repeticiones',
				myoRepsInfo: 'Método que ahorra tiempo con una serie de activación y miniseries con descanso corto.',
				strengthTestInfo: 'Encuentra el peso máximo que solo puedes levantar de 1 a 5 repeticiones. Sigue añadiendo peso de forma intuitiva hasta que solo puedas hacer de 1 a 5 repeticiones.',
				repTestInfo: 'Haz tantas repeticiones como puedas con el peso indicado. Este número se convertirá en tu objetivo de repeticiones. Este método autorregula tu volumen de entrenamiento para cada grupo muscular de forma individual, según su composición de fibras musculares, densidad capilar y otros factores que lo hacen más fuerte en ciertos rangos de repeticiones.',
				tempSwap: 'Temporal',
				tempSwapInfo: 'Este ejercicio es un reemplazo temporal solo para este entrenamiento. Tu programa de entrenamiento no se ve afectado.',
				bodyweight: 'Peso corporal',
				bodyweightInfo: 'Este ejercicio usa tu peso corporal como parte de la carga.',
			},
			superset: 'Serie combinada',
			units: {
				lb: 'Lb',
				kg: 'Kg',
			},
			firstWorkoutTestExplainer: 'Entrenamiento de prueba para personalizar tu programa',
			pendingWorkoutWarning: 'Tienes un entrenamiento sin terminar del',
			pendingWorkoutExplanation: 'Puedes volver y terminarlo o empezar este entrenamiento, lo que lo completará automáticamente.',
			workoutChangedInfo: 'Cualquier cambio en este entrenamiento se guardará cuando completes al menos una serie.',
			coachChanged: {
				title: 'Tu entrenador cambió este ejercicio.',
				detail: '{date}, {name}: {summary}',
			},
			skipRemaining: 'Omitir el resto',
			skipRemainingConfirm: '¿Seguro que quieres omitir todas las series y ejercicios restantes?',
			lastAttempt: 'Último intento, hace {days} días:',
			equipment: {
				stack: 'Placas apiladas: ',
				fixed: 'Fijo: ',
				bar: 'Barra: ',
				platesEachSide: 'Discos (a cada lado)',
				micro: 'Micro',
				plates: 'Discos',
				notConfigured: '(sin configurar)',
				automatic: 'Automático',
				inferredStep: 'incremento estimado: ~{step}',
				copiedFromOtherUnit: 'Usamos tu {name} para este ejercicio. Es la misma máquina, ahora mostrada en la unidad que elegiste.',
				chooseDifferentEquipment: 'Elegir Equipamiento',
				chooseEquipmentLabel: 'Elegir equipamiento',
			},
			setInstructions: {
				nonRMTestRetry: 'Descansa unos minutos. Consulta las [instrucciones](@help:workout.strength-test-failed) e inténtalo de nuevo.',
				nonRMTest: 'Encuentra el peso máximo que puedes levantar para el número de repeticiones sugerido. [Más información](@help:workout.strength-test)',
				rmTestRetry: 'Descansa unos minutos. Consulta las [instrucciones](@help:workout.RM-strength-test-failed) e inténtalo de nuevo.',
				rmTest: 'Encuentra tu 1-5RM. [Más información](@help:workout.RM-strength-test)',
				rmTestFollow: 'Haz tantas repeticiones como puedas con buena técnica. [Más información](@help:workout.RM-test_follow)',
				repTest: 'Encuentra tu objetivo de repeticiones para este ejercicio. [Más información](@help:workout.rep-test)',
				regular: 'Haz tantas repeticiones como puedas con el peso indicado.',
				followup: 'Haz tantas repeticiones como puedas con buena técnica.',
				dropset: 'Haz tantas repeticiones como puedas con buena técnica. [Más información](@help:workout.dropset)',
				dropsetEccentric: 'Si es posible, intenta hacer solo la fase excéntrica (el movimiento de bajada) del ejercicio, sin carga añadida, durante tantas repeticiones como puedas controlar. [Más información](@help:workout.dropset)',
				dropsetReduce: 'Reduce el peso como se indica. Haz tantas repeticiones como puedas con buena técnica. [Más información](@help:workout.dropset)',
				deload: 'Haz solo de 3 a 5 repeticiones **explosivas** con la carga reducida. [Más información](@help:workout.deload)',
				deloadAtFloor: 'Haz solo de 3 a 5 repeticiones **explosivas** con este peso. [Más información](@help:workout.deload)',
			},
			setProgress: {
				lastSession: 'Última sesión',
				lastMarker: 'última · {reps}',
				repsRangePlaceholder: '{min}–{max}',
				progressedTitle: '¡Has progresado!',
				targetHitTitle: '¡Repeticiones objetivo alcanzadas!',
				setLoggedTitle: 'Serie registrada',
				repsAtWeight: '{reps} {{repetición|repeticiones}} a {weight}',
				overLastTime: '+{count} más que la última vez',
				nextSessionAimFor: 'Próxima sesión: apunta a {reps}+.',
				lastTimeYouDid: 'La última vez hiciste {reps}.',
				lastTimeLabel: 'Última vez',
				todayLabel: 'Hoy',
				startRestTimer: 'Iniciar temporizador de descanso · {duration}',
				outcomeTargetHit: 'Objetivo alcanzado',
				lastShort: 'Anterior: {value}',
				targetLabel: 'Objetivo',
				overLastTimeShort: '+{count} {{rep|reps}} (vs. última vez)',
				editSet: 'Editar serie',
				restTimer: 'Temporizador de descanso · {duration}',
				outcomeSame: 'Igual que la última vez',
				outcomeFewer: 'Menos repeticiones',
				loggedAtLabel: 'Registrado a las',
				nextSessionLabel: 'Próxima sesión',
				repsOrMore: '{reps}+',
				targetRangeReps: '{floor}–{target} reps',
				targetReps: '{target} {{rep|reps}}',
			},
			summary: {
				title: 'Entrenamiento completado',
				setsCount: '{count} {{serie|series}}',
				minutes: '{minutes} min',
				hoursMinutes: '{hours} h {minutes} min',
				recordsPart: '{count} {{récord personal|récords personales}}',
				progressedPart: '{count} {{ejercicio progresó|ejercicios progresaron}}',
				and: 'y',
				personalRecord: 'Récord personal',
			},
			finishedExercise: {
				moreRepsVsLastTime: '+{count} {{rep|reps}} vs. última vez',
				fewerRepsVsLastTime: '−{count} {{rep|reps}} vs. última vez',
				sameAsLastTime: 'Igual que la última vez',
				lastWorkoutLine: 'Último entrenamiento: {sets}',
				nextTargetLine: 'Próximo objetivo: apunta a {reps}+ reps en la serie 1',
			},
			exerciseHeader: {
				set: 'serie',
				sets: 'series',
				skipped: 'omitido',
				highRep: 'altas repeticiones; ',
				heavy: 'pesado; ',
				medium: 'medio; ',
			},
		},
		buttons: {
			description: 'Descripción',
			instructions: 'Instrucciones',
			history: 'Historial',
			stats: 'Estadísticas',
			settings: 'Ajustes',
			skipToday: 'Omitir hoy',
			changeExercise: 'Cambiar ejercicio',
			resetProgress: 'Restablecer progreso',
			logSet: 'Registrar serie',
			completeSet: 'Completar serie',
			saveSet: 'Guardar serie',
			logShort: 'Registrar',
			saveShort: 'Guardar',
			nextDay: 'Día siguiente',
			close: 'Cerrar',
			yesAgree: 'Sí, estoy de acuerdo',
			noDisagree: 'No, no estoy de acuerdo',
			yesCorrect: 'Sí, es correcto',
			oopsLetMeChange: 'Vaya, déjame cambiarlo.',
			addNote: 'Añadir nota',
			setNote: 'Nota de la serie',
		},
		alerts: {
			youChangedWeight: '¿Cambiaste el peso?',
			weightEstimateWrong: 'Nuestra app estima la carga ideal para cada una de tus series efectivas. ¿Por qué crees que nos equivocamos?',
			agreeWithDeload: '¿Estás de acuerdo con una descarga reactiva?',
			agreeWithUpgrade: '¿Estás de acuerdo con una mejora del programa de entrenamiento?',
			skipExercise: 'Omitir ejercicio...',
			skipRemainingSets: '¿Quieres omitir el resto de las series de este ejercicio en este entrenamiento?',
			skipThisExercise: '¿Quieres omitir este ejercicio en este entrenamiento?',
			isThisCorrect: '¿Es esto correcto?',
			notesForSet: 'Notas para esta serie',
			notesForPreviousWorkouts: 'Las notas de entrenamientos anteriores están en Más > Estadísticas y notas.',
			switchType: 'Cambiar ejercicio',
			switchTypeMessage: '¿Quieres reemplazar este ejercicio de forma permanente en tu programa o solo para esta sesión?',
			thisSessionOnly: 'Solo esta sesión',
			permanently: 'Permanentemente',
			resetProgress: 'Restablecer progreso',
			resetProgressConfirm: '¿Seguro que quieres restablecer el ciclo actual de este ejercicio? Tendremos que volver a probar tu fuerza en este ejercicio. Tus récords personales anteriores se conservarán en la sección "Progreso".',
			switchExerciseResetWarning: 'Tus series completadas se quedan con este ejercicio, y el nuevo ejercicio empieza en la serie 1. ¿Quieres continuar?',
			exercisesSkipped: 'Algunos ejercicios se omitieron debido a un fallo de la aplicación.\n({exercises})',
			weightTooHeavy: 'El peso que me recomiendas es demasiado pesado.',
			weightTooLight: 'El peso que me recomiendas es demasiado ligero.',
			closestWeight: 'El peso que elegí es lo más cerca que puedo llegar de lo que me indicas usar.',
			recommendDeload: 'Se recomienda una descarga reactiva para este ejercicio. Parece que aún no te has recuperado.',
			plateau: {
				exerciseChanged: 'Cambiamos {name} a este ejercicio.',
				exerciseWillChange: 'Este ejercicio se cambiará en la próxima sesión.',
				intensityChangeTitle: '¿Estás de acuerdo con un cambio de intensidad para {name}?',
				intensityChangeMessage: 'Creemos que has alcanzado un estancamiento con la intensidad actual del ejercicio. Por eso, recomendamos volver a probarte con una intensidad diferente para asegurar una progresión óptima.',
				exerciseChangeTitle: '¿Estás de acuerdo con cambiar {name} por un ejercicio diferente?',
				exerciseChangeMessage: 'Recomendamos reemplazar este ejercicio en este momento.',
				planUpgradeMessage: '¡Enhorabuena! Tu progreso reciente indica que estás listo para asumir un programa de entrenamiento más avanzado.',
				retestThis: 'Volveremos a determinar tu objetivo de repeticiones en esta sesión.',
				retestNext: 'Volveremos a determinar tu objetivo de repeticiones en la próxima sesión.',
				switchToTUPThis: 'El ejercicio cambiará a periodización ondulante triple en esta sesión.',
				switchToTUPNext: 'El ejercicio cambiará a periodización ondulante triple en la próxima sesión.',
				switchToDUPThis: 'El ejercicio cambiará a periodización ondulante doble en esta sesión.',
				switchToDUPNext: 'El ejercicio cambiará a periodización ondulante doble en la próxima sesión.',
				planUpgradeConfirm: 'Mejoraremos tu programa de entrenamiento a un nivel más avanzado después de esta sesión.',
			},
			repCeiling: {
				title: 'Has llegado a 30 repeticiones',
				switchMessage: 'Hacer más de 30 repeticiones ya no ayuda mucho a ganar músculo, y el siguiente peso de tu equipamiento es un salto demasiado grande. ¿Cambiamos a otro ejercicio a partir del próximo entrenamiento?',
				yes: 'Sí',
				noKeep: 'No, mantener 30 repeticiones',
			},
			unusualSet: '{setStatText} para {exerciseName} parece inusual en comparación con tus registros anteriores.',
			unusualSetRepTest: '{setStatText} para la prueba de repeticiones de {exerciseName} parece inusual en comparación con tus registros anteriores.',
			viewOnly: {
				futureWorkoutMessage: 'Este entrenamiento está programado para una fecha futura. Completa y registra los entrenamientos en su día planificado, idealmente en el gimnasio.',
				previousWorkoutMessage: 'Este es un entrenamiento anterior. Puedes hacer correcciones si quieres.',
				templateMessage: 'Esta es una plantilla de entrenamiento de tu plan. Verás el entrenamiento concreto con más detalles en su día programado. Puedes cambiar ejercicios con antelación aquí si lo necesitas.',
				loggingMessage: 'Deberías registrar el entrenamiento mientras estás en el gimnasio. Así podemos darte la mejor orientación posible en cada serie siguiente.',
			},
		},
		status: {
			exerciseNotOptimal: 'Este ejercicio no es óptimo para ti en este momento y se reemplazará en el próximo entrenamiento.',
			goodJobProgression: '¡Buen trabajo! Ahora podemos guiar tu progresión desde aquí.',
			strengthLevelCalculated: '¡Buen trabajo! Nivel de fuerza calculado.',
			strengthCalculatedLighterSets: '¡Buen trabajo! Nivel de fuerza calculado. El resto de las series son más ligeras para evaluar tu fuerza-resistencia.',
			tooManyRepsRetry: 'Descansa unos minutos y usa un peso más pesado para acercarte al objetivo de repeticiones.',
			tooManyRepsNextWorkout: 'Volveremos a intentarlo en un próximo entrenamiento con un peso más pesado para acercarnos al objetivo de repeticiones.',
			tooFewRepsRetry: 'Descansa unos minutos y usa un peso más ligero para acercarte al objetivo de repeticiones.',
			tooFewRepsNextWorkout: 'Volveremos a intentarlo en un próximo entrenamiento con un peso más ligero para acercarnos al objetivo de repeticiones.',
			repRangeEstablished: '¡Excelente! Hemos establecido tu rango de repeticiones objetivo.',
			repRangeEstablishedContinue: '¡Excelente! Hemos establecido tu rango de repeticiones objetivo. En las siguientes series no tienes que igualarlo. Solo haz tantas repeticiones como puedas.',
			strengthRetestNextTooHeavy: 'Como indicaste que la carga sugerida es demasiado pesada para ti, la próxima vez te dejaremos volver a probar tu fuerza con un método diferente. Revisa las instrucciones de la prueba. Por hoy, puedes seguir usando el peso que has elegido.',
			strengthRetestNextTooLight: 'Como indicaste que la carga sugerida es demasiado ligera para ti, la próxima vez te dejaremos volver a probar tu fuerza con un método diferente. Revisa las instrucciones de la prueba. Por hoy, puedes seguir usando el peso que has elegido.',
			differentWeightEquipment: 'Como elegiste un peso diferente al sugerido, considera actualizar el equipamiento de este ejercicio para que podamos acertar la próxima vez.',
			progressionDeload: 'No alcanzaste la progresión planificada. Aplicando descarga...',
			progressionDeloadLastSet: 'No alcanzaste la progresión planificada. Tu peso objetivo bajará un escalón en el próximo entrenamiento.',
			repTargetUpdatedRegular: 'Hemos actualizado el objetivo de repeticiones de este ejercicio según tu progreso actual.',
			repTargetUpdatedHighRep: 'Hemos actualizado el objetivo de repeticiones de la sesión de altas repeticiones de este ejercicio según tu progreso actual.',
			repTargetUpdatedHeavy: 'Hemos actualizado el objetivo de repeticiones de la sesión pesada de este ejercicio según tu progreso actual.',
			lastSetNotNeeded: 'La última serie no es necesaria. Se omite.',
			lowerThanRecommended: 'Este peso es inferior al peso recomendado de {plannedWeight}. Si has cambiado de gimnasio o equipamiento, puedes actualizar el equipamiento para que sepamos qué tienes disponible.',
			immediateProgression: '¡Lo estás haciendo genial! Aumentemos el peso de inmediato y veamos si puedes alcanzar el objetivo de repeticiones con eso.',
			immediateProgressionReps: '¡Lo estás haciendo genial! Aumentemos el objetivo de repeticiones y veamos si puedes alcanzarlo con este peso.',
			maxedOutEquipment: 'Parece que ya no podemos aumentar tu peso objetivo con este equipamiento, así que la próxima vez cambiaremos a otro ejercicio. Si en realidad puedes añadir más peso, actualiza el equipamiento que tienes disponible.',
			plateauResolved: 'Has alcanzado un estancamiento. {message}',
			plateauDetected: 'Tu progreso se ha estancado en este peso durante más de una sesión.',
			plateauDismissed: 'Estancamiento descartado por el usuario.',
			volumeAutoregulationIncrease: 'Autorregulación de volumen aplicada. Tu volumen de entrenamiento aumentará en 1 serie en el próximo entrenamiento según tu índice de fatiga.',
			volumeAutoregulationDecrease: 'Autorregulación de volumen aplicada. Tu volumen de entrenamiento disminuirá en 1 serie en el próximo entrenamiento según tu índice de fatiga.',
			volumeAutoregulationPending: 'Según tu rendimiento, recomendamos ajustar tu volumen de series.',
			strengthTestFollowupDone: '¡Buena serie! Tu prueba de fuerza ya actualizó tu progresión en este ejercicio, así que mantén este peso durante el resto de hoy.',
			repCeilingSwitch: 'Has llegado a 30 repeticiones y el siguiente peso es un salto demasiado grande, así que la próxima vez cambiaremos a otro ejercicio.',
			repCeilingSwitchSameEquipment: 'Has llegado a 30 repeticiones y el siguiente peso es un salto demasiado grande, así que la próxima vez cambiaremos a otro ejercicio. Todas las alternativas a este ejercicio usan el mismo equipamiento, así que plantéate añadir incrementos de peso más pequeños en los ajustes de tu equipamiento.',
			repCeilingHeld: 'Has llegado a 30 repeticiones. Tu objetivo de repeticiones se queda en 30 y te lo volveremos a preguntar la próxima vez.',
			dropSet: '¡Dropset! Reduce el peso para las siguientes series.',
			dropSetAtFloor: '¡Dropset! Este equipamiento no permite bajar más, así que mantén este peso para las siguientes series.',
			completeProgressionReset: 'Para completar el restablecimiento, realiza la prueba de fuerza ahora. Si sales del entrenamiento sin registrar nada de la prueba de fuerza, el restablecimiento se cancelará y volverás a los valores anteriores.',
			adjustedTargetWeight: 'Parece que no realizaste este ejercicio durante más de una semana. Por eso, ajustaremos tu peso objetivo en consecuencia.',
			adjustedTargetReps: 'Parece que no realizaste este ejercicio durante más de una semana. Por eso, ajustaremos tu objetivo de repeticiones en consecuencia.',
			cappedToRecentPerformance: 'Según tus últimas series, el peso planeado parecía demasiado alto para tantas repeticiones. Lo hemos reducido para ajustarlo a lo que puedes hacer ahora mismo.',
			deloadedTargetWeight: 'Tu peso objetivo es un escalón más bajo por tu última descarga. Esta es una serie efectiva normal: apunta a tu objetivo de repeticiones.',
			retestRequired: 'Parece que no realizaste este ejercicio durante algunas semanas. Por eso, necesitamos que vuelvas a probar este ejercicio.',
		},
		instructions: {
			fillInReps: 'Introduce el número de repeticiones de la serie.',
			fillInWeight: 'Introduce el peso que levantaste.',
			fillInWeightAndReps: 'Introduce el peso que levantaste y el número de repeticiones de la serie.',
		},
		errors: {
			unableToLoad: 'No se puede cargar el entrenamiento',
			unableToLoadMessage: 'El entrenamiento no se puede cargar en este momento, lo sentimos. Inténtalo de nuevo. Si el problema persiste, contacta con soporte.',
		},
	},
	foods: {
		title: 'Alimentos',
		addFoods: 'Añadir alimentos',
		searchPlaceholder: 'Buscar...',
		filtersAndSettings: 'Filtros y ajustes',
		showFoodValuesBy: 'MOSTRAR VALORES DE ALIMENTOS POR',
		servingSize: 'Tamaño de la porción',
		per100g: '100 g',
		filters: {
			all: 'Todos',
			foods: 'Alimentos',
			recipes: 'Recetas',
			meals: 'Comidas',
			favorites: 'Favoritos',
			myFoods: 'Mis alimentos',
			loggedBefore: 'Registrado antes',
			hideUnverified: 'Ocultar no verificados',
			hideUnverifiedHint: 'Oculta los alimentos añadidos por otros miembros y por Open Food Facts',
			type: 'Tipo',
			showOnly: 'Mostrar solo',
			source: 'Origen',
			removeFilter: 'Quitar {filter}',
			reset: 'Restablecer',
		},
		buttons: {
			createRecipe: 'Crear receta',
			createFood: 'Crear alimento',
			addMacros: 'Añadir macros',
			new: 'Nuevo',
			filters: 'Filtros',
			retrySearch: 'Reintentar',
			clearFilters: 'Quitar Filtros',
			searchCorrection: 'Buscar {phrase}',
			searchTypedInstead: 'Buscar {phrase} en cambio',
			removeFromHistory: 'Quitar del historial',
		},
		badges: {
			recipe: 'Receta',
			meal: 'Comida',
			locked: 'Bloqueado',
			usedBefore: 'Registrado antes',
			liked: 'Me gusta',
			disliked: 'No me gusta',
			community: 'Comunidad',
			openFoodFacts: 'Open Food Facts',
			staple: 'Alimento Básico',
			noNutritionData: 'Sin datos nutricionales',
			checkValues: 'Revisar datos',
			checkValuesInfo: 'Las calorías indicadas para este alimento no coinciden con su proteína, grasa y carbohidratos, que dan unas {expectedCalories} kcal por 100 g. Puede que este registro esté mal.',
		},
		messages: {
			useSearchBar: 'Usa la barra de búsqueda de arriba para encontrar alimentos.',
			removedFromHistory: 'Quitado de tus alimentos recientes.',
			nothingMatchesFilters: 'Ningún alimento coincide con tus filtros.',
			clearFiltersOrSearch: 'Quita los filtros o usa la barra de búsqueda de arriba para encontrar alimentos.',
			clearFiltersOrCreate: 'Quita los filtros o usa el botón + Nuevo para crear un nuevo alimento o receta.',
			noFoodByBarcode: 'No se encontró ningún alimento para ese código de barras. Usa el botón de abajo para crearlo.',
			noFoodByBarcodeScanLabel: 'No se encontró ningún alimento para ese código de barras.',
			noFoodByBarcodeScanLabelHint: 'Haz unas fotos del envase y crearemos un nuevo alimento para ti.',
			notFoundWhat: '¿No encuentras lo que buscas?',
			searchConnectionTitle: 'No se pudieron cargar los resultados',
			searchConnectionHint: 'Parece que hay un problema de conexión. Revisa tu internet e inténtalo de nuevo.',
			offlineShowingLocalFoods: 'No tienes conexión, así que no podemos buscar en la base de datos de alimentos. Mostramos los alimentos básicos y los alimentos que has comido recientemente, ambos guardados en este dispositivo.',
			searchUnreachableShowingLocalFoods: 'No pudimos conectar con la base de datos de alimentos. Mostramos los alimentos básicos y los alimentos que has comido recientemente, ambos guardados en este dispositivo.',
			offlineShowingLocalFoodsBarcode: 'No tienes conexión, así que no podemos buscar en la base de datos de alimentos. Mostramos solo los alimentos que has comido recientemente, guardados en este dispositivo.',
			searchUnreachableShowingLocalFoodsBarcode: 'No pudimos conectar con la base de datos de alimentos. Mostramos solo los alimentos que has comido recientemente, guardados en este dispositivo.',
			searchFailedTitle: 'No se pudieron cargar los alimentos',
			searchFailedHint: 'Algo salió mal al cargar tus alimentos. Inténtalo de nuevo.',
			wrongFoodScanLabel: '¿No es el alimento correcto?',
			wrongFoodScanLabelHint: 'Haz unas fotos del envase y crearemos un nuevo alimento para ti.',
			useButtonsBelow: 'Usa el botón + Nuevo para crear un nuevo alimento o receta.',
			copiedToClipboard: 'Copiado al portapapeles',
			didYouMeanLabel: 'Quizás quisiste decir:',
			showingResultsForLabel: 'Estos son los resultados de',
			searchInsteadForLabel: 'Buscar en cambio',
		},
		suggestions: {
			listLabel: 'Búsquedas sugeridas',
			loading: 'Buscando sugerencias',
			rowLabel: '{phrase}, {count} {{alimento|alimentos}}',
			stapleRowLabel: '{name}, alimento básico',
		},
	},
	nutrition: {
		labels: {
			nutrient: 'Nutriente',
			target: 'Objetivo',
			actual: 'Real',
		},
		targets: {
			remaining: 'Restante',
			logged: 'Registrado',
		},
		macrosLogged: 'Macros registradas',
		macrosRemaining: 'Macros restantes',
		nutritionInfo: 'Información nutricional',
		flexibleNutritionLink: 'Nutrición flexible',
		calorieCyclingLink: 'Ciclado de calorías',
		settings: {
			meals: 'Comidas',
		},
		planMyWeek: 'Planificar mi semana',
		charts: {
			loggedCalories: 'Calorías registradas',
			targetCalories: 'Calorías objetivo',
		},
		enabledForMealsBoth: 'están activados para tus comidas.',
		enabledForMeals: 'está activado para tus comidas.',
	},
	errors: {
		userFacing: {
			authFailed: 'No se pudo iniciar sesión al volver a estar en línea. Seguirás sin conexión.',
			foodNotExist: 'El alimento no existe',
			foodLoadFailedTitle: 'No se pudo cargar el alimento',
			foodLoadFailed: 'No se pudo cargar este alimento ahora mismo. Revisa tu conexión e inténtalo de nuevo.',
			foodDeleteFailed: 'No se pudo eliminar este alimento. Inténtalo de nuevo.',
			ingredientListLoadFailed: 'No se pudieron cargar todos los alimentos de esta comida. Revisa tu conexión e inténtalo de nuevo.',
			noMealOnDayTitle: 'Sin comida a la que añadir',
			noMealOnDay: 'No hay ninguna comida en este día a la que puedas añadir el alimento. Elige otro día.',
			splitIntoFoodsFailed: 'No se pudo dividir esto en alimentos. Puede que uno de sus ingredientes ya no esté disponible. Inténtalo de nuevo.',
			splitTuningFailed: 'Tus alimentos se han dividido, pero el ajuste automático ha tenido un problema y no ha podido ajustar sus cantidades. Ajústalas tú mismo o inténtalo de nuevo.',
			confirmRecentMealFailed: 'No se han podido añadir los alimentos de esta comida. Inténtalo de nuevo.',
			recentMealCouldNotBeOpened: 'No se pudo abrir esta comida, así que no se añadió nada. Puede que se haya eliminado o que aún no haya terminado de sincronizarse. Inténtalo de nuevo.',
			couldNotOpenPage: 'No se pudo abrir esto. Puede que se haya eliminado o que no esté disponible en este momento.',
			couldNotLeavePage: 'No se pudo cerrar esta pantalla. Vuelve a intentarlo.',
			exportFailed: 'No se pudo exportar el archivo. Vuelve a intentarlo.',
			unsupportedBrowser: 'Puede que tu navegador no sea totalmente compatible',
			noticeUnusual: '¿Notas algo extraño?',
			communityAuthFailed: 'No se puede autenticar el acceso a la comunidad',
			equipmentCannotBeUsed: 'Este equipamiento no se puede usar',
			unsubscribeFailed: 'No se pudo cancelar la suscripción',
			paymentPending: 'Tu pago está pendiente de verificación, pero puedes seguir usando la app',
			resubscribeFailed: 'No se pudo volver a suscribir',
			planSwitchFailed: 'No se puede cambiar el plan',
			sendLoginEmailFailed: 'No se pudo enviar el correo de inicio de sesión. Ponte en contacto con soporte.',
			updateWorkoutFailed: 'No se pudo actualizar tu entrenamiento. Inténtalo de nuevo.',
			paddlePortalFailed: 'No se pudo abrir el portal de suscripción. Inténtalo de nuevo.',
			imageReadFailed: 'No se pudo leer la imagen seleccionada.',
			imageDecodeFailed: 'No se pudo cargar la imagen seleccionada.',
			imageTooSmall: 'La imagen seleccionada es demasiado pequeña. El tamaño mínimo es de {minSize} px.',
			imageUploadFailed: 'No se pudo subir la imagen. Revisa tu conexión e inténtalo de nuevo.',
		},
		syncRetry: {
			retrying: 'Conectando con tus datos… un momento…',
			stillRetrying: 'Seguimos en ello… ¡aguanta un poco!',
		},
	},
	auth: {
		login: 'Iniciar sesión',
		signup: 'Registrarse',
		forgotPassword: 'Olvidé mi contraseña',
		email: 'Correo electrónico',
		enterYourEmail: 'Introduce tu correo electrónico',
		password: 'Contraseña',
		enterYourPassword: 'Introduce tu contraseña',
		signInReadyTapAgain: 'El inicio de sesión ya está listo. Vuelve a tocar el botón.',
		enterYourName: 'Introduce tu nombre',
		chooseYourPassword: 'Elige tu contraseña',
		loginToAccount: 'Inicia sesión en tu cuenta',
		welcomeToMhPhysique: 'Te damos la bienvenida a MH Physique',
		dontHaveAccountYet: '¿Aún no tienes cuenta?',
		dontHaveAccount: '¿No tienes cuenta?',
		dontHaveAccountButton: '¿No tienes cuenta?',
		learnMore: 'Más información',
		processing: 'Procesando',
		loginWithLink: 'Obtener el enlace',
		signInByEmail: 'Envíame un enlace de acceso por correo',
		signInWithPassword: 'Iniciar sesión con contraseña',
		createAccount: 'Crear una cuenta',
		alreadyHaveAccount: '¿Ya tienes cuenta?',
		signUpWithEmail: 'Registrarse con correo electrónico',
		orSignUpWith: 'O regístrate con',
		or: 'O',
		signIn: 'Iniciar sesión',
		signInWithGoogle: 'Iniciar sesión con Google',
		signInWithApple: 'Iniciar sesión con Apple',
		google: 'Google',
		apple: 'Apple',
		firstLastName: 'Nombre y apellidos',
		choosePassword: 'Elige una contraseña',
		subscriptionSuccess: '¡Suscripción realizada!',
		subscriptionSuccessCheckEmail: 'Enviamos un enlace de acceso al correo que usaste durante el pago. Revisa tu bandeja de entrada para empezar.',
		emailLinkSent: 'Enlace enviado por correo',
		emailLinkSentMessage: 'Te enviamos un correo con un enlace de acceso. Si no lo ves pronto, revisa tu carpeta de spam.',
		emailLinkContact: 'Si no está ahí, ponte en contacto con',
		bySigningIn: 'Al iniciar sesión, aceptas los de MH Physique',
		bySubscribing: 'Al suscribirte, aceptas los de MH Physique',
		termsAndConditions: 'Términos y condiciones',
		and: 'y',
		privacyPolicy: 'Política de privacidad',
		pricing: 'Precios',
		refunds: 'Reembolsos',
		eula: 'EULA',
		claim: {
			alreadyHaveAccount: 'Ya tengo una cuenta',
			newToMhPhysique: 'Soy nuevo aquí',
			createAccount: 'Crear cuenta',
		},
		switchAccount: {
			title: 'Cambiar de cuenta',
			message: 'Has iniciado sesión como {currentEmail}. ¿Quieres cambiar a {newEmail} para acceder a tu suscripción?',
			switchButton: 'Cambiar',
			expiredTitle: 'Enlace caducado',
			expiredMessage: 'Tu enlace de acceso ha caducado. Hemos enviado uno nuevo a {email}.',
			expiredResendFailedMessage: 'Tu enlace de acceso ha caducado y no hemos podido enviar uno nuevo a {email} en este momento. Comprueba tu conexión e inténtalo de nuevo.',
			unfinishedTitle: 'Cambio no completado',
			unfinishedMessage: 'El cambio a {newEmail} está tardando demasiado, así que sigues con la sesión iniciada en tu cuenta actual. Si el cambio se completa, la app se reiniciará. Si no, vuelve a abrir el enlace.',
		},
		errors: {
			otlExpired: 'El enlace de un solo uso ha caducado. Introduce tu correo electrónico para recibir uno nuevo.',
			otlRecent: 'Revisa tu bandeja de entrada. Te enviamos hace poco un enlace para iniciar sesión. ¿No lo encuentras? Podemos enviarte otro.',
			otlAmbiguousAccount: 'No hemos podido enviarte el enlace para iniciar sesión, porque hay más de una cuenta con esta dirección de correo electrónico y no podemos saber cuál es la tuya. Ponte en contacto con nosotros en {email} y lo resolveremos.',
			signInTokenCheck: 'Error al comprobar el token de inicio de sesión. Inténtalo de nuevo o usa otro método.',
			useAlternativeTitle: '¿Usar {provider}?',
			useAlternativeMessage: 'Esta cuenta ya está registrada con el inicio de sesión de {provider}. ¿Quieres usar {provider} para iniciar sesión?',
			badEmailFormat: 'El formato del correo electrónico no es válido.',
			passwordResetSent: 'Revisa tu bandeja de entrada para ver las instrucciones de restablecimiento de contraseña. Luego vuelve aquí para iniciar sesión.',
			popupClosed: 'Se cerró la ventana emergente. Inténtalo de nuevo.',
			firebase: {
				invalidEmail: 'Introduce una dirección de correo electrónico válida.',
				missingEmail: 'Introduce tu dirección de correo electrónico.',
				userNotFound: 'No se encontró ninguna cuenta con este correo. Revisa tu correo o crea una cuenta nueva.',
				emailAlreadyInUse: 'Ya existe una cuenta con este correo. Inicia sesión, o usa «Olvidé mi contraseña» si no la recuerdas.',
				accountExistsWithDifferentCredential: 'Ya existe una cuenta con este correo, pero usa otro método de inicio de sesión. Inicia sesión como lo hiciste la otra vez, por ejemplo con tu correo y contraseña.',
				wrongPassword: 'Contraseña incorrecta. Inténtalo de nuevo.',
				invalidCredential: 'Correo o contraseña incorrectos. Inténtalo de nuevo.',
				weakPassword: 'Tu contraseña es demasiado débil. Elige una más segura.',
				tooManyRequests: 'Demasiados intentos. Espera unos minutos e inténtalo de nuevo.',
				networkRequestFailed: 'No se pudo conectar. Revisa tu conexión a internet e inténtalo de nuevo.',
				userDisabled: 'Esta cuenta ha sido desactivada. Ponte en contacto con soporte en {email} para recibir ayuda.',
				operationNotAllowed: 'Este método de inicio de sesión no está disponible ahora mismo. Prueba con otro método.',
				popupBlocked: 'Tu navegador bloqueó la ventana emergente de inicio de sesión. Permite las ventanas emergentes para este sitio e inténtalo de nuevo.',
				requiresRecentLogin: 'Por motivos de seguridad, vuelve a iniciar sesión.',
				invalidActionCode: 'Este enlace no es válido o ya se ha usado.',
				expiredActionCode: 'Este enlace ha caducado. Solicita uno nuevo.',
				genericError: 'Algo salió mal. Inténtalo de nuevo o ponte en contacto con soporte en {email}.',
			},
		},
		newAccountMade: {
			title: 'Cuenta nueva creada',
			message: 'Al iniciar sesión de esta forma se ha creado una cuenta totalmente nueva, por lo que está vacía. Si ya te suscribiste con otra dirección de correo, introdúcela y te enviaremos un enlace de acceso.',
			placeholder: 'tu@ejemplo.com',
			continueAsNew: 'Soy nuevo aquí',
			findMyAccount: 'Buscar mi cuenta',
			checking: 'Comprobando esa dirección...',
			linkSent: 'Hemos enviado un enlace de acceso a {email}. Ábrelo en este dispositivo para volver a tu cuenta.',
			sameAccount: 'Esa es la dirección de la cuenta nueva en la que ya has iniciado sesión. Si te suscribiste con otra dirección, prueba con esa.',
			noAccount: 'No hemos encontrado ninguna cuenta con esa dirección de correo. Revisa cómo está escrita o continúa con la cuenta nueva que acabas de crear.',
			severalAccounts: 'Varias cuentas usan esa dirección de correo, así que no podemos saber cuál es la tuya. Ponte en contacto con soporte y lo resolveremos por ti.',
			couldNotCheck: 'No hemos podido comprobar esa dirección de correo en este momento. Revisa tu conexión e inténtalo de nuevo.',
			couldNotSend: 'No hemos podido enviar el enlace de acceso en este momento. Revisa tu conexión e inténtalo de nuevo.',
		},
		accountHint: {
			title: 'Otra cuenta',
			message: 'El enlace que has abierto se envió a {hintEmail}, pero has iniciado sesión como {currentEmail}. ¿Quieres que enviemos un enlace de acceso a {hintEmail}?',
			stayButton: 'Seguir con esta cuenta',
			sendButton: 'Enviar enlace',
			sending: 'Enviando el enlace de acceso...',
		},
	},
	settings: {
		sections: {
			training: 'Entrenamiento',
			nutrition: 'Nutrición',
			general: 'General',
			support: 'Soporte',
			regional: 'Preferencias regionales y de visualización',
			accessibility: 'Accesibilidad',
			experimental: 'Experimental',
		},
		intakePendingCard: {
			title: 'Termina de configurar tu perfil',
			body: 'La mayoría de las opciones de aquí ajustan tu plan de fitness, así que estarán listas una vez que se haya generado.',
			linkText: 'Continuar el cuestionario',
		},
		items: {
			trainingSettings: 'Ajustes de entrenamiento',
			workouts: 'Entrenamientos',
			editEquipment: 'Editar equipamiento',
			nutritionSettings: 'Ajustes de nutrición',
			mealPlanner: 'Planificador de comidas',
			foods: 'Alimentos',
			appSettings: 'Ajustes de la app',
			manageSubscription: 'Gestionar suscripción',
			coaching: 'Coaching',
			privacyChoices: 'Opciones de privacidad',
			admin: 'Administración',
			help: 'Ayuda',
			feedback: 'Comentarios',
			messageCoach: 'Enviar mensaje al entrenador',
			community: 'Comunidad',
			whatsNew: 'Novedades',
			rateTheApp: 'Valorar la app',
		},
		installApp: 'Instalar la app',
		language: 'Idioma',
		applyingLanguage: 'Aplicando el idioma…',
		downloadingLanguage: 'Descargando idioma…',
		languageDownloadFailed: {
			title: 'No se pudo cambiar el idioma',
			message: 'No pudimos descargar {language} para usarlo sin conexión. Comprueba tu conexión a internet e inténtalo de nuevo.',
		},
		clockMode: 'Formato de hora',
		hour24: '24 h',
		ampm: 'AM/PM',
		automatic: 'Automático',
		decimalSeparator: 'Separador decimal',
		point: 'Punto (.)',
		comma: 'Coma (,)',
		dateFormat: 'Formato de fecha',
		firstDayOfWeek: 'Primer día de la semana',
		monday: 'Lunes',
		saturday: 'Sábado',
		sunday: 'Domingo',
		nutritionLabelStyle: 'Estilo de etiqueta nutricional',
		foods: {
			uncaching: 'Vaciando la caché de alimentos...',
		},
		allowCardAnimations: 'Permitir animaciones de las tarjetas',
		headerHideBehavior: 'Ocultar cabecera al desplazar',
		footerHideBehavior: 'Ocultar pie al desplazar',
		scrollHide: {
			always: 'Siempre',
			never: 'Nunca',
		},
		descriptions: {
			language: 'Elige el idioma de la interfaz de la app. Cualquier texto que aún no esté traducido aparecerá en inglés.',
			clockMode: 'Hemos detectado {mode} como el formato de hora más probable según tu país actual. Si no coincide con tus preferencias, configura aquí una anulación manual.',
			dateFormat: 'Elige cómo se muestran las fechas en toda la app. El modo automático usa la configuración regional detectada según tu país actual.',
			firstDayOfWeek: 'Elige qué día aparece primero en las vistas semanales. El modo automático usa la configuración regional detectada según tu país actual.',
			decimalSeparator: 'Elige qué símbolo se usa para los decimales (p. ej., «.» o «,»). Según tu configuración regional.',
			nutritionLabelStyle: 'Las etiquetas de estilo estadounidense muestran los carbohidratos totales con la fibra incluida. Las de estilo europeo muestran los carbohidratos netos sin la fibra.\n\nEsto solo se aplica al editar un alimento individual. En el resto de la app siempre mostramos los carbohidratos netos (sin fibra), porque tiene más sentido a nivel metabólico.',
			cardAnimations: 'Desactiva las animaciones si el movimiento te molesta o si tu dispositivo no las gestiona bien.',
			headerHideBehavior: 'Controla si la cabecera se oculta al desplazar hacia abajo. «Auto» solo oculta las cabeceras con calendarios.',
			footerHideBehavior: 'Controla si la navegación inferior se oculta al desplazar hacia abajo. «Auto» solo oculta la barra de navegación principal.',
			showSlotName: 'Muestra el nombre del grupo muscular (nombre del hueco) debajo de los nombres de los ejercicios en las vistas de entrenamiento y la configuración de ejercicios.',
		},
		notifications: {
			sectionTitle: 'Notificaciones',
			description: 'Recibe recordatorios de las actividades programadas. Las notificaciones se envían 10 minutos antes de la hora programada.',
			workout: 'Entrenamientos',
			workoutDescription: 'Antes de cada entrenamiento programado',
			meals: 'Comidas',
			mealsDescription: 'Antes de cada comida programada',
			weighIn: 'Pesajes',
			weighInDescription: 'En tus días de pesaje programados',
			weeklyCheckup: 'Revisión semanal',
			weeklyCheckupDescription: 'Cuando toca tu revisión semanal',
			sleep: 'Sueño',
			sleepDescription: 'Antes de la hora que tienes programada para relajarte',
			deviceSettings: 'Ajustes de notificaciones del dispositivo',
			deviceSettingsDescription: 'Gestiona los permisos de notificación en los ajustes de tu dispositivo',
			content: {
				workout: 'Hora de entrenar',
				meal: 'Hora de comer',
				weighIn: 'Hora de pesarte',
				weeklyCheckup: 'Hora de tu revisión semanal',
				sleep: 'Hora de relajarte',
			},
		},
		testSettings: {
			header: 'Ajustes de prueba',
			testMode: 'Modo de prueba',
			locale: 'Configuración regional',
			localeDecimalSeparator: 'Separador decimal regional',
			unitSettings: 'Ajustes de unidades',
			hintsSeen: 'Pistas vistas',
			helpSeen: 'Ayuda vista',
			dismissedToasts: 'Avisos descartados',
			showAllHints: 'Mostrar siempre todas las pistas',
			showAllTutorials: 'Mostrar siempre todos los tutoriales',
			debugFoodSearch: 'Depurar búsqueda de alimentos',
			debugRestTimerOnWeb: 'Mostrar temporizador de descanso en la web (depuración)',
			debugLog: 'Registro de depuración',
			debugLogPlaceholder: 'No hay ningún registro',
			clearLog: 'Borrar registro',
			accountDatabase: 'Base de datos de la cuenta',
			cachedFoods: 'Alimentos en caché actualmente: {count}',
			uncacheFoodsNote: 'Para cualquier alimento de userdb que exista en globaldb, elimina el elemento de userdb (provocará que se vuelva a guardar en caché la próxima vez que se use).',
			testSurveyNote: 'Esto mostrará la encuesta llamada «Encuesta de prueba».',
			testNotificationNote: 'Envía una notificación push a todos los dispositivos móviles con sesión iniciada en esta cuenta. Llega en el plazo de un minuto.',
			testNotification: 'Probar notificación push',
			resetHiddenMessagesNote: 'Vuelve a mostrar todos los mensajes que ocultaste al tocar «No mostrar nunca más». Sin esto no hay forma de deshacerlo.',
			resetHiddenMessages: 'Restablecer mensajes ocultos',
			hiddenMessagesRestored: '{count} mensaje{{|s}} oculto{{|s}} se volverá{{|n}} a mostrar.',
			noHiddenMessages: 'No has ocultado ningún mensaje.',
		},
		experimental: {
			showSlotName: 'Mostrar nombre del hueco',
		},
	},
	dbSnapshots: {
		title: 'Copias de la base de datos',
		createSnapshot: 'Crear copia',
		rename: 'Cambiar nombre',
		download: 'Descargar',
		noSnapshots: 'Aún no hay copias. Crea una para guardar el estado actual de la base de datos.',
		renameTitle: 'Cambiar nombre de la copia',
		renamePlaceholder: 'Nombre de la copia',
		deleteConfirmTitle: '¿Eliminar la copia?',
		deleteConfirmMessage: 'Esto eliminará permanentemente la copia «{name}».',
		creating: 'Creando copia...',
		snapshotInfo: '{date} · {count} docs',
		restore: 'Restaurar',
		restoreConfirmTitle: '¿Restaurar la copia?',
		restoreConfirmMessage: 'Esto reemplazará todos los datos actuales con la copia «{name}». No se puede deshacer.',
		restoring: 'Restaurando copia...',
		restoreComplete: 'La copia «{name}» se ha restaurado correctamente.',
		restoreFailed: 'No se pudo restaurar la copia. La conexión se cortó a mitad del proceso, así que tus datos pueden ser una mezcla de documentos antiguos y restaurados hasta que termine la sincronización. La aplicación se recargará ahora. Comprueba tu conexión e inténtalo de nuevo.',
		restoreFailedTitle: 'Error al restaurar',
		restoreCleanupFailed: 'La copia se restauró en el servidor, pero no se pudo borrar la copia local antigua de este dispositivo. NO sigas usando la aplicación en este dispositivo todavía: borra el almacenamiento de la aplicación (o reinstálala) y ábrela de nuevo, para que los datos restaurados se descarguen desde cero.',
	},
	dbRestoreJson: {
		title: 'Restaurar base de datos desde JSON',
		description: 'Sube un archivo JSON o pega datos JSON para restaurar la base de datos de un usuario.',
		chooseFile: 'Elegir archivo JSON',
		orPaste: 'O pega JSON',
		pasteHint: 'Pega un array de documentos como JSON',
		parseJson: 'Analizar JSON',
		restore: 'Restaurar',
		restoring: 'Restaurando base de datos...',
		invalidJson: 'JSON no válido. Debe ser un array de documentos, cada uno con un campo _id.',
		confirmTitle: '¿Restaurar la base de datos?',
		confirmMessage: 'Esto reemplazará todos los datos actuales del usuario con {count} documentos. No se puede deshacer.',
		fileLoaded: 'Se cargaron {count} documentos del archivo.',
		restoreCompleteTitle: 'Base de datos restaurada',
		restoreCompleteMessage: 'La base de datos se ha restaurado desde JSON ({count} documentos).',
		restoreFailed: 'No se pudo restaurar la base de datos. La conexión se cortó a mitad del proceso, así que tus datos pueden ser una mezcla de documentos antiguos y restaurados hasta que termine la sincronización. La aplicación se recargará ahora. Comprueba tu conexión e inténtalo de nuevo.',
		restoreFailedTitle: 'Error al restaurar',
		restoreCleanupFailed: 'Tus datos se restauraron en el servidor, pero no se pudo borrar la copia local antigua de este dispositivo. NO sigas usando la aplicación en este dispositivo todavía: borra el almacenamiento de la aplicación (o reinstálala) y ábrela de nuevo, para que los datos restaurados se descarguen desde cero.',
	},
	debug: {
		nextDay: 'Día siguiente',
		more: 'Más...',
	},
	app: {
		title: 'MH Physique',
		updated: 'Actualizado a {version}',
		whatsNew: '¿Qué hay de nuevo?',
		updateAvailable: {
			message: 'Hay una nueva versión disponible.',
			action: 'Actualizar',
			downloading: 'Descargando actualización…',
			ready: 'Actualización descargada.',
			restart: 'Reiniciar',
			upToDate: 'Estás al día',
			settingsRow: 'Buscar actualizaciones',
		},
		updateRequired: {
			title: 'Actualiza la app',
			message: 'Esta versión de la app ya no tiene soporte. Actualiza ahora para seguir recibiendo correcciones y funciones nuevas.',
			update: 'Actualizar',
			later: 'Más tarde',
			cardMessage: 'Esta versión ya no tiene soporte. Actualiza la app.',
		},
		starting: 'Iniciando...',
		loading: 'Cargando...',
		databaseRecoveryLoading: 'Restaurando tus datos...',
		downloadingExistingData: 'Descargando datos existentes...',
		openingCommunity: 'Abriendo la Comunidad, espera...',
		communityOffline: 'La comunidad necesita conexión a internet. Conéctate a internet e inténtalo de nuevo.',
		videoOffline: 'Los vídeos necesitan conexión a internet.',
		offlineFirstLoadMessage: 'Estás sin conexión. Conéctate a internet para cargar tu cuenta por primera vez en este dispositivo.',
		offlineFirstLoadChecking: 'Comprobando tu conexión...',
		offlineFirstLoadStillOffline: 'Sigues sin conexión. Conéctate a internet y luego inténtalo de nuevo.',
		offlineFirstLoadServerUnreachable: 'Tu conexión ha vuelto, pero no pudimos acceder a tu cuenta. Inténtalo de nuevo en un momento.',
		accountLoadFailedMessage: 'No pudimos cargar tu cuenta. Comprueba tu conexión e inténtalo de nuevo.',
		splashStuckMessage: 'Está tardando más de lo normal. Comprueba tu conexión e inténtalo de nuevo.',
		splashStuckOfflineMessage: 'Parece que estás sin conexión. Vuelve a conectarte a internet y luego inténtalo de nuevo.',
		retry: 'Reintentar',
		communityTitle: 'Comunidad',
		communityFirstTime: 'Si abres la Comunidad por primera vez, puede que tarde un poco en crear una cuenta para ti. Gracias de antemano por tu paciencia.',
		screenshotHelp: 'Usa este botón para hacer la captura de pantalla. Puedes arrastrarlo si te estorba.',
		screenshotCaptureFailed: 'No hemos podido hacer la captura de pantalla. Tu texto sigue ahí, así que puedes enviarlo sin ella.',
		darkModeConflictTitle: 'Conflicto con el modo oscuro de Samsung',
		darkModeConflictMessage: 'Esta aplicación siempre está en modo oscuro. Samsung Internet está forzando su propio modo oscuro por encima, lo que hace que la aplicación sea ilegible. Abre el menú del navegador y toca «Sitios con tema claro» o «Ajustes > Labs > Usar tema oscuro del sitio web».',
		darkModeConflictButton: 'Ok, ya lo hice',
		serverConnectionDifficulty: 'Teniendo dificultades para conectar con el servidor...',
		serverBehindAccountVersion: 'Este servidor está usando una versión más antigua de la que necesita tu cuenta. Inténtalo de nuevo en unos minutos.',
	},
	appInstallSheet: {
		title: 'Consigue la aplicación MH Physique',
		body: 'Una experiencia más rápida y fluida: entrenamientos, registro de comidas y seguimiento del progreso directamente en tu teléfono.',
		openInAppCta: 'Abrir en MH Physique',
		openInAppLink: '¿Ya tienes la aplicación? Ábrela',
		continueInBrowser: 'Continuar en el navegador',
		dontShowAgain: 'No volver a mostrar',
		notRightNow: '¿Ahora no?',
	},
	progress: {
		title: 'Progreso',
		filters: 'Filtros',
		measurements: 'Mediciones',
		exportAsCsv: 'Exportar como CSV',
		noData: 'Sin datos',
		lostPerWeek: 'perdido por semana',
		gainedPerWeek: 'ganado por semana',
		filterHeaders: {
			bodyComposition: 'Composición corporal',
			nutrition: 'Nutrición',
			chartDisplaySettings: 'Ajustes de visualización del gráfico',
		},
		chartTitles: {
			bodyComposition: 'Progreso de composición corporal',
			nutrition: 'Progreso de nutrición',
		},
		filterOptions: {
			showAverage: 'Mostrar promedio',
			showAverageDescription: 'Promedia los últimos 7 días de datos para suavizar las fluctuaciones diarias',
			showPoints: 'Mostrar puntos',
			showPointsDescription: 'Muestra los datos como círculos en las líneas del gráfico',
		},
		axisTitles: {
			weight: 'Peso ({unit})',
			waist: 'Cintura ({unit})',
			caloriesKcal: 'Calorías (kcal)',
			day: 'Día',
			month: 'Mes',
		},
		trendLegend: {
			falling: 'Bajando',
			rising: 'Subiendo',
			flat: 'Estable',
			uncertain: 'Incierto',
			mayChange: 'Aún puede cambiar',
		},
	},
	intro: {
		start: 'Empezar',
		next: 'Siguiente',
		back: 'Atrás',
		skip: 'Saltar introducción',
		slide1: {
			title: 'Tu entrenador de fitness todo en uno en tu bolsillo',
			text: 'El entrenamiento adaptativo y la nutrición se unen en una potente aplicación. Tu programa evoluciona con tu progreso, asegurándose de que ganes músculo, ganes fuerza y pierdas grasa.',
		},
		slide2: {
			title: 'Registra tus entrenamientos y observa cómo crece tu progreso',
			text: 'Tu programa se ajusta después de cada sesión para adaptarse a tu rendimiento. Si es demasiado fácil, te desafiaremos. Si es demasiado, lo reduciremos para ayudarte a recuperarte.',
		},
		slide3: {
			title: 'Nutrición sin esfuerzo para tus objetivos',
			text: 'Tu plan de nutrición se actualiza continuamente.\nLas comidas diseñadas por expertos eliminan las conjeturas a la hora de alcanzar tus objetivos.',
		},
		slide4: {
			title: 'Siempre adaptándose a ti',
			text: 'Tu plan evoluciona a medida que te haces más fuerte, ajustándose sin problemas para mantenerte en el buen camino.\n¿Prefieres otro ejercicio o quieres tu propia comida?\nAjusta tus planes cuando quieras.',
		},
	},
	customizeHomepage: {
		title: 'Personalizar la pantalla de inicio',
		sections: {
			dailyLog: 'Registro diario',
			progress: 'Progreso',
		},
		options: {
			wakeUp: 'Despertar',
			weighIn: 'Pesaje',
			workout: 'Entrenamiento',
			meals: 'Comidas',
			sleep: 'Sueño',
			goal: 'Objetivo',
			bodyComposition: 'Composición corporal',
			nutrition: 'Nutrición',
			coachingTips: 'Consejos de entrenamiento',
		},
	},
	home: {
		tabs: {
			dailyLog: 'Registro diario',
			progress: 'Progreso',
		},
		buttons: {
			logActivity: 'Registrar actividad',
			logMeal: 'Registrar comida',
			logWorkout: 'Registrar entrenamiento',
			weighIn: 'Pesarse',
			barcodeScan: 'Escanear código de barras',
			labelScan: 'Escanear etiqueta',
		},
		hints: {
			nutritionTargetsWaiting: 'Los objetivos de nutrición estarán disponibles después de que se evalúen tus fotos. Esto no debería tardar más de 48 h.',
			offlineNow: 'Estás sin conexión. La sincronización con la nube se reanudará cuando vuelvas a conectarte.',
		},
		messages: {
			noScheduleForDay: 'No hay ninguna programación para este día.',
		},
		emptyState: {
			allHidden: {
				title: 'Todos los elementos ocultos',
				subtext: 'Has ocultado todos los elementos de esta sección. Usa el botón de abajo para personalizar lo que aparece aquí.',
			},
			customizeButton: 'Personalizar la pantalla de inicio',
		},
		alerts: {
			workoutTimeLabel: 'Hora del entrenamiento',
		},
		settingsMenu: {
			customizeDashboard: 'Personalizar el panel',
		},
		progress: {
			goalCard: {
				title: 'Objetivo',
				target: 'Meta',
				progress: 'Progreso',
				fatLoss: 'Pérdida de grasa',
				weightLoss: 'Pérdida de peso',
				weightGain: 'Ganancia de peso',
				estimatedValueTooltip: 'El valor actual se estima algorítmicamente a partir de tus mediciones de las últimas dos semanas. El cambio que se muestra es la diferencia desde que fijaste este objetivo.',
				growthMindset: 'Mentalidad de crecimiento',
				growthMindsetInfo: 'La mentalidad de crecimiento se centra en la constancia y el progreso del entrenamiento. El objetivo es desarrollar fuerza y músculo.',
				start: 'Inicio',
				goal: 'Objetivo',
				onTrack: 'En el buen camino',
				offTrack: 'Fuera de camino',
				undetermined: 'Sin determinar',
				notEnoughData: 'Aún no tenemos suficientes mediciones para evaluar tu progreso. Sigue registrando tus pesajes y mediciones de grasa corporal.',
				measureMoreOften: 'Necesitamos más mediciones de grasa corporal (cinta métrica de cintura o calibradores) para determinar si estás en el buen camino o no.',
				dataErratic: 'Tus mediciones fluctúan mucho, lo que dificulta determinar una tendencia clara. Intenta medir en condiciones constantes.',
				weightTooFlat: 'Tus lecturas de peso han sido sospechosamente idénticas. Comprueba que tu báscula funcione correctamente.',
				insufficientFatnessConfidence: 'Aún no confiamos en tu tendencia de grasa corporal. Añade unas cuantas mediciones más (cinta métrica de cintura o calibradores) antes de que ajustemos tu plan.',
				nutritionAdjusted: 'Nutrición ajustada hace {N1} {{día|días}}. Sigue registrando: la evaluación se reanuda en unos {N2} {{día|días}}.',
				nutritionAdjustedToday: 'Nutrición ajustada hoy. Sigue registrando: la evaluación se reanuda en unos {N2} {{día|días}}.',
				planJustStarted: 'El plan empezó hace {N1} {{día|días}}. Sigue registrando: la evaluación empieza en unos {N2} {{día|días}}.',
				planJustStartedToday: 'El plan empezó hoy. Sigue registrando: la evaluación empieza en unos {N2} {{día|días}}.',
			},
			bodyComposition: {
				title: 'Composición corporal',
			},
			nutrition: {
				title: 'Nutrición',
			},
			coachingTips: {
				title: 'Consejos de entrenamiento',
				noTips: '¡Lo estás haciendo genial! Sigue así.',
			},
		},
	},
	editTrainingGoal: {
		title: 'Editar objetivos de entrenamiento',
		primaryGoal: 'Objetivo principal',
		method: 'Método',
		targetUnit: 'Unidad objetivo',
		targetUnitDescription: 'Elige cómo quieres seguir tu progreso',
		goalWeight: 'Peso objetivo',
		goalBodyFat: 'Grasa corporal objetivo',
		growthMindset: 'Mentalidad de crecimiento',
		growthMindsetDescription: 'La mentalidad de crecimiento se centra en la constancia y el progreso del entrenamiento. El objetivo es ganar fuerza y músculo.',
		fixedTarget: 'Objetivo fijo',
		fixedTargetDescription: 'Haz que la app siga tu progreso frente a un peso objetivo o un porcentaje de grasa corporal.',
		weight: 'Peso',
		bodyFatPercent: '% de grasa corporal',
		fatLoss: 'Pérdida de grasa',
		muscleGrowth: 'Crecimiento muscular',
		update: 'Actualizar',
		updateAlert: {
			title: 'Actualizar objetivo de entrenamiento',
			message: 'Cambiar tu objetivo puede requerir que tu programa de entrenamiento se reconstruya y reinicie por completo.',
			updateGoal: 'Actualizar objetivo',
		},
	},
	consent: {
		cookies: {
			header: 'Cookies sin calorías, las mejores cookies que existen.',
			message: 'Al hacer clic en «Aceptar todas las cookies», aceptas que MH Physique pueda almacenar cookies en tu dispositivo y divulgar información de acuerdo con nuestra ',
			privacyPolicy: 'Política de privacidad',
			customize: 'Personalizar',
			customizeHeader: 'Personalizar cookies',
			saveSettings: 'Guardar ajustes',
			acceptAll: 'Aceptar todas las cookies',
			rejectAll: 'Rechazar todas',
			required: 'Obligatoria',
			types: {
				functionality: {
					name: 'Funcionalidad',
					description: 'Habilita el almacenamiento que respalda las funciones necesarias para el correcto funcionamiento del sitio web o la app, como los ajustes de idioma.',
				},
				security: {
					name: 'Seguridad',
					description: 'Habilita el almacenamiento relacionado con la seguridad, como la autenticación, la prevención de fraudes y otras protecciones del usuario.',
				},
				personalization: {
					name: 'Personalización',
					description: 'Habilita el almacenamiento relacionado con la personalización, como las recomendaciones de vídeos.',
				},
				advertising: {
					name: 'Publicidad',
					description: 'Ayuda a que MH Physique crezca: permite que nuestros socios publicitarios sepan cómo usas la app, para que nuestros anuncios lleguen a las personas adecuadas y podamos ver cuáles funcionan.',
					gpcNotice: 'Publicidad está desactivada porque tu navegador envió una señal de Global Privacy Control.',
				},
				performance: {
					name: 'Rendimiento',
					description: 'Habilita el almacenamiento, como las cookies, relacionado con el rendimiento del sitio web y la aplicación, como qué opciones se usan más a menudo. Lo usamos para mejorar la app.',
				},
			},
			chooseEach: 'Elige activado o desactivado en cada opción para guardar tus ajustes.',
		},
		user: {
			header: 'Términos y acuerdos',
			subtitle: 'Abre los enlaces de abajo y lee los términos con atención. Al continuar, confirmas que has leído y aceptas los siguientes términos.',
			updatedHeader: 'Hemos actualizado nuestros Términos y nuestra Política de privacidad',
			updatedSubtitle: 'Hemos actualizado nuestros términos. Revísalos y acéptalos para continuar.',
			later: 'Más tarde',
			updatedCard: 'Hemos actualizado nuestros Términos y nuestra Política de privacidad.',
			updatedCardAction: 'Revisar',
			reviewOffline: 'No tienes conexión. Conéctate a internet para revisar la política actualizada.',
			additionalOptions: 'Opciones adicionales:',
			acceptAll: 'Aceptar todo',
			tosLabel: 'Condiciones del servicio',
			healthLabel: 'Aviso de salud',
			privacyLabel: 'Política de privacidad',
			researchLabel: 'Ayuda a mejorar la app compartiendo datos de entrenamiento anonimizados para su análisis.',
			marketingLabel: 'Recibe consejos sobre la app, novedades y alguna oferta ocasional.',
			advertisingLabel: 'Ayudar a que MH Physique crezca: permitir que nuestros socios publicitarios sepan cómo uso la app, para que nuestros anuncios lleguen a las personas adecuadas y podamos ver cuáles funcionan.',
			continue: 'Continuar',
			details: 'Detalles',
			requiredError: 'Debes aceptar las Condiciones del servicio, la Política de privacidad y el Aviso de salud para continuar.',
			persistFailed: 'No pudimos guardar tu aceptación. Comprueba tu conexión e inténtalo de nuevo.',
		},
	},
	profile: {
		title: 'Perfil de usuario',
		signOut: 'Cerrar sesión',
		profileSection: 'Perfil',
		subscriptionSection: 'Suscripción',
		subscription: 'Suscripción',
		subscriptionType: 'Tipo',
		subscriptionTypeMonthly: 'Mensual',
		subscriptionTypeYearly: 'Anual',
		renewalDate: 'Fecha de renovación',
		expiresOn: 'Caduca el',
		renewalPrice: 'Precio de renovación',
		emailSupport: 'Soporte por email',
		switchPlanPromo: 'Tu plan actual es «{current}». ¡Cámbiate a «{other}» por {price} y ahorra {saving}!',
		perpetualLicense: 'Licencia {type}',
		refreshingStatus: 'Actualizando el estado de la suscripción...',
		subscriptionInfoError: 'No se pudieron cargar los detalles de la suscripción. Vuelve a abrir esta página para reintentarlo.',
		coachCoversMembership: 'El plan de tu entrenador cubre tu membresía Premium en este momento. Además, estás pagando tu propia suscripción.',
		boostYourGains: '¡Impulsa tus ganancias!',
		upgradeToPremium: 'Pásate a Premium y desbloquea todas las funciones, incluidos programas de entrenamiento avanzados, seguimiento detallado del progreso y planes de nutrición personalizados.',
		upgradeNow: 'Mejorar ahora',
		trialEndsOn: 'Tu prueba termina el {date}',
		trialCancelInfo: 'Si cancelas ahora, puedes seguir usando las funciones Premium hasta que termine tu prueba.',
		cancelSubscription: 'Cancelar suscripción',
		trialCanceled: 'Tu prueba está cancelada y terminará el {date}',
		trialPaused: 'Tu prueba se pausará el {date}',
		trialResumeInfo: 'Puedes reanudar tu suscripción en cualquier momento antes de que termine la prueba.',
		resumeSubscription: 'Reanudar suscripción',
		currentPlanWithSaving: 'Tu plan actual es «{current}». ¡Puedes cambiarte a «{other}» por {price} y ahorrar {saving}!',
		currentPlan: 'Tu plan actual es «{current}». Puedes cambiarte a «{other}» por {price}.',
		switchToPlan: 'Cambiar a {plan}',
		paymentFailing: 'Tu último pago no se ha podido procesar. Seguiremos intentándolo y, mientras tanto, tu suscripción sigue activa. Si el pago sigue fallando, tu suscripción finalizará el {date}.',
		paymentProcessing: 'Se está procesando tu pago.',
		paymentProcessingHelp: 'Esto suele tardar solo unos minutos. Vuelve a comprobarlo en un rato.',
		subscriptionEnds: 'Tu suscripción termina el {date}',
		resubscribeInfo: 'Puedes reanudar tu suscripción en cualquier momento para seguir disfrutando de las funciones Premium.',
		support: 'Soporte',
		reportIssueInfo: '¿La app parecía funcionar mal o no sabes qué hacer a continuación? Quizá la respuesta que buscas esté aquí. Si no, no dudes en comentarlo con otras personas en nuestra <a href="https://community.mh-physique.app/" target="_blank">Comunidad</a>.',
		reportIssueInfoFeedback: 'Si no puedes enviar tu opinión con los botones de arriba, también puedes contactarnos por email.',
		termsAndConditions: 'Términos y condiciones',
		privacyPolicy: 'Política de privacidad',
		healthDisclaimer: 'Aviso de salud',
		refundPolicy: 'Política de reembolsos',
		menu: {
			logout: 'Cerrar sesión',
			deletePrivateData: 'Eliminar datos privados',
		},
		deleteData: {
			title: '¿Estás seguro?',
			message: 'Esto eliminará todos tus datos privados de los servidores y de este dispositivo. Tu cuenta y tu suscripción se mantendrán, pero todo tu historial de entrenamiento y nutrición se perderá para siempre. Ten en cuenta que algunos datos pueden seguir estando en otros dispositivos si has iniciado sesión en ellos antes.',
			deleteButton: 'ELIMINAR',
			deleting: 'Eliminando todos los datos del usuario...',
			error: 'No se puede purgar la cuenta. Inténtalo de nuevo más tarde.',
		},
		signOutOfflineWarning: {
			title: '¿Cerrar sesión sin subir los cambios?',
			message: 'Algunos de tus cambios recientes aún no se han subido a la nube. Si cierras sesión ahora, esos cambios se eliminarán de este dispositivo y no se podrán recuperar. Para conservarlos, mantén la sesión iniciada, asegúrate de tener una conexión a internet que funcione y dale un momento a la app para terminar de subirlos antes de cerrar sesión.',
			signOutAnyway: 'Cerrar sesión de todos modos',
		},
		reportProblemEmail: {
			subject: 'Nombre-del-problema-aquí',
		},
		contactSupport: {
			title: 'Contactar con soporte',
			message: 'Contáctanos por email en {email}. Copia la dirección de abajo o abre tu app de correo para empezar un mensaje.',
			copyAddress: 'Copiar dirección',
			openMailApp: 'Abrir app de correo',
			close: 'Cerrar',
			copied: 'Dirección de email de soporte copiada',
			copyFailed: 'No se pudo copiar. Copia a mano la dirección que se muestra arriba.',
		},
		resubscribe: {
			confirm: '¿Quieres reanudar tu suscripción?',
			success: 'Has vuelto a suscribirte correctamente. Necesitamos reiniciar la aplicación para aplicar los cambios.',
			confirmPaused: '¿Reanudar tu suscripción? Esto inicia un nuevo período de facturación y cobra ahora a tu método de pago guardado, a menos que aún te quede tiempo pagado.',
		},
		manageSubscription: {
			title: 'Gestionar suscripción',
			emailSent: 'Te enviamos un enlace de inicio de sesión a tu email. Úsalo para acceder al portal de cuentas de PayPro Global y gestionar tu suscripción, ver facturas y actualizar los métodos de pago.',
		},
		googlePlayCancel: {
			confirm: '¿Cancelar tu suscripción? Conservarás el acceso hasta el final de tu periodo de facturación actual.',
			confirmButton: 'Cancelar suscripción',
			success: 'Tu suscripción se ha cancelado. Conservarás el acceso hasta el {date}.',
			error: 'No se pudo cancelar la suscripción. Inténtalo de nuevo.',
		},
		paddleStaleState: 'Tu suscripción cambió en otro lugar, así que esta acción ya no se aplica. Vuelve a abrir esta página para ver su estado actual.',
		paddleCancel: {
			confirm: '¿Cancelar tu suscripción? Conservarás el acceso hasta el final de tu periodo de facturación actual.',
			confirmImmediate: '¿Cancelar tu suscripción? Tu suscripción está en pausa, así que cancelarla la finaliza de inmediato.',
			confirmButton: 'Cancelar suscripción',
			successImmediate: 'Tu suscripción ha sido cancelada.',
			error: 'No se pudo cancelar la suscripción. Inténtalo de nuevo.',
			successScheduled: 'Tu suscripción ha sido cancelada. Mantendrás el acceso hasta el final de tu período de facturación actual.',
			alreadyScheduled: 'Tu suscripción ya está programada para cancelarse, así que no tienes que hacer nada más. Mantendrás el acceso hasta el final de tu período de facturación actual.',
		},
		subscriptionPausesOn: 'Tu suscripción se pausa el {date}',
		subscriptionPaused: 'Tu suscripción está en pausa. Reanúdala cuando quieras para recuperar tu acceso.',
		appleCancel: {
			confirm: 'Para cancelar tu suscripción, abriremos la gestión de suscripciones de Apple, donde podrás cancelarla.',
			confirmButton: 'Gestionar suscripción',
			success: 'Si la cancelaste en la gestión de suscripciones de Apple, tu acceso continuará hasta el final de tu periodo de facturación actual.',
			error: 'No se pudo abrir la gestión de suscripciones. Puedes gestionar tu suscripción en los Ajustes de tu dispositivo, en tu Cuenta de Apple.',
		},
		appleResume: {
			confirm: 'Para reanudar tu suscripción, abriremos la gestión de suscripciones de Apple, donde podrás volver a activar la renovación automática.',
			confirmButton: 'Gestionar suscripción',
			success: 'Si volviste a activar la renovación automática en la gestión de suscripciones de Apple, tu suscripción seguirá renovándose automáticamente.',
			error: 'No se pudo abrir la gestión de suscripciones. Puedes gestionar tu suscripción en los Ajustes de tu dispositivo, en tu Cuenta de Apple.',
		},
		subscribedViaOtherPlatform: 'Tu suscripción se gestiona a través de {provider}. Abre esa plataforma para gestionar tu suscripción.',
		subscribedViaWeb: 'Tu membresía se gestiona en la web. Inicia sesión en nuestro sitio web para hacer cambios.',
		webMembershipProblem: 'No hemos podido cargar los datos de tu suscripción, así que ahora mismo no podemos cambiarla desde aquí. Tu suscripción se cobra a través de nuestra web: inicia sesión allí para gestionarla o contacta con soporte y te ayudaremos.',
		switchPlan: {
			confirm: '¿Quieres cambiar tu plan a {plan} por {price}?',
			confirmNoPrice: '¿Quieres cambiar tu plan a {plan}? La diferencia de precio por el resto de tu período actual se cobrará o abonará de inmediato, usando tu método de pago guardado.',
			success: 'Has cambiado el plan correctamente. Necesitamos reiniciar la aplicación para aplicar los cambios.',
			scheduledConfirm: 'Tu plan cambiará a «{plan}» cuando termine tu ciclo de suscripción actual, el {date}.',
			error: 'No se pudo cambiar el plan.',
			trialNotSupported: 'El cambio de plan está disponible cuando termine tu prueba. Podrás cambiar de plan una vez que se procese tu primer pago, o cancela ahora y compra un plan diferente cuando caduque la prueba.',
			grantedPriceWouldBeLost: 'Tienes un precio especial que acordamos contigo, y ese precio solo se aplica a tu plan actual. Cambiar de plan te devolvería al precio estándar, así que contacta con soporte y haremos el cambio manteniendo tu precio.',
			notYetConfirmed: 'Tu cambio de plan se ha realizado en la tienda. No hemos podido terminar de confirmarlo ahora mismo, pero debería aplicarse solo en unos minutos. No hace falta que vuelvas a intentarlo.',
		},
		pendingPlanChange: 'Tu plan está programado para cambiar a «{plan}» el {date}.',
		pausesOn: 'Se pausa el',
	},
	intake: {
		title: {
			updateProgram: 'Actualizar programa de entrenamiento',
		},
		steps: {
			basicInfo: 'Información básica',
			bodyComposition: 'Composición corporal',
			strength: 'Fuerza',
			lifestyle: 'Estilo de vida',
			advancedTraining: 'Entrenamiento avanzado',
			schedule: 'Horario',
			nutritionOptions: 'Opciones de nutrición',
			goals: 'Objetivos',
			trainingVolume: 'Volumen de entrenamiento',
			energyBalance: 'Balance energético',
			programOverview: 'Resumen del programa',
			firstWorkoutHandoff: 'Empezar',
		},
		step: 'Paso {current} de {total}',
		validation: {
			selectOption: 'Selecciona una opción',
			checkInputs: 'Revisa tus datos y asegúrate de que todos los campos obligatorios estén rellenados correctamente.',
			gender: 'Indica tu sexo. La planificación de la nutrición y el entrenamiento depende en gran medida de las características de cada sexo.',
			age: 'Necesitamos saber tu edad para optimizar el programa teniéndola en cuenta.',
			ageMinimum: 'Tienes que tener 18 años o más para usar esta aplicación.',
			ageTooOld: 'No puedes tener tantos años.',
			birthdayFuture: 'Vaya, hola, querido visitante del futuro. Prueba con otra. :)',
			height: 'Introduce tu estatura',
			bodyMeasurements: 'Las medidas del dedo, la muñeca y el tobillo son importantes para varios indicadores genéticos. Pulsa el botón de información de arriba si quieres saber más.',
			weight: 'Indica tu peso actual.',
			chooseOption: 'Elige una de las opciones.',
			weekdaySelection: 'Selecciona sí o no para cada día de la semana.',
			trainingDaysAtLeastOne: 'Selecciona los días en los que entrenarás la mayor parte del tiempo.',
			bothTimes: 'Introduce las dos horas. No tienen que ser exactas.',
			unknownField: 'Campo desconocido',
			internalError: 'Error interno [{code}]',
			strengthTooGoodToBeTrue: 'Eso parece demasiado bueno para ser verdad. ¿Puedes revisar esos números?',
			strengthTestsNotLoaded: 'Toca Intentar de nuevo, o toca Omitir para continuar sin estadísticas de levantamiento.',
		},
		strength: {
			liftingStatsOptional: 'Estadísticas de levantamiento (opcional)',
			liftingStatsNote1: 'Indica el peso máximo x repeticiones que estimas que podrías levantar ahora mismo o tus récords personales recientes.',
			liftingStatsNoteHighlight: 'Cuanto más cerca de un máximo de una repetición (1RM), mejor.',
			liftingStatsNote2: 'Si no tienes ni idea, deja ese ejercicio en blanco.',
			addedWeightOnly: 'Introduce solo el peso añadido por encima de tu peso corporal. Si no hay ninguno, pon 0.',
			skipExerciseReason: '¿Por qué quieres omitir este ejercicio?',
			neverTrained: 'Nunca lo he entrenado antes.',
			injuryOrEquipment: 'Tengo que evitarlo por una lesión o por falta de equipo.',
			skipEstimate: 'Omitir estimación',
			selectExercisePlaceholder: 'Selecciona ejercicio',
			loadFailed: 'No se pudieron cargar las pruebas de fuerza. Revisa tu conexión a internet y toca Intentar de nuevo, o toca Omitir para continuar sin estadísticas de levantamiento.',
		},
		nutrition: {
			morningAppetite: 'Apetito por la mañana',
			morningAppetiteQuestion: '¿Sientes hambre de forma natural por la mañana?',
			mealFrequency: 'Frecuencia de comidas',
			mealFrequencyDescription: 'Elige cuántas comidas planeas hacer cada día. (Consejo: para mejores resultados, come a horas constantes y evita picar entre comidas.)',
		},
		nutritionOptions: {
			header: 'Opciones de nutrición',
			macroTargets: 'Objetivos de macros',
			enabled: 'Activado',
			enabledNote: 'Quiero que la app prescriba objetivos de macros y calorías, y que los actualice según mi progreso.',
			disabled: 'Desactivado',
			disabledNote: 'No quiero que la app determine mis objetivos de macros.',
			macroTracking: 'Seguimiento de macros',
			trackInApp: 'Seguir en la app',
			trackInAppNote: 'Registraré mis comidas en esta app.',
			trackElsewhere: 'Seguir en otro sitio',
			trackElsewhereNote: 'Registraré mis comidas en papel o en otra app (o no las registraré).',
			trackingType: 'Tipo de seguimiento',
			flexibleNutrition: 'Nutrición flexible',
			flexibleNutritionNote: 'Trabajarás con rangos flexibles para tus macros. El reparto exacto de macros a menudo no afecta significativamente a tus resultados.',
			fixedTargets: 'Objetivos fijos',
			fixedTargetsNote: 'La app fija objetivos exactos de macronutrientes para cada comida.',
		},
		goals: {
			physiqueGoal: 'Objetivo de físico',
			physiqueGoalQuestion: '¿Cuál es tu objetivo principal de fitness?',
			bareMinimum: 'Lo mínimo indispensable',
			bareMinimumNote: 'Entrena con un volumen mínimo para mantener la masa muscular actual.',
			balanced: 'Desarrollo equilibrado de todo el cuerpo',
			balancedNote: 'Es nuestra recomendación por defecto. Vale para la mayoría de personas que entrenan de forma recreativa, atletas y culturistas.',
			lowerBodyNote: 'Esta opción es popular entre las mujeres que quieren enfatizar el tren inferior, incluidas las competidoras de Bikini Fitness y Wellness.',
			lowerBodyFocus: 'Enfoque en el tren inferior',
			lowerBodyFocusNote: 'Esta opción es popular entre las mujeres que quieren enfatizar el tren inferior, incluidas las competidoras de Bikini Fitness y Wellness.',
			custom: 'Personalizado',
			customNote: 'Déjame decidir cómo personalizar cada grupo muscular.',
			customizationNote: 'Puedes personalizar tu enfoque de entrenamiento para cada grupo muscular.',
			bodyPartCustomization: 'Personalización por parte del cuerpo',
			lowerBody: 'Tren inferior',
			upperBody: 'Tren superior',
			primaryGoal: 'Objetivo principal',
			trainingVolume: 'Volumen de entrenamiento',
			maximize: 'Maximizar',
			maintain: 'Mantener',
			shrink: 'Reducir',
			decideForMe: 'Decidir por mí',
			decideForMeDescription: 'Deja que la app determine el mejor enfoque según tu estado actual',
			fatLoss: 'Pérdida de grasa',
			fatLossDescription: 'Céntrate en perder grasa corporal mientras mantienes el músculo',
			muscleGrowth: 'Crecimiento muscular',
			muscleGrowthDescription: 'Céntrate en ganar masa muscular',
		},
		training: {
			selectDaysNote: 'Para empezar, selecciona los días que representen tu horario habitual. Puedes cambiarlos más adelante si lo necesitas.',
			volumeDescription: 'Esto se refiere al volumen de entrenamiento semanal total para los grupos musculares que quieres hacer crecer. Los grupos musculares que no priorices para el crecimiento tendrán un volumen semanal menor.',
			currentPlanVolume: 'Plan actual: {volume} series/semana',
			setsPerWeek: 'Series por semana:',
			recommendSwitchToMuscleGrowth: 'Tu grasa corporal ya es lo bastante baja para centrarte en ganar músculo. Te recomendamos cambiar tu objetivo a Crecimiento muscular.',
			recommendSwitchToFatLoss: 'Tu grasa corporal ya es lo bastante alta como para que perder grasa sea lo primero. Te recomendamos cambiar tu objetivo a Pérdida de grasa.',
			slowAndSteady: 'Lento y constante',
			slowAndSteadyDescription: 'Para mí lo más importante es la sostenibilidad. Mientras avance en la dirección correcta, el ritmo de progreso no me preocupa.',
			balanced: 'Equilibrado',
			balancedDescription: 'Quiero lograr un equilibrio razonable entre buenos resultados en proporción al esfuerzo y la sostenibilidad.',
			maximumEffort: 'Esfuerzo máximo',
			maximumEffortDescription: 'Haré lo que haga falta para conseguir los máximos resultados (sin comprometer mi salud).',
			overreachingWarning: 'Advertencia: mala relación riesgo-beneficio con volúmenes tan altos. Hay un riesgo alto de sobrecarga y lesiones a cambio de relativamente poco progreso adicional.',
			calorie: 'Calorías',
			calorieDeficit: 'Déficit calórico:',
			calorieSurplus: 'Superávit calórico:',
		},
		advancedLabels: {
			progressionTesting: 'Prueba de progresión',
			slot: 'Hueco',
			sets: 'Series',
			level: 'Nivel',
			otherSlotsLevel: 'Nivel de los otros huecos',
			intensityPeriodization: 'Intensidad/Periodización',
			slotIntensitiesJSON: 'JSON de intensidades de huecos',
		},
		labels: {
			gender: 'Sexo',
			male: 'Hombre',
			female: 'Mujer',
			birthdate: 'Fecha de nacimiento',
			height: 'Altura',
			weight: 'Peso',
			bodyfat: 'Porcentaje de grasa corporal',
		},
		alerts: {
			progressSaved: 'Tu progreso se guarda a medida que avanzas. Puedes salir y retomar el formulario en cualquier momento.',
			recalculateNeeded: 'Has hecho cambios que afectan a otros ajustes; tendrás que recalcular antes de poder acceder a algunas pestañas y actualizar tu programa.',
		},
		updateOptions: {
			title: 'Actualiza tu programa',
			intro: 'Has cambiado algunos ajustes. Elige qué quieres actualizar.',
			workoutsTitle: 'Tus entrenamientos',
			workoutsRebuild: 'Rehacer mi programa',
			workoutsRebuildNote: 'Crea entrenamientos nuevos a partir de tus nuevos ajustes.',
			workoutsRebuildNoteWithCustomizations: 'Crea entrenamientos nuevos a partir de tus nuevos ajustes. Los ejercicios que hayas cambiado tú se sustituirán.',
			workoutsVolumesOnly: 'Actualizar solo mi volumen de series',
			workoutsVolumesOnlyNote: 'Mantiene tus ejercicios. Ajusta cuántas series haces de cada uno.',
			workoutsKeep: 'Mantener mis entrenamientos actuales',
			workoutsKeepNote: 'No cambia nada de tu entrenamiento.',
			nutritionTitle: 'Tu nutrición',
			nutritionUpdate: 'Actualizar mi objetivo de calorías',
			nutritionUpdateNote: 'Vuelve a calcular tus calorías diarias a partir de tus nuevos ajustes.',
			nutritionKeep: 'Mantener mi objetivo de calorías',
			nutritionKeepNote: 'Tus calorías diarias se quedan en {target}.',
			nutritionKeepNoteNoTarget: 'Tus calorías diarias se quedan como están.',
			warnKeepEnergyBalance: 'Tu nuevo déficit o superávit no cambiará tus calorías diarias, porque vas a mantener tu objetivo actual.',
			warnKeepGoal: 'Has cambiado tu objetivo. Si mantienes tu objetivo de calorías, seguirás comiendo la cantidad calculada para tu objetivo anterior.',
			warnKeepBodyData: 'Tu objetivo de calorías seguirá calculado con tu peso y tu grasa corporal anteriores.',
			scrollToMessages: 'Desplázate para leer qué cambia',
			warnKeepActivityLevel: 'Has cambiado tu nivel de actividad, pero si mantienes tu objetivo tus calorías diarias seguirán calculadas para tu nivel de actividad anterior.',
			warnUpdateReplacesTarget: 'Tu objetivo de {target} se sustituirá por {recommended}. Puedes volver a fijarlo en la pantalla de objetivo nutricional diario.',
			warnUpdateReplacesTargetUnknown: 'Tu objetivo de {target} se sustituirá por uno recién calculado. Puedes volver a fijarlo en la pantalla de objetivo nutricional diario.',
		},
		buttons: {
			next: 'Siguiente',
			back: 'Atrás',
			skip: 'Omitir',
			saveAndUpdate: 'Guardar y actualizar',
			recalculate: 'Recalcular',
		},
		lifestyle: {
			activityLevel: 'Nivel de actividad, incluyendo cardio y deportes',
			sedentary: 'Sedentario',
			sedentaryNote: 'Ejemplo: tienes un trabajo de oficina con las tareas cotidianas habituales.',
			somewhatActive: 'Algo activo',
			somewhatActiveNote: 'Ejemplo: tienes un trayecto largo en bicicleta, o de vez en cuando sales a correr o practicas algún deporte, pero por lo demás eres mayormente sedentario.',
			active: 'Activo',
			activeNote: 'Ejemplo: eres entrenador personal a tiempo completo, literalmente de pie la mayor parte del día, o practicas mucho deporte además de levantar pesas.',
			veryActive: 'Muy activo',
			veryActiveNote: 'Ejemplo: tienes un trabajo de esfuerzo físico o realizas muchas actividades físicamente exigentes además de levantar pesas.',
			stressLevel: 'Nivel de estrés',
			mildStress: 'Estrés solo ocasional/leve',
			mildStressNote: 'Ejemplo: estudiante fuera del periodo de exámenes.',
			averageStress: 'Estrés medio',
			averageStressNote: 'Ejemplo: trabajo a tiempo completo con plazos de entrega y desplazamientos.',
			highStress: 'Estrés alto',
			highStressNote: 'Ejemplo: entorno laboral muy acelerado con gran responsabilidad.',
		},
		advanced: {
			myoReps: 'Myo-reps',
			myoRepsPrefer: 'Preferir (ahorra tiempo)',
			myoRepsPreferNote: 'Tus entrenamientos serán lo más cortos posible, teniendo en cuenta tus objetivos y tu progresión individual. Esto incluye el uso de myo-reps siempre que esté justificado.',
			myoRepsAvoid: 'Evitar (entrenamiento clásico)',
			myoRepsAvoidNote: 'Usa solo series rectas clásicas para todos los ejercicios. Los myo-reps no se aplicarán automáticamente. Aun así, siempre puedes activarlos para los ejercicios adecuados más adelante.',
			automatic: 'Automático',
			myoRepsAutomaticNote: 'Los myo-reps se implementarán por ti siempre que sean especialmente beneficiosos.',
			rmTesting: 'Método de hipertrofia específica muscular (prueba de RM)',
			rmTestingPrefer: 'Preferir',
			rmTestingPreferNote: 'Realizarás una prueba de fuerza para la mayoría de los ejercicios y, juntos, determinaremos tus repeticiones objetivo personalizadas.',
			rmTestingAvoid: 'Evitar',
			rmTestingAvoidNote: 'Te daremos un objetivo de repeticiones para cada ejercicio y encontrarás el peso adecuado durante tus primeros entrenamientos. Más adelante podrás activar las repeticiones objetivo autorreguladas.',
			calorieCycling: 'Ciclado de calorías',
			calorieCyclingOn: 'Activado',
			calorieCyclingOnNote: 'Para usuarios más avanzados muy familiarizados con el registro de sus macros, la app puede repartir más nutrientes en tus ventanas anabólicas (las comidas posteriores a tus entrenamientos) y menos nutrientes fuera de ellas. Esto mejora la partición de nutrientes (la proporción de músculo frente a grasa que ganas) según algunas investigaciones.',
			calorieCyclingOff: 'Desactivado (más sencillo)',
			calorieCyclingOffNote: 'Esto repartirá tus macros de forma equitativa a lo largo de la semana sin temporización de nutrientes, al estilo if-it-fits-your-macros.',
			myoRepsTooltip: 'Una técnica eficiente en tiempo que usa una serie de activación seguida de mini-series con pausa-descanso cortas para maximizar el estímulo muscular.',
			rmTestingTooltip: 'Pruebas de fuerza para autorregular tus repeticiones objetivo (ideal para usuarios avanzados).',
			calorieCyclingTooltip: 'Reparte más nutrientes alrededor de tus entrenamientos y menos fuera de las ventanas anabólicas para mejorar la partición de nutrientes.',
		},
		schedule: {
			trainingFrequency: 'Frecuencia de entrenamiento',
			daysPerWeek: 'Días por semana:',
			mealsPerDay: 'Comidas por día:',
			hoursPerNight: 'Horas por noche:',
			sleep: 'Sueño',
			sleepDescription: '¿Cuántas horas de sueño duermes de media por noche? ¡Sé realista!',
		},
		firstWorkout: {
			heading: 'Tu plan está listo.',
			subheading: 'Esto es lo que ocurrirá a continuación:',
			step1: 'Una breve prueba de fuerza fija tus pesos iniciales.',
			step2: 'Después, la app actualiza tu entrenamiento y tu nutrición cada semana, en función de tu rendimiento.',
			startButton: 'Empieza tu primer entrenamiento',
			finishLaterButton: 'Terminar, empezaré más tarde',
		},
		planOverview: {
			successAlert: 'Tu programa personalizado está listo, optimizado para tus objetivos de entrenamiento y nutrición.',
			keepingProgramAlert: 'Tu programa de entrenamiento actual se mantendrá sin cambios. El resto de tus ajustes se han actualizado.',
			nutritionPlan: 'Plan de nutrición',
			nutritionGoal: 'Tu objetivo principal está fijado actualmente en',
			nutritionGoalSuffix: 'Los siguientes objetivos de nutrición están diseñados para ayudarte a alcanzar ese objetivo:',
			dailyAverageCalories: 'Calorías medias diarias',
			dailyAverageTooltip: 'Tu ingesta media de calorías a lo largo de varios días, no un objetivo diario.',
			mealCalories: 'Calorías por comida',
			mealCaloriesTooltip: 'Calorías objetivo por comida media. Los totales semanales importan más que la precisión por comida.',
			cutMealCalories: 'Calorías de comida en definición',
			cutMealTooltip: 'Calorías objetivo para las comidas fuera de tu ventana anabólica.',
			bulkMealCalories: 'Calorías de comida en volumen',
			bulkMealTooltip: 'Calorías objetivo para las comidas después del entrenamiento de fuerza.',
			macroTabs: {
				day: 'Día',
				bulkMeal: 'Volumen',
				cutMeal: 'Definición',
				perDay: 'Por día',
				perMeal: 'Por comida',
			},
			macroTitles: {
				estimatedDailyAverage: 'Macros medios diarios estimados',
				bulkMeal: 'Macros de comida en volumen',
				cutMeal: 'Macros de comida en definición',
				daily: 'Macros diarios',
				meal: 'Macros por comida',
			},
			macroMin: '(mín)',
			macroMax: '(máx)',
			protein: 'Proteína',
			carbs: 'Carbohidratos',
			fat: 'Grasa',
			fiber: 'Fibra',
			workouts: 'Entrenamientos ({count})',
			workoutsDescription: 'Los siguientes entrenamientos se han diseñado para ti; irás rotando entre ellos cada semana.',
			learnMoreProgramming: 'Más información sobre el razonamiento detrás de la programación',
			edit: 'Editar',
			gainWeightQuicker: 'Ganarás peso más rápido con porcentajes más altos, pero pasarse de la raya significa ganar grasa.',
			loseWeightQuicker: 'Perderás peso más rápido con porcentajes más altos, pero perder peso demasiado rápido supone un riesgo de perder músculo.',
			currentPlan: 'Plan actual: {percent}%',
			muscleLossWarning: 'Con tu selección actual es probable que pierdas masa muscular.',
			fatGainWarning: 'Con tu selección actual es probable una ganancia excesiva de grasa.',
		},
		dedication: {
			slowAndSteady: 'Lento y constante',
			slowAndSteadyNote: 'Para mí lo más importante es la sostenibilidad. Mientras avance en la dirección correcta, el ritmo de progreso no me preocupa.',
			balanced: 'Equilibrado',
			balancedNote: 'Quiero lograr un equilibrio razonable entre buenos resultados en proporción al esfuerzo y la sostenibilidad.',
			maximumEffort: 'Esfuerzo máximo',
			maximumEffortNote: 'Haré lo que haga falta para conseguir los máximos resultados (sin comprometer mi salud).',
		},
		trainingSplit: {
			title: 'División del entrenamiento',
			optimal: 'Óptima',
			optimalNote: 'La app optimiza tu frecuencia de entrenamiento por grupo muscular, sin las limitaciones de ninguna plantilla.',
			pushPullLegs: 'Empuje / Tirón / Pierna',
			pushPullLegsNote: 'Alternas entre entrenamientos de ejercicios de empuje, después de tirón y después de tren inferior.',
			upperLower: 'Superior / Inferior',
			upperLowerNote: 'Alternas entre entrenamientos de tren superior y de tren inferior.',
			fullBody: 'Cuerpo completo',
			fullBodyNote: 'Trabajas todos los grupos musculares principales en cada entrenamiento.',
			availableAtFrequency: 'Disponible a partir de {minimum} entrenamientos por semana',
		},
		testMode: {
			options: 'Opciones del modo de prueba',
			novice: 'Principiante',
			intermediate: 'Intermedio',
			advanced: 'Avanzado',
			initial: 'Inicial',
		},
		loading: {
			analyzingFitness: 'Analizando tus objetivos y nivel de forma física.\nEsto puede tardar un minuto o dos.',
			generatingProgram: 'Generando un programa de entrenamiento personalizado.\nEsto puede tardar un minuto o dos.',
			finishingPlan: 'Finalizando tu plan y tu horario...',
		},
		errors: {
			internalError: 'Error interno [{code}]. Actualiza la página e inténtalo de nuevo.',
			couldntGeneratePlan: 'No se pudo generar el plan de fitness.',
			subscriptionRequired: 'Tu suscripción no está activa, posiblemente porque el pago no se completó. Vuelve a suscribirte para continuar.',
		},
		notes: {
			bodyfatEstimate: '¿Cuál es la mejor estimación de tu porcentaje de grasa corporal que puedes obtener?',
			immutableStats: 'La información de esta sección no se puede editar una vez que completes el formulario de admisión. Si necesitas cambiar esta información más adelante, tendrás que borrar tus datos y volver a crear tu cuenta en Ajustes.',
		},
	},
	fatalError: {
		title: {
			whoops: 'Vaya...',
			testError: 'Error grave de prueba',
			storageNotResponding: 'El almacenamiento de tu dispositivo no responde',
		},
		messages: {
			cantAccessData: 'No se puede acceder a los datos locales sin conexión.',
			testError: 'Se produjo un error grave de prueba.',
			appFailedToStart: 'La app no pudo iniciarse.',
			lockdownMode: 'Tu dispositivo tiene activado el modo de aislamiento.',
			serverError: 'No se puede conectar con el servidor.',
			localStorageWedged: 'La app no puede acceder a la copia sin conexión de tus datos en este dispositivo. Tu cuenta y todo lo que ya se ha sincronizado están a salvo en nuestros servidores.',
			resetLocalDataOffer: 'Si eso no ayuda, puedes empezar de cero la copia de este dispositivo. Todo lo que ya se ha sincronizado se descarga de nuevo; se perderá lo que hayas registrado en este dispositivo y aún no se haya sincronizado.',
		},
		help: {
			tryAgainLater: 'Inténtalo de nuevo más tarde.',
			retryOrLogout: 'Si volver a intentarlo no ayuda, prueba a cerrar sesión y volver a iniciarla.',
			testError: 'Es solo una prueba, ignórala.',
			retryOrRelogin: 'Inténtalo de nuevo, o prueba a cerrar sesión e iniciarla de nuevo.',
			disableLockdown: 'Desactiva el modo de aislamiento en tu dispositivo y vuelve a intentarlo, o contacta con soporte si el problema persiste después.',
			storageForceQuitIos: 'Cerrar la pestaña no soluciona esto. Cierra la app por completo (deslízala fuera del selector de apps) y vuelve a abrirla.',
			storageRestartApp: 'Cierra la app por completo y vuelve a abrirla.',
			storageRestartBrowser: 'Cierra y vuelve a abrir tu navegador, y después abre la app de nuevo.',
		},
		buttons: {
			retry: 'Reintentar',
			logout: 'Cerrar sesión',
			resetLocalData: 'Empezar de cero en este dispositivo',
		},
		orPaste: '... o pega',
		intoYourBrowser: 'en tu navegador.',
		support: {
			prefix: 'Si lo anterior no ayuda y el problema persiste, contacta con',
		},
		alerts: {
			resetLocalDataTitle: '¿Empezar de cero en este dispositivo?',
			resetLocalDataMessage: 'Tu cuenta está a salvo, y todo lo que ya se ha sincronizado se descargará de nuevo. Se perderá lo que hayas registrado en este dispositivo y aún no se haya sincronizado.',
		},
	},
	calorieChange: {
		decrease: 'Reducir',
		increase: 'Aumentar',
		self: {
			less: 'Un {percent}% menos que las {base} kcal que indicaste son {kcal} kcal.',
			more: 'Un {percent}% más que las {base} kcal que indicaste son {kcal} kcal.',
			same: 'Lo mismo que las {base} kcal que indicaste.',
		},
		coach: {
			less: 'Un {percent}% menos que las {base} kcal indicadas son {kcal} kcal.',
			more: 'Un {percent}% más que las {base} kcal indicadas son {kcal} kcal.',
			same: 'Lo mismo que las {base} kcal indicadas.',
		},
		belowMinimum: '{kcal} kcal está por debajo de {minimum} kcal, el objetivo más bajo que fijaría la app. Tu número se usa tal como lo escribiste. La app puede subirlo a {minimum} kcal la próxima vez que recalcule el plan.',
	},
	bodyCompOverview: {
		progressCheck: 'Control de progreso',
		fatTrendDown: 'La grasa corporal tiende a bajar',
		fatTrendUp: 'La grasa corporal tiende a subir',
		fatTrendUnclear: 'Tendencia de grasa corporal poco clara',
		notEnoughFatReadings: 'Faltan mediciones de pliegues o cintura para ver una tendencia',
		notEnoughWeighIns: 'Faltan pesajes para ver una tendencia',
		readFromSkinfolds: 'según los pliegues cutáneos',
		readFromWaist: 'según la cintura',
		perWeek: '{value} {unit}/sem',
		changeOf: '{name} {change}',
		countedFrom: 'El control contó las mediciones desde el {date}.',
		judgedOnLast14Days: 'El veredicto se basa en los últimos 14 días. Esta tarjeta muestra la tendencia del periodo que elegiste.',
		periodTrendOnly: 'Tendencia del periodo que elegiste.',
		storedAtCheckup: 'Tal como se valoró al completar esta revisión.',
		weightResponse: 'Respuesta del peso',
		percentOfBodyWeight: '{value}% del peso corporal',
		atKcal: 'con {kcal} kcal/día',
		baselineLogged: 'media registrada',
		baselineTarget: 'objetivo de calorías',
		baselineCustom: 'valor introducido',
		intakeReportedOn: '{how}, indicado en la revisión del {date}',
		fillsAfterFirstCheckup: 'Se completa tras tu primera revisión semanal.',
		weightNow: '{value} {unit} ahora',
		energyIntake: 'Ingesta de energía',
		avgKcalPerDay: '{kcal} kcal/día de media',
		targetKcal: 'objetivo {kcal}',
		daysCounted: '{counted} de {total} días',
		checkupWeek: 'Semana de la revisión {from} - {to}',
		mean: 'Media',
		valueWithUnit: '{value} {unit}',
		readingsInRange: '{count} mediciones en este periodo',
		adherence: 'Adherencia',
		kcalAgainstTarget: '{consumed} / {target} kcal · {percent}%',
		kcalNoTarget: '{consumed} kcal/día',
		trainingDays: '{done} de {planned} días de entrenamiento',
		noWorkoutsPlanned: 'No había entrenamientos previstos esa semana.',
		noWeighIns: 'No hay pesajes en este periodo.',
		noFatReadings: 'Aún no hay mediciones de pliegues ni de cintura.',
		loadFailed: 'No se pudo cargar el resumen.',
		retry: 'Reintentar',
	},
	trainingOverview: {
		title: 'Resumen de entrenamiento',
		notAvailable: 'Esta página no está disponible.',
		deletedExercise: 'Ejercicio eliminado',
		otherSessions: 'Otras sesiones',
		noLongerInWorkout: 'Ya no está en este entrenamiento',
		columnExercise: 'Ejercicio',
		columnSets: 'Series',
		columnRepTarget: 'Reps objetivo',
		showingSessions: 'Mostrando {shown} de {total} {{sesión|sesiones}}',
		showEarlier: 'Mostrar {count} anteriores',
		skipped: 'omitido',
		setsAndTarget: 'Series {sets} · Objetivo {target}',
		setsOnly: 'Series {sets}',
		noWorkouts: 'No hay entrenamientos registrados en las últimas {weeks} semanas.',
		noSessions: 'Aún no hay sesiones.',
		olderDownloading: 'Los entrenamientos más antiguos aún se están descargando.',
		loadFailed: 'No se pudo cargar el resumen de entrenamiento.',
		retry: 'Reintentar',
		markSame: '=',
		markDown: '▼',
		legend: {
			same: 'igual que la última vez',
			down: 'menos que la última vez',
			intensity: 'día pesado / medio / ligero',
			test: 'prueba de fuerza o de repeticiones',
			deload: 'más ligero tras una descarga',
			break: 'más ligero tras una pausa en el entrenamiento',
			cap: 'la app limitó el peso',
		},
		tags: {
			heavy: 'P',
			medium: 'M',
			light: 'L',
			test: 'PRUEBA',
			deload: 'DESCARGA',
			break: 'PAUSA',
			cap: 'LÍMITE',
		},
		menu: {
			exerciseSettings: 'Ajustes del ejercicio',
			history: 'Historial',
			editWorkouts: 'Editar entrenamientos',
		},
		programChanged: 'El programa cambió mientras editabas. No se guardó nada.',
		saveFailed: 'No se pudieron guardar los ajustes del ejercicio. Inténtalo de nuevo.',
		openOverview: 'Abrir resumen de entrenamiento',
		upToToday: 'Entrenamiento hasta hoy',
		tabTraining: 'Entrenamiento',
		checkupCount: '{same} igual, {down} a la baja',
	},
	dateRange: {
		week: 'Semana',
		month: 'Mes',
		quarter: 'Trimestre',
		year: 'Año',
		all: 'Todo',
		twoWeeks: '2 sem',
		fourWeeks: '4 sem',
		eightWeeks: '8 sem',
		twelveWeeks: '12 sem',
	},
	dayItems: {
		titles: {
			weighIn: 'Pesaje',
			weeklyCheckup: 'Revisión semanal',
			wakeUp: 'Despertar',
			sleep: 'Sueño',
			restDay: 'Día de descanso',
			meal: 'Comida {number}',
			workout: 'Entrenamiento',
			workoutNamed: 'Entrenamiento {name}',
		},
		text: {
			reviewYourWeek: 'Revisa tu semana',
		},
		alerts: {
			rescheduleWorkout: 'Ahora mismo no tienes ningún entrenamiento programado para mañana. ¿Quieres reprogramar este entrenamiento para mañana?',
		},
		warnings: {
			daysSinceLastWeighIn: 'Han pasado {days} {{día|días}} desde tu último pesaje.',
			weeksSinceLastWeighIn: 'Han pasado {weeks} {{semana|semanas}} desde tu último pesaje.',
			longTimeSinceLastWeighIn: 'Ha pasado mucho tiempo desde tu último pesaje.',
			logWeightLink: 'Registrar peso',
			planUpdateNeeded: 'Tu progreso indica que tu programa de entrenamiento necesita actualizarse para adaptarse a tus capacidades actuales.',
			updateProgramLink: 'Actualizar programa',
			pendingWorkout: 'Tienes un entrenamiento sin terminar del',
			unfinishedWeeklyCheckup: 'Tienes una revisión semanal sin terminar del',
			firstWorkoutReminder: 'Tu primer entrenamiento es el {day}. ¡No olvides volver a iniciar sesión!',
			coachLapseManageInApp: 'Gestionar Suscripción',
			coachLapseManageInStore: 'Para mantenerla activa, actualiza esta suscripción en los ajustes de suscripciones de tu tienda de aplicaciones.',
			coachPaymentFailedTitle: 'Tu pago de entrenador no se ha completado',
			coachPaymentFailed: 'No hemos podido cobrar tu suscripción de entrenador. Seguiremos intentándolo, pero si no se completa, tu acceso terminará el {date}.',
			coachPaymentFailedNoDate: 'No hemos podido cobrar tu suscripción de entrenador. Seguiremos intentándolo, pero si no se completa, perderás el acceso.',
			coachNotRenewingTitle: 'Tu plan de entrenador no se renovará',
			coachNotRenewing: 'Tu suscripción de entrenador ya no está configurada para renovarse. Mantendrás el acceso hasta el {date}.',
			coachNotRenewingNoDate: 'Tu suscripción de entrenador ya no está configurada para renovarse.',
			coachPlanStoppedTitle: 'Tu plan de entrenador no está activo',
			coachPlanStopped: 'Tu suscripción de entrenador no está activa. No se ha eliminado nada: todo volverá en cuanto la suscripción esté activa de nuevo.',
			coachClientsWillLoseAccess: 'Esto también afecta a {count} de tus clientes, que perderá{{|n}} el acceso Premium que cubre.',
			coachClientsLostAccess: 'Esto también afecta a {count} de tus clientes, que ya no tiene{{|n}} el acceso Premium que cubría.',
			memberPaymentFailedTitle: 'Tu último pago no se ha completado',
			memberPaymentFailed: 'No hemos podido procesar tu pago. Seguiremos intentándolo y, mientras tanto, tu suscripción sigue activa. Si el pago sigue fallando, tu suscripción finalizará el {date}.',
			memberPaymentFailedNoDate: 'No hemos podido procesar tu pago. Seguiremos intentándolo y, mientras tanto, tu suscripción sigue activa. Si el pago sigue fallando, tu suscripción finalizará.',
			memberPaymentFailedViewMembership: 'Ver Suscripción',
		},
		success: {
			weightChange: 'Tu cambio de peso estimado es {direction} {amount}{unit} / semana.',
			viewProgress: 'Ver progreso',
		},
		info: {
			notEnoughWeightData: 'Necesitamos algunos pesajes más para estimar tu tendencia semanal.',
		},
		badges: {
			mealPlanner: 'Planificador de comidas',
			mealPlannerInfo: 'Esta comida se generó con el Planificador de comidas, diseñado para ajustarse a tus objetivos de macros. Los nutrientes estarán cerca de tus objetivos, aunque ligeras variaciones permiten flexibilidad y variedad de alimentos.',
			macrosMatch: 'En objetivo',
			macrosMatchInfo: 'Los macros de esta comida están dentro del 5 % de tus objetivos. ¡Buen trabajo!',
		},
		buttons: {
			logMacrosManually: 'Registrar macros manualmente',
			reschedule: 'Reprogramar',
			markAsComplete: 'Marcar como hecho',
			addFood: 'Añadir alimento',
			logWeight: 'Registrar peso',
			resume: 'Reanudar',
			start: 'Empezar',
			done: 'Hecho',
		},
		skippedWorkout: {
			message: 'Entrenamiento movido al {date}.',
			moveToToday: 'Mover a hoy',
			moveToTodayButton: 'Mover a Hoy',
			restore: 'Restaurar',
		},
		noWorkout: {
			nextWorkout: 'El próximo entrenamiento es el {day}.',
			message: 'Entrena hoy si quieres.',
		},
	},
	unsavedChanges: {
		title: '¿Aplicar cambios?',
		alerts: {
			incompleteData: 'Los datos están incompletos y no se pueden guardar. ¿Qué quieres hacer?',
			applyChanges: 'Tienes cambios sin guardar. ¿Quieres aplicarlos antes de salir?',
		},
		errors: {
			saveFailed: 'No se han podido guardar tus cambios. Tu trabajo sigue aquí - inténtalo de nuevo.',
		},
		buttons: {
			keepEditing: 'Seguir editando',
		},
		discard: {
			feedbackTitle: '¿Descartar tus comentarios?',
			feedbackMessage: 'Todavía no los has enviado. Si sales ahora, lo que has escrito se perderá.',
			coachMessageTitle: '¿Descartar tu mensaje?',
			coachMessageMessage: 'Todavía no lo has enviado. Si sales ahora, lo que has escrito se perderá.',
			noteTitle: '¿Descartar tu nota?',
			noteMessage: 'Todavía no has guardado esta nota. Si sales ahora, lo que has escrito se perderá.',
			brandingTitle: '¿Descartar los cambios de tu marca?',
			brandingMessage: 'Todavía no los has guardado. Si sales ahora, tu logotipo, color y nombre volverán a ser los de antes.',
			checkupTitle: '¿Salir del control semanal?',
			checkupMessage: 'Todavía no lo has terminado. Si sales ahora, las respuestas que has introducido se perderán.',
			coachTargetTitle: '¿Descartar tu objetivo de calorías?',
			coachTargetMessage: 'Todavía no lo has aplicado. Si sales ahora, el número que has escrito se perderá.',
			nutritionPlanTitle: '¿Descartar los cambios de calorías y macros?',
			nutritionPlanMessage: 'Todavía no los has guardado. Si sales ahora, los valores volverán a ser los de antes.',
			ingredientTitle: '¿Descartar los cambios de este ingrediente?',
			ingredientMessage: 'Todavía no los has guardado. Si sales ahora, la cantidad volverá a ser la de antes.',
		},
	},
	training: {
		startWorkout: 'Empezar Entrenamiento',
		resumeWorkout: 'Reanudar Entrenamiento',
		openWorkout: 'Abrir Entrenamiento',
		skipWorkout: 'Saltar Hoy',
		editWorkout: 'Editar Entrenamiento {letter}',
		editWorkoutShort: 'Editar Entrenamiento',
		changeWorkout: {
			title: 'Entrenamiento diferente',
			description: 'Selecciona qué entrenamiento te gustaría realizar en esta fecha.',
			menuOption: 'Entrenamiento Diferente',
		},
		workoutChangedInfo: 'Este cambio solo se guardará cuando empieces el entrenamiento y completes al menos una serie. De lo contrario, se restablecerá al actualizar la app.',
		noWorkout: 'No hay entrenamiento programado para este día',
		noWorkoutScheduled: 'Sin Entrenamiento Programado',
		nextWorkoutOn: 'Tu próximo entrenamiento es el {day}.',
		trainAnyway: '¿Te gustaría entrenar hoy?',
		trainToday: 'Entrenar Hoy',
		workout: 'Entrenamiento',
		trainingProgram: {
			muscleVolume: 'Volumen Muscular',
			workoutLetter: 'Entrenamiento {letter}',
			sets: 'Series',
			myoReps: 'Myo-Reps',
			rmTesting: 'Prueba de RM',
			set: 'Serie',
			notCountedTitle: 'Aún Sin Contar',
			notCountedExplanation: 'Estos ejercicios no tienen un "Ejercicio Más Similar" definido, así que no podemos saber qué músculos trabajan. Toca uno para definirlo e incluirlo en el volumen de arriba.',
			notCountedUntrackedTitle: 'No Medido por el Programa',
			notCountedUntrackedExplanation: 'Estos ejercicios trabajan una zona del cuerpo que este programa no mide, así que no se pueden sumar a los totales de arriba. Los sigues haciendo y registrando como siempre.',
			notCountedSummary: '{count} sin contar',
		},
		goals: {
			muscleGrowth: 'Crecimiento muscular',
			bodyRecomposition: 'Recomposición corporal',
		},
		emptyProgramDay: {
			message: 'Este entrenamiento aún no tiene ejercicios.',
			editLink: 'Añadir ejercicios',
		},
	},
	schedule: {
		warnings: {
			mealBeforeWorkout: 'Puedes entrenar en ayunas, pero recomendamos hacer al menos una comida antes del entrenamiento.',
			mealAfterWorkout: 'Al menos una comida después de un entrenamiento ayuda a maximizar el crecimiento muscular.',
			minTimeBetweenMeals: 'Si hay menos de 3 horas entre dos comidas, puedes considerar combinarlas en una.',
			oneMealCloseToWo: 'Hacer una comida dentro de 1 hora antes o después del entrenamiento es beneficioso.',
			prePostWoMealDistance: 'Sugerimos colocar tu entrenamiento entre dos comidas, haciendo esas comidas con no más de 5 horas de diferencia.',
			shortFeedingWindow: 'El ayuno intermitente está bien, pero sugerimos que tu ventana de alimentación diaria total (el tiempo entre la primera y la última comida) dure al menos 8 horas.',
			workoutTimingIrregular: 'Entrena cuando puedas, pero sugerimos entrenar aproximadamente a la misma hora cada día (de entrenamiento).',
			mealTimingIrregular: 'Puedes comer cuando quieras, pero recomendamos hacer las comidas aproximadamente a las mismas horas cada día.',
			sleepTimingIrregular: 'Si puedes, recomendamos acostarte y levantarte de forma constante aproximadamente a las mismas horas cada día.',
			shortSleep: 'Si puedes dormir más, probablemente deberías hacerlo. Se recomienda encarecidamente al menos 8 horas cada noche.',
		},
		tips: 'Consejos de Horario',
	},
	editFood: {
		labelScanLowConfidence: 'Confianza baja — verifica los nutrientes manualmente',
		labelScanJsonRepaired: 'La respuesta de la IA se truncó — podrían faltar algunos nutrientes',
		placeholders: {
			enterName: 'Introduce un nombre',
		},
		labels: {
			servingSize: 'Tamaño de la porción',
			servingSizes: 'Medidas',
			measureName: 'Nombre de la medida',
			valuesPer: 'Por',
			instructions: 'Instrucciones',
			labelStyle: 'Estilo de Etiqueta',
			details: 'Detalles',
			source: 'Fuente:',
			barcode: 'Código de barras',
			noBarcode: 'Sin código de barras',
			macros: 'Macros',
			nutrients: 'Nutrientes',
			usLabel: 'Etiqueta EE. UU.',
			euLabel: 'Etiqueta UE',
			serving: 'Porción',
			portion: 'porción',
			perPortionOfWeight: '{per} {portion} de {weight}',
			foodName: 'Nombre del Alimento',
			image: 'Imagen',
			nutritionFacts: 'Información Nutricional',
			nutritionInformation: 'Información Nutricional',
			hideAdditionalNutrients: 'Ocultar nutrientes adicionales',
			showAdditionalNutrients: 'Mostrar nutrientes adicionales',
			description: 'Descripción',
		},
		buttons: {
			addServingSize: 'Añadir Medida',
			addImage: 'Añadir Imagen',
			scanBarcode: 'Escanear código de barras',
			log: 'Registrar',
			duplicate: 'Duplicar',
			delete: 'Eliminar',
			editFood: 'Editar Alimento',
			scanRecipe: 'Escanear Receta',
			useScannedBarcode: 'El que escaneé',
			useBarcodeOnLabel: 'El de la etiqueta',
			useAnyway: 'Usar de todos modos',
			doubleCheck: 'Déjame comprobarlo',
			share: 'Compartir Receta',
			unshare: 'Dejar de Compartir',
			importRecipe: 'Importar a Mis Recetas',
			recipeImported: 'Receta Importada',
			linkCopied: 'Enlace Copiado',
			updateAvailable: 'Actualización Disponible',
			refreshFromOriginal: 'Actualizar',
			originalUnavailable: 'La Receta Original Ya No Está Disponible',
			importedRecipe: 'Receta Importada',
			recipeRefreshed: 'Receta Actualizada',
			sharedRecipeInfo: 'Esta receta se compartió contigo.',
			shareFailed: 'No se pudo compartir la receta. Inténtalo de nuevo.',
			unshareFailed: 'No se pudo dejar de compartir la receta. Inténtalo de nuevo.',
			shareIngredientsFailed: 'Algunos ingredientes no se pudieron publicar. Es posible que la receta compartida no funcione correctamente para otros.',
		},
		titles: {
			newRecipe: 'Nueva receta',
			newFood: 'Nuevo alimento',
		},
		tabs: {
			overview: 'Resumen',
			ingredients: 'Ingredientes',
		},
		nutrients: {
			calories: 'Calorías',
			totalFat: 'Grasa Total',
			saturatedFat: 'Grasa Saturada',
			transFat: 'Grasa Trans',
			cholesterol: 'Colesterol',
			sodium: 'Sodio',
			totalCarbohydrate: 'Carbohidratos Totales',
			dietaryFiber: 'Fibra Dietética',
			totalSugars: 'Azúcares Totales',
			includesAddedSugars: 'Incluye Azúcares Añadidos',
			protein: 'Proteína',
			vitaminD: 'Vitamina D',
			calcium: 'Calcio',
			iron: 'Hierro',
			potassium: 'Potasio',
			energy: 'Energía',
			fat: 'Grasa',
			saturates: 'saturadas',
			carbohydrate: 'Carbohidratos',
			sugars: 'azúcares',
			fiber: 'Fibra',
			salt: 'Sal',
		},
		alerts: {
			inconsistentValues: '¡Los valores parecen inconsistentes!',
			confirmDelete: '¿Seguro que quieres eliminar este {type}?',
			removeBarcode: 'Eliminar código de barras',
			removeBarcodeMessage: '¿Quieres eliminar el código de barras {barcode} de este alimento?',
			confirmScannedBarcode: '¿Es el mismo producto?',
			confirmScannedBarcodeMessage: 'Escaneaste el código de barras {barcode}, pero no se encontró ningún código de barras en esta etiqueta. ¿Quieres asignar ese código a este nuevo alimento?',
			barcodeMismatch: 'Dos códigos de barras distintos',
			barcodeMismatchMessage: 'Escaneaste {scanned}, pero la etiqueta muestra {onLabel}. ¿Cuál pertenece a este alimento?',
			foodSourceBody: '{attribution}\n\n{trustNote}',
		},
		errors: {
			caloriesInconsistent: '¡Las calorías son inconsistentes con los valores de macronutrientes! Se esperaban alrededor de {expectedCalories} kcal.',
			nameRequired: 'El nombre del alimento es obligatorio.',
			ingredientRequired: 'Se debe añadir al menos un ingrediente.',
			portionRequired: 'El tamaño de la porción es obligatorio.',
			nutrientMissing: 'Falta un nutriente clave.',
			measureWeightRequired: 'Introduce el peso en gramos',
		},
		messages: {
			barcodeExists: 'El código de barras ya existe en este alimento.',
		},
		types: {
			recipe: 'receta',
			food: 'alimento',
		},
		foodSources: {
			appRecipe: {
				name: 'Receta de MH Physique',
				shortName: 'Receta',
				description: 'Receta proporcionada y verificada por el equipo de la app MH Physique.',
			},
			community: {
				name: 'Alimento creado por la comunidad',
				shortName: 'Comunidad',
				description: 'Alimento creado por la comunidad de la app MH Physique.',
			},
			staple: {
				name: 'Alimento básico de MH Physique',
				shortName: 'Básico',
				description: 'Un alimento común revisado por el equipo de MH Physique, creado a partir de bases de datos de alimentos fiables.',
			},
		},
		sourceFoods: {
			header: 'Creado a Partir de Estos Alimentos',
			row: '{name} ({database})',
			nameUnavailable: 'Nombre No Disponible',
		},
		trustLevel: {
			official: 'Esta es una información de alimentos **muy precisa** obtenida de bases de datos verificadas.',
			crowdsource: 'Esta información de alimentos procede de una base de datos editable públicamente. A menudo pueden existir errores. **¡Verifica los valores tú mismo antes de usarla!**',
			community: 'Esta información de alimentos la proporciona la comunidad de la app MH Physique. Suele ser de alta calidad, pero pueden existir errores. **¡Verifica los valores tú mismo antes de usarla!**',
		},
	},
	editMeal: {
		basedOn: 'Basado en {name}, {day}',
		recipeInstructions: 'Instrucciones de {name}',
		macrosLogged: 'Macros Registrados',
		macrosRemaining: 'Macros Restantes',
		dayMacrosLogged: 'Macros del Día Registrados',
		dayMacrosRemaining: 'Macros del Día Restantes',
		instructions: 'Instrucciones',
		skippedNotice: 'Te has saltado esta comida, así que sus alimentos no cuentan en los totales del día.',
		buttons: {
			clear: 'Vaciar',
			saveAsRecipe: 'Guardar como Receta',
			copyFrom: 'Copiar de un día',
			scanMeal: 'Escanear Comida',
		},
		addToMeal: {
			title: 'Añadir a esta comida',
			addFoodsDescription: 'Busca alimentos, recetas y comidas',
			scanBarcode: 'Escanear código de barras',
			scanBarcodeDescription: 'Un producto envasado',
			scanLabel: 'Escanear etiqueta',
			scanLabelDescription: 'Fotografía la tabla nutricional',
			logMacrosManuallyDescription: 'Escribe las cifras directamente',
			scanMealDescription: 'Fotografía tu plato',
			autoSuggestionsDescription: 'Completa la comida hasta tus objetivos restantes',
			copyFromDescription: 'La misma comida de otro día',
			short: {
				addFoods: 'Añadir',
				scanBarcode: 'Código',
				scanLabel: 'Etiqueta',
				logMacrosManually: 'Macros',
				scanMeal: 'Comida',
				autoSuggestions: 'Sugerencias',
				copyFrom: 'Copiar día',
			},
		},
		placeholders: {
			recipeName: 'Introduce el nombre de la receta',
		},
		labels: {
			recipeName: 'Nombre de la receta',
		},
		alerts: {
			clearMealTitle: '¿Vaciar {mealName}?',
			deleteMealTitle: '¿Eliminar {mealName}?',
			clearMealMessage: '¿Seguro que quieres vaciar el contenido de esta comida?',
			deleteMealMessage: '¿Seguro que quieres eliminar esta comida?',
			cannotTuneTitle: 'No se puede ajustar',
			cannotTuneMessage: 'Esta comida no se puede ajustar para cumplir tus objetivos.\n\nEl ajuste automático funciona cambiando la cantidad de cada alimento de la comida, así que necesita margen para trabajar. Prueba a añadir otro alimento, o uno de otro grupo.',
			splitRecipesTitle: '¿Dividir recetas?',
			splitRecipesMessage: 'Para ajustar una receta, hay que dividirla en ingredientes individuales. ¿Quieres hacerlo ahora?',
			splitAndTune: 'Dividir y Ajustar',
			tuneSuccessTitle: 'Consejos de ajuste',
			tuneSuccessMessage: 'La comida se ajustó lo más posible, pero no puede cumplir del todo los objetivos con estos ingredientes.\n\nEl ajuste automático funciona mejor con una comida completa que contenga una mezcla razonable de proteína, grasa, carbohidratos e, idealmente, fuentes de fibra.',
			mealOnTarget: 'La comida ya está en el objetivo',
			copyFromNoMatchTitle: 'Nada que copiar',
			copyFromNoMatchMessage: 'No registraste {mealName} el día que elegiste. Elige otro día o añade los alimentos a esta comida manualmente.',
			cannotTuneLockedTitle: 'No queda nada que ajustar',
			cannotTuneLockedMessage: 'Parte de esta comida está bloqueada o se introdujo como macros a mano, y el ajuste automático no puede cambiar ninguna de las dos cosas. Lo que queda no le basta para trabajar.\n\nDesbloquea un alimento, o sustituye una entrada escrita a mano por un alimento real, e inténtalo de nuevo.',
		},
		toasts: {
			mealTuned: 'La comida se ajustó.',
			undoTuneFailed: 'No se pudo dejar la comida como estaba.',
			mealAlreadyOptimal: 'Esta comida ya está todo lo cerca de tus objetivos que el ajuste automático puede dejarla.',
		},
		errors: {
			couldNotSizeSuggestions: 'Ahora mismo no se han podido ajustar las sugerencias a tus objetivos. Inténtalo de nuevo.',
			autoTuneFailed: 'El ajuste automático ha tenido un problema y no ha podido ajustar esta comida. Inténtalo de nuevo.',
		},
	},
	mealPlan: {
		title: 'Planificador de Comidas',
		dailyMacroTargets: 'Objetivos Diarios de Macros',
		emptyState: {
			selectDatesTitle: 'Selecciona fechas para empezar',
			selectDatesSubtext: 'El Planificador de Comidas genera automáticamente comidas que se ajustan a tus objetivos diarios de macros. Selecciona los días para los que quieres generar comidas.',
		},
		labels: {
			startDate: 'Fecha de Inicio',
			numberOfDays: 'Número de Días',
		},
		duration: {
			days7: '7 días',
			days14: '14 días',
			untilSunday: 'Hasta el próximo domingo',
			untilSaturday: 'Hasta el próximo sábado',
		},
		buttons: {
			generateMeals: 'Generar Comidas',
			favorite: 'Favorito',
			dontSuggest: 'No Sugerir de Nuevo',
			copyMeals: 'Copiar Comidas',
			acceptAll: 'Aceptar Todo',
			editMeal: 'Editar Comida',
			viewDetails: 'Ver Detalles',
		},
		exitDialog: {
			title: 'Salir del Planificador de Comidas',
			message: 'No has planificado todas tus comidas para el rango de fechas seleccionado. ¿Cómo quieres continuar?',
			saveAndExit: 'Guardar mis selecciones de comidas actuales.',
			keepPlanning: 'Seguir planificando el resto de mis comidas.',
			discardAndExit: 'Salir y no guardar mis cambios.',
		},
		errors: {
			saveFailed: 'No se ha podido guardar tu plan de comidas. Tus días planificados siguen aquí: inténtalo de nuevo.',
			dayCouldNotBeOpened: 'No se ha podido abrir el {day} para planificarlo, así que se ha omitido. Tus otros días no se ven afectados.',
		},
		copyDialog: {
			title: 'Copiar Comida a Otros Días',
			message: 'Selecciona los días a los que quieres copiar {meals}.',
			selectAll: 'Seleccionar Todo',
			copyButton: 'Copiar Comidas',
			multipleMeals: '{count} comidas',
		},
	},
	mealSuggestions: {
		title: 'Sugerencias de Comidas',
		replaceMealTitle: 'Reemplazar comida',
		match: 'Coincidencia',
		targets: 'Objetivos',
		buttons: {
			viewRecipe: 'Ver receta',
			addMeal: 'Añadir comida',
			replace: 'Reemplazar',
		},
		errors: {
			serviceUnavailable: 'No se puede conectar con el servicio de planificación de comidas, inténtalo de nuevo más tarde.',
			recipeLibraryNotReady: 'Estamos preparando tu biblioteca de recetas; inténtalo de nuevo en un minuto.',
		},
	},
	editNutritionPlan: {
		title: 'Editar plan de nutrición',
		description: 'Solo deberías editar tu plan de nutrición si sabes cuántas calorías y macros debes consumir según tu propio seguimiento.',
		caloriesLabel: 'Calorías',
		macronutrients: 'Macronutrientes',
		autoAdjustLabel: 'Ajustar macros automáticamente',
		autoAdjustTooltip: 'Cuando está activado, los objetivos de macronutrientes se recalculan automáticamente para mantener las proporciones óptimas al cambiar tu objetivo de calorías. Cuando está desactivado, los objetivos de macros se mantienen fijos independientemente de los cambios en las calorías.',
		proteinLabel: 'Proteína',
		carbsLabel: 'Carbohidratos',
		fatLabel: 'Grasa',
		fiberLabel: 'Fibra',
		recommendedHint: 'Recomendado: {value}',
		carbFatRatioLabel: 'Proporción de calorías carbohidratos/grasa',
		resetRecommended: 'Restablecer valores',
		calorieOvershoot: 'Los objetivos de macros superan tu objetivo de calorías',
		couldNotComputeTargets: 'No hemos podido calcular tus objetivos nutricionales ahora mismo, así que esta pantalla no se puede abrir. Inténtalo de nuevo en un momento.',
	},
	addMacros: {
		title: 'Registrar macros manualmente',
		defaultFoodName: 'Mi alimento personalizado',
		labels: {
			foodName: 'Nombre del alimento',
		},
		placeholders: {
			enterFoodName: 'Introduce el nombre del alimento',
		},
		warnings: {
			caloriesMismatch: 'Las calorías no coinciden con los macros definidos',
		},
	},
	reschedule: {
		labels: {
			date: 'Fecha',
			weighIn: 'Pesaje',
			wakeUp: 'Despertar',
			time: 'Hora',
			item: 'Elemento',
			meal: 'Comida',
		},
		weighInHelpText: 'Pésate en ayunas por la mañana después de ir al baño.',
		weekdaySelect: {
			placeholder: 'Selecciona un día de la semana',
			currentBadge: 'Actual',
		},
		options: {
			thisDayOnly: {
				title: 'Aplicar solo a este día',
				description: 'Aplicar solo a este {weekday}.',
			},
			allDays: {
				title: 'Aplicar a todos los días',
				descriptionWakeUp: 'Establecer esta como mi hora de despertar para todos los días.',
				descriptionWorkout: 'Establecer esta como mi hora de entrenamiento para todos los entrenamientos.',
				description: 'Establecer esta como mi hora de {itemName} para todos los días.',
			},
			thisWeekday: {
				title: 'Aplicar a este día de la semana',
				descriptionWorkout: 'Mover permanentemente este entrenamiento a esta hora los {weekday}.',
				descriptionWakeUp: 'Establecer esta como mi hora de despertar los {weekday}.',
				description: 'Establecer esta como mi hora de {itemName} los {weekday}.',
			},
		},
		title: 'Reprogramar {item}',
		titleWakeUpWeighIn: 'Reprogramar despertar y pesaje',
		errors: {
			timeAlreadyUsed: 'Esta hora ya la usa la comida {mealNumber}. Elige otra hora.',
		},
	},
	pinnedNote: {
		viewTitle: 'Notas fijadas',
		description: 'Las notas fijadas permanecen visibles cada vez que haces este ejercicio.',
		placeholder: 'Ej. Escribe consejos de equipamiento o recordatorios que siempre quieras tener a mano.',
		title: 'Crear nota fijada',
		titleEdit: 'Editar nota fijada',
	},
	setNote: {
		viewTitle: 'Nota de serie',
		title: 'Nota de serie',
		titleEdit: 'Editar nota de serie',
		description: 'Una nota de serie es para 1 serie específica de un entrenamiento. Puedes verla en la página del entrenamiento y en las estadísticas del historial del ejercicio.',
		placeholder: 'Ej. Notas sobre esta serie en concreto...',
	},
	editIngredient: {
		title: 'Editar ingrediente',
		logMacrosTitle: 'Registrar macros manualmente',
		viewDetails: 'Ver detalles',
		details: 'Detalles',
		date: 'Fecha',
		meal: 'Comida',
		foodName: 'Nombre del alimento',
		amount: 'Cantidad',
		foods: 'Alimentos',
		splitTitle: 'Dividir en alimentos individuales',
		splitDescription: 'Esta receta está registrada actualmente como un solo elemento. ¿Quieres dividirla en sus ingredientes separados para poder ajustar las cantidades?',
		splitIntoFoods: 'Dividir en alimentos',
		splitAndAutoTune: 'Dividir y autoajustar alimentos',
		splitMealDescription: 'Divide esta comida en alimentos individuales y autoajusta sus cantidades para adaptarse a tus objetivos.',
		splitMealDescriptionNoTargets: 'Divide esta comida en alimentos individuales para poder ajustar sus cantidades.',
		splitTuneNoSolutionToast: 'Tus alimentos se han dividido, pero el ajuste automático no ha encontrado cantidades que cumplan tus objetivos. Prueba a añadir otro alimento o ajusta las cantidades tú mismo.',
		splitTuneNoSolutionLockedToast: 'Tus alimentos se han dividido, pero parte de esta comida está bloqueada o se introdujo como macros a mano, y el ajuste automático no puede cambiar ninguna de las dos cosas. Desbloquea un alimento o sustituye una entrada escrita a mano, e inténtalo de nuevo.',
		caloriesMismatchWarning: 'Según la cantidad de macronutrientes, este alimento debería tener aproximadamente {expectedCalories} calorías.',
		foodAddedToast: '{food} {amount} añadido a {meal}',
		foodAddedToastNoDestination: '{food} {amount} añadido',
		undoFailedToast: 'No se pudo quitar ese alimento — la comida ha cambiado desde que lo añadiste.',
		inconsistentNutrientsWarning: 'Las calorías indicadas para este alimento no coinciden con su proteína, grasa y carbohidratos, que dan unas {expectedCalories} kcal por 100 g. Revisa los números antes de registrarlo, o elige otra opción.',
		refuseHint: {
			withParts: 'Pésalo sin {parts}. Aproximadamente el {percent}% del peso tal como se compra no se come.',
			percentOnly: 'Los valores corresponden a la parte comestible. Aproximadamente el {percent}% del peso tal como se compra no se come.',
			partsOnly: 'Pésalo sin {parts}.',
			withPartsRough: 'Pésalo sin {parts} para una cantidad exacta. Si lo pesas antes, normalmente se retira alrededor del {percent} %, pero esto varía mucho.',
			percentOnlyRough: 'Los valores corresponden a la parte comestible. Pésalo después de prepararlo para una cantidad exacta: normalmente se retira alrededor del {percent} %, pero esto varía mucho.',
		},
		refuseParts: {
			shell: 'cáscara',
			tail: 'cola',
			bone: 'hueso',
			skin: 'piel',
			fat: 'grasa',
			peel: 'cáscara',
			pit: 'hueso',
			seeds: 'semillas',
			core: 'corazón',
			stem: 'tallo',
			leaves: 'hojas exteriores',
			rind: 'corteza',
			pod: 'vaina',
			husk: 'farfolla',
			cob: 'mazorca',
			top: 'parte superior',
			root: 'raíz',
			trimmings: 'recortes',
		},
		weighedWith: {
			withParts: 'Pesado con {parts}',
			asBought: 'Pesado tal como se compra',
		},
		weighedWithNote: {
			typical: 'Se cuentan {weight} consumidos: se descuenta el {percent}% del peso.',
			rough: 'Se cuentan unos {weight} consumidos: normalmente se retira alrededor del {percent}%, pero esto varía mucho.',
		},
	},
	ingredientSearch: {
		addFood: 'Añadir alimento',
		customFood: 'Alimento personalizado',
		emptyState: {
			title: 'Selecciona alimentos para tu comida',
			titleRecipe: 'Aún no se han añadido alimentos',
		},
		buttons: {
			clearMeal: 'Vaciar comida',
			lock: 'Bloquear',
			unlock: 'Desbloquear',
			viewAll: 'Ver todo',
			addFoods: 'Añadir alimentos',
			logMacrosManually: 'Registrar macros manualmente',
			autoSuggestions: 'Autosugerencias',
			editServingSize: 'Editar tamaño de porción',
			viewFoodDetails: 'Ver detalles del alimento',
			splitIntoFoods: 'Dividir en alimentos',
			lockFood: 'Bloquear alimento',
			unlockFood: 'Desbloquear alimento',
			removeFood: 'Quitar alimento',
			reorder: 'Reordenar',
			done: 'Listo',
		},
		tooltips: {
			lockFood: 'Bloquear un alimento evita que se modifique al autoajustar la comida.',
		},
		alerts: {
			removeTitle: '¿Quitar ingrediente?',
			removeMessage: '¿Seguro que quieres quitar {name}?',
		},
		errors: {
			foodDoesNotExist: 'El alimento no existe',
		},
		titleMeal: 'Alimentos',
		repeatMeal: {
			sectionTitle: 'Repetir una comida reciente',
			lastTimeIn: 'La última vez en {meal}',
			add: 'Añadir de Nuevo',
			addedToast: '{count} {{alimento|alimentos}} añadido{{|s}} a {meal}',
			addedToastNoDestination: '{count} {{alimento|alimentos}} añadido{{|s}}',
			undoFailedToast: 'No se han podido quitar esos alimentos: la comida ha cambiado desde que los añadiste.',
			couldNotRepeatToast: 'No se ha podido añadir esa comida: ya no contiene ningún alimento.',
		},
		splitToast: 'Dividido en {count} {{alimento|alimentos}}',
		splitUndoFailedToast: 'No se ha podido deshacer la división: la comida ha cambiado desde entonces.',
	},
	editExercise: {
		titles: {
			createExercise: 'Crear ejercicio',
			editExercise: 'Editar {name}',
			viewExercise: '{name}',
			relativeStrengthStandard: 'Estándar de fuerza relativa',
			absoluteStrengthStandard: 'Estándar de fuerza absoluta ({gender})',
		},
		labels: {
			name: 'Nombre',
			id: 'ID',
			shortName: 'Nombre corto',
			advancedSettings: 'Ajustes avanzados',
			instructions: 'Instrucciones',
			videoUrl: 'URL del vídeo',
			equipmentTemplate: 'Equipamiento',
			bodyweightPercent: '% del peso corporal',
			myoRep: '¿Ejercicio de myo-reps?',
			rmTesting: '¿Usar prueba de RM?',
			referenceExercise: 'Ejercicio de referencia',
			oneRMFactor: 'Factor de 1RM %',
			bodyWeight: 'Peso corporal',
			similarExercise: 'Ejercicio más similar',
		},
		placeholders: {
			exerciseName: 'Introduce el nombre del ejercicio',
			shortName: 'Introduce el nombre corto',
			instructions: 'Introduce las instrucciones del ejercicio',
			videoUrl: 'Pega un enlace de YouTube o Vimeo',
			selectTemplate: 'Selecciona...',
			selectExercise: 'Selecciona ejercicio',
		},
		hints: {
			bodyweightPercent: 'El porcentaje de tu peso corporal que levantas en el movimiento.',
			similarExercise: 'Esto determina la musculatura objetivo.',
		},
		buttons: {
			addImage: 'Añadir imagen',
			previewInstructions: 'Previsualizar instrucciones',
			addAbsoluteStandard: 'Añadir estándar absoluto',
			addRelativeStandard: 'Añadir estándar relativo',
			addWeightCategory: 'Añadir categoría de peso',
			importExercise: 'Importar',
			refreshFromOriginal: 'Actualizar',
			revertToOriginal: 'Revertir al original',
			checkForUpdate: 'Buscar actualización',
		},
		messages: {
			exerciseNotFound: 'Este ejercicio ya no está disponible.',
			exerciseUnreadable: 'No se pudo cargar este ejercicio ahora mismo. Vuelve atrás e inténtalo de nuevo en un momento.',
			sharedWithYou: 'Este ejercicio se compartió contigo.',
			youOwnThisExercise: 'Eres el autor de este ejercicio.',
			updateAvailable: 'Hay disponible una versión actualizada de este ejercicio.',
			originalUnavailable: 'El ejercicio compartido original ya no está disponible.',
			importedExercise: 'Ejercicio importado',
			basedOn: 'Basado en: {name}',
		},
		toasts: {
			exerciseImported: 'Ejercicio importado',
			importFailed: 'No se pudo importar el ejercicio',
			exerciseRefreshed: 'Ejercicio actualizado',
			refreshFailed: 'No se pudo actualizar el ejercicio',
			exerciseCustomized: 'Ejercicio personalizado',
			revertedToOriginal: 'Revertido al original.',
			originalNoLongerAvailable: 'El original ya no está disponible.',
			couldNotReachExercises: 'No se pudo acceder a tus ejercicios ahora mismo. Inténtalo de nuevo en un momento.',
			checkForUpdateOffline: 'No se pudo buscar actualizaciones; parece que estás sin conexión.',
			partialUpdateApplied: '{count} cambio(s) aplicado(s) desde el origen.',
			saveFailed: 'No se pudo guardar el ejercicio',
		},
		alerts: {
			saveAndExit: {
				title: '¿Guardar y salir?',
				message: '¿Seguro que quieres guardar tus cambios y salir de la página?',
			},
			revertToOriginal: {
				title: '¿Revertir al original?',
				message: '¿Descartar tus cambios y restaurar el original?',
			},
			updateAvailable: {
				title: 'Actualización disponible',
				acceptButton: 'Aceptar cambios',
				ignoreButton: 'Ignorar',
				cancelButton: 'Cancelar',
				updateRevisionButton: 'Actualizar revisión',
				noVisibleChangesBody: 'No hay cambios visibles para el usuario.',
				alreadyUpToDateToast: 'Ya está actualizado',
				pickerApplyButton: 'Aplicar ({count})',
				pickerIgnoreButton: 'Ignorar',
				pickerCheckboxHint: 'Selecciona los cambios que quieres tomar del origen.',
				pickerCurrentDescription: 'Descripción actual',
				pickerUpdatedDescription: 'Descripción actualizada',
				toggledOn: 'Activado',
				toggledOff: 'Desactivado',
				descriptionChanged: 'Descripción cambiada',
				standardChanged: 'Estándar de fuerza cambiado',
				empty: '(vacío)',
				fieldDiffLabels: {
					name: 'Nombre',
					shortname: 'Nombre corto',
					description: 'Descripción',
					videoUrl: 'URL del vídeo',
					bw_pc: '% del peso corporal',
					allowMyoReps: 'Myo-reps permitidas',
					avoidRMTesting: 'Evitar prueba de RM',
					standard: 'Estándar de fuerza',
					equipmentTemplateId: 'Equipamiento',
					similarExerciseId: 'Ejercicio similar',
				},
			},
		},
		errors: {
			invalidName: 'Nombre no válido',
			unknownButton: 'Botón de edición de equipamiento desconocido {button}',
		},
	},
	exerciseSwitch: {
		titles: {
			changeExercise: 'Cambiar ejercicio',
			addExercise: 'Añadir ejercicio',
			pickExercise: 'Elegir ejercicio',
		},
		placeholders: {
			searchExercise: 'Escribe el nombre de un ejercicio...',
		},
		filters: {
			all: 'Todos',
			recommended: 'Recomendados',
			myExercises: 'Mis ejercicios',
			suggested: 'Sugeridos',
			filterByCategory: 'Filtrar por categoría',
		},
		messages: {
			recommendationInfo: 'Te recomendamos los siguientes ejercicios como reemplazo, de más a menos recomendado.',
		},
		buttons: {
			statsAndNotes: 'Estadísticas y notas',
			description: 'Descripción',
			modify: 'Modificar',
			delete: 'Eliminar',
			share: 'Compartir',
			checkForUpdate: 'Buscar actualización',
			update: 'Actualizar',
			createExercise: 'Crear ejercicio',
			save: 'Guardar',
			add: 'Añadir',
		},
		indicators: {
			updateAvailable: 'Actualización disponible',
		},
		emptyState: {
			noResultsTitle: 'No se encontraron resultados',
			noResultsSubtext: 'Prueba con otro término de búsqueda',
		},
		alerts: {
			deleteExercise: {
				title: 'Eliminar ejercicio',
				message: '¿Seguro que quieres eliminar "{name}"? {extra}',
				neverUsed: 'Nunca se usó en un entrenamiento, así que se eliminará para siempre.',
				wasUsed: 'Se usó en un entrenamiento. Se marcará como eliminado y no aparecerá en la lista de ejercicios, pero podrás restaurarlo más tarde.',
			},
		},
		removeExercise: {
			title: 'Quitar ejercicio',
			message: '¿Seguro que quieres quitar {exercise} del entrenamiento {workout}?',
		},
		linkWorkouts: {
			title: '¿Compartir progresión?',
			message: '{exercise} ya está en {workouts}. Si también lo usas aquí, ambos entrenamientos comparten una sola progresión: los mismos pesos y repeticiones, y un cambio posterior en este ejercicio en un entrenamiento también lo cambia en el otro.',
			workoutName: 'el entrenamiento {workout}',
			share: 'Compartir progresión',
		},
		alreadyInWorkout: {
			title: 'Ya está en este entrenamiento',
			message: '{exercise} ya está en el entrenamiento {workout}. Elige otro ejercicio o, si lo prefieres, elimina el que estás cambiando.',
		},
		errors: {
			workoutNotFound: 'No se encontró el entrenamiento {workoutId}',
			noSelectedItem: 'No hay ningún elemento seleccionado al aceptar el cambio de ejercicio',
		},
		coachBadge: {
			label: 'Entrenador',
			info: 'De tu entrenador {coachName}',
			infoNoName: 'De tu entrenador',
		},
	},
	editTrainingProgram: {
		labels: {
			sets: '{count} {{serie|series}}',
		},
	},
	editWorkouts: {
		title: 'Editar entrenamientos',
		setsCount: '{count} series',
		rmTesting: 'Prueba de RM',
		myoReps: 'Myo-reps',
		repsCount: '{count} repeticiones',
		suggestedRepsCount: '~{count} repeticiones',
		dupRepsCount: '{heavy}/{light} repeticiones',
		suggestedDupRepsCount: '~{heavy}/{light} repeticiones',
		tupRepsCount: '{heavy}/{medium}/{light} repeticiones',
		suggestedTupRepsCount: '~{heavy}/{medium}/{light} repeticiones',
		buttons: {
			save: 'Guardar',
			revert: 'Revertir',
			deleteWorkout: 'Eliminar entrenamiento {name}',
		},
		menu: {
			volumeOptimization: 'Optimización de volumen',
			scanWorkout: 'Escanear entrenamiento',
			removeExercise: 'Quitar ejercicio',
			moveExercise: 'Mover ejercicio',
			moveExerciseTo: 'Mover ejercicio a...',
			workoutName: 'Entrenamiento {name}',
		},
		deleteWorkout: {
			confirmTitle: 'Eliminar entrenamiento',
			confirmMessage: '¿Seguro que quieres eliminar el entrenamiento {name}? Se quitarán todos los ejercicios de este entrenamiento.',
			cannotDeleteTitle: 'No se puede eliminar',
			cannotDeleteMessage: 'Debes tener al menos un entrenamiento.',
		},
		removeExercise: {
			cannotRemoveLastTitle: 'No se puede quitar',
			cannotRemoveLastMessage: 'Tu plan necesita al menos un ejercicio; de lo contrario, todos los entrenamientos estarían vacíos. Añade otro ejercicio primero, o cambia este por otro distinto.',
		},
		revert: {
			title: 'Revertir cambios',
			message: 'Elige cómo quieres revertir tus cambios:',
			undoMessage: 'Esto deshará todos los cambios hechos en esta sesión.',
			undoButton: 'Deshacer',
			undoSession: 'Deshacer cambios de la sesión',
			restoreOriginal: 'Restaurar plan original',
			noChangesTitle: 'Sin cambios',
			noChangesMessage: 'No has hecho ningún cambio en esta sesión.',
			notAvailableTitle: 'No disponible',
			notAvailableMessage: 'La copia de seguridad del plan original no está disponible para los planes creados antes de que se añadiera esta función.',
			confirmRestoreTitle: 'Restaurar plan original',
			confirmRestoreMessage: 'Esto restaurará tus entrenamientos al plan de la evaluación inicial o de la última actualización del programa. Se perderán todos los cambios hechos después de eso.',
			restoreButton: 'Restaurar',
		},
		toast: {
			exerciseMoved: 'Ejercicio movido al entrenamiento {workout}. ',
			view: 'Ver',
		},
		alerts: {
			reoptimizeConfirm: {
				message: '¿Quieres que la app actualice el volumen de series de tus ejercicios para que coincida con tu volumen semanal objetivo por grupo muscular? El orden de tus ejercicios y la distribución de tu entrenamiento no se verán afectados. Solo cambiarán tus series por ejercicio.',
				yes: 'Sí, reoptimizar mi volumen',
				no: 'No, no actualizar el volumen de mis ejercicios',
			},
			reoptimizeResult: {
				title: 'Volumen reoptimizado',
				noChanges: 'Tu volumen de series ya coincide con tus objetivos.',
			},
			reoptimizeLoading: 'Reoptimizando volumen...',
		},
		exercisesLoadFailed: {
			title: 'No se pudieron cargar tus ejercicios',
			message: 'Ahora mismo no se pudieron cargar tus ejercicios. Comprueba tu conexión y toca Intentar de nuevo.',
			saveRefused: 'No se pudieron cargar tus ejercicios, así que todavía no se ha guardado nada. Tus cambios se conservan. Comprueba tu conexión e inténtalo de nuevo.',
		},
		emptyWorkout: {
			title: 'Entrenamiento vacío',
			message: 'El entrenamiento {name} no tiene ejercicios. Añádele un ejercicio o elimínalo. Un entrenamiento vacío aparecería como un día en blanco en tu entrenamiento.',
			messageSeveral: 'Los entrenamientos {names} no tienen ejercicios. Añádeles ejercicios o elimínalos. Un entrenamiento vacío aparecería como un día en blanco en tu entrenamiento.',
			deleteSeveral: 'Eliminar entrenamientos vacíos',
		},
	},
	exerciseConfiguration: {
		loadFailed: {
			title: 'No se pudo cargar el ejercicio',
			message: 'Ahora mismo no se pudo cargar este ejercicio. Comprueba tu conexión e inténtalo de nuevo.',
		},
		labels: {
			muscleGroup: 'Grupo muscular',
			myoReps: 'Myo-reps',
			equivalentVolume: 'Volumen equivalente',
			volume: 'Volumen',
			myoRepsVolume: 'Volumen de myo-reps',
			rmTesting: 'Prueba de RM',
			repTarget: 'Repeticiones objetivo',
			heavyRepTarget: 'Repeticiones objetivo (pesado)',
			mediumRepTarget: 'Repeticiones objetivo (medio)',
			lightRepTarget: 'Repeticiones objetivo (ligero)',
			toBeDetermined: 'Por determinar',
		},
		options: {
			avoid: 'Evitar',
			prefer: 'Preferir',
			auto: 'Automático',
		},
		buttons: {
			save: 'Guardar',
		},
		myoRepsVolumeOneSeries: '1 serie de activación y {minisets} miniseries',
		myoRepsVolumeMultipleSeries: '{count} series de activación + {minisets} miniseries',
		repTargetInfo: 'Las repeticiones objetivo se determinarán durante tu próximo entrenamiento para este ejercicio.',
		repTargetInfoRMTesting: 'Las repeticiones objetivo se determinarán una vez completada la prueba de RM.',
		repTargetHint: {
			atLeast: 'Deben ser al menos {min} repeticiones',
			atMost: 'Deben ser como máximo {max} repeticiones',
			between: 'Deben estar entre {min} y {max} repeticiones',
			dupBanner: 'Las sesiones pesadas y ligeras usan distintas repeticiones objetivo. Mantenlas separadas al menos {gap} repeticiones.',
			tupBanner: 'Las sesiones pesadas, medias y ligeras usan distintas repeticiones objetivo. Mantén las sesiones adyacentes separadas al menos {gap} repeticiones.',
		},
		toast: {
			repTargetRequired: 'Las repeticiones objetivo no pueden estar vacías.',
			repTargetTooLow: 'Las repeticiones objetivo deben ser al menos {min} para este ejercicio.',
			dupLightTooLow: 'Las repeticiones objetivo ligeras deben ser al menos {min} (pesado + {gap}).',
			dupHeavyTooHigh: 'Las repeticiones objetivo pesadas deben ser como máximo {max} (ligero - {gap}).',
			tupLightTooLow: 'Las repeticiones objetivo ligeras deben ser al menos {min} (medio + {gap}).',
			tupMediumTooHigh: 'Las repeticiones objetivo medias deben ser como máximo {max} (ligero - {gap}).',
			tupMediumTooLow: 'Las repeticiones objetivo medias deben ser al menos {min} (pesado + {gap}).',
			tupHeavyTooHigh: 'Las repeticiones objetivo pesadas deben ser como máximo {max} (medio - {gap}).',
		},
		coach: {
			intensity: 'Intensidad',
			oneTarget: 'Un objetivo',
			nextSessionOnly: 'Solo la próxima sesión',
			nextWeight: 'Próximo peso',
			nextMinReps: 'Próximas repeticiones mínimas',
			dayHeavy: 'Día pesado',
			dayMedium: 'Día medio',
			dayLight: 'Día ligero',
			dayOne: 'Cada sesión',
			comesNext: 'Este día toca a continuación, en la próxima sesión de {exercise}.',
			nextSessionNote: 'La app los ajusta después de cada sesión. Un cambio solo se aplica a la próxima sesión.',
			lastSession: 'Última sesión: {weight} × {reps} el {date}.',
			calculatedFrom: 'Pesos calculados a partir de la mejor serie reciente, {weight} × {reps} el {date}. Puedes cambiarlos.',
			strengthTestNext: 'Se decidirá con una prueba de fuerza en la próxima sesión.',
			calculateWeights: 'Calcular pesos',
			historyUnreadable: 'No se pudieron leer los entrenamientos recientes, así que ahora no se puede cambiar la intensidad. Inténtalo de nuevo más tarde.',
			minRepsInvalid: 'Debe ser al menos 1 repetición, o quedar vacío.',
			strengthAtLastDeload: 'Fuerza en la última descarga',
			deloadStrength: '{strength}. Se considera estancamiento si una descarga queda por debajo de {limit}.',
			deloadStrengthNone: 'Todavía ninguna.',
			plateauWaiting: 'Pregunta de estancamiento pendiente desde el {date}. {client} aún no ha respondido. Cambiar la intensidad o el ejercicio la responde.',
			plateauWillAnswer: 'Al guardar se responde la pregunta de estancamiento pendiente desde el {date}. No se le preguntará a {client}.',
			volumeWaiting: 'Pregunta de volumen pendiente desde el {date}. {client} aún no ha respondido. Cambiar el volumen la responde.',
			volumeWillAnswer: 'Al guardar se responde la pregunta de volumen pendiente desde el {date}. No se le preguntará a {client}.',
			setAside: 'Apartado',
			setAsideNone: 'No',
			setAsidePlateau: '{exercise} se apartó el {date} tras un estancamiento, hasta el {until}.',
			setAsideWeakness: '{exercise} se apartó el {date} tras un resultado de punto débil, hasta el {until}.',
			bringBackNow: 'Recuperar ahora',
			broughtBack: '{exercise} volverá a estar disponible cuando guardes.',
			changes: 'Cambios',
			changesNone: 'Aún no hay cambios.',
			changeBy: '{who}: {what}',
			app: 'App',
			event: {
				plateau: 'Estancamiento detectado',
				deload: 'Descarga',
				weakness: 'Resultado de punto débil',
				volumeUp: 'Volumen aumentado en 1 serie',
				volumeDown: 'Volumen reducido en 1 serie',
			},
			field: {
				scheme: 'Intensidad {before} → {after}',
				targetReps: '{day}: repeticiones objetivo {before} → {after}',
				targetWeight: '{day}: próximo peso {before} → {after}',
				minReps: '{day}: próximas repeticiones mínimas {before} → {after}',
				volume: 'Volumen {before} → {after} series',
				myo: 'Myo-reps cambiado',
				rmTesting: 'Prueba de RM cambiada',
				setAsideCleared: 'Ejercicio apartado recuperado',
				plateauAnswered: 'Pregunta de estancamiento respondida',
				volumeQuestionAnswered: 'Pregunta de volumen respondida',
				none: '–',
			},
			advanced: 'Avanzado',
			plateauWaitingSelf: 'Pregunta de estancamiento pendiente desde el {date}. Cambiar la intensidad o el ejercicio la responde.',
			plateauWillAnswerSelf: 'Al guardar se responde la pregunta de estancamiento pendiente desde el {date}.',
			volumeWaitingSelf: 'Pregunta de volumen pendiente desde el {date}. Cambiar el volumen la responde.',
			volumeWillAnswerSelf: 'Al guardar se responde la pregunta de volumen pendiente desde el {date}.',
		},
	},
	equipment: {
		sections: {
			incrementWeights: 'Pesos de incremento',
			barbellWeight: 'Peso de la barra',
			stackedWeights: 'Pesos apilados',
			dumbbellWeights: 'Pesos de mancuernas',
			plates: 'Discos',
		},
		stack: {
			additionalMicroloading: 'Discos de "microcarga" adicionales (normalmente magnéticos) que puedes acoplar a esta pila si es necesario. Haz una entrada por cada disco.',
			additionalMicroloadingWeights: 'Discos de "microcarga" adicionales (normalmente magnéticos) que puedes acoplar a los pesos si es necesario. Haz una entrada por cada disco.',
			unsortedWeights: 'Los pesos están sin ordenar. Se reordenarán al guardar. O puedes pulsar Limpiar a la derecha para hacerlo ahora.',
		},
		labels: {
			template: '[Plantilla]',
			usedIn: 'Usado en: {exercises}',
			minimumWeight: 'Peso mínimo',
			weightIncrement: 'Incremento de peso',
			bar: 'Barra',
			from: 'Desde:',
			to: 'Hasta:',
			increments: 'Incrementos:',
			collarWeightOptional: 'Peso de las abrazaderas (opcional)',
			individualWeight: 'Peso individual',
			noPlatesYet: 'Aún no hay discos',
			filters: 'Filtros',
			equipmentType: 'Tipo de equipo',
			details: 'Detalles',
			name: 'Nombre',
			units: 'Unidades',
			microPlatesOptional: 'Microdiscos (opcional)',
			platesSummary: '{count} discos de {weight}',
			platesSummaryPairs: '{count} pares de {weight}',
			numberOfPairs: 'Número de pares',
			numberOfPlates: 'Número de discos',
			myEquipmentName: 'Mi {name}',
		},
		summary: {
			manual: 'Especificado manualmente con un mínimo de {min} e incrementos de {inc}',
			bar: 'Barra de {bar} con discos de {plates} (en pares)',
			barWithCollars: 'Barra de {bar} con collarines de {collars} y discos de {plates} (en pares)',
			stack: 'Máquina de placas que selecciona entre {weights}',
			freePlates: 'Discos sueltos: {plates}',
			withMicroloading: '{base} con microcarga {plates}',
			noPlates: 'sin discos',
			unknown: 'Equipo desconocido',
		},
		templates: {
			barbell: 'Barra',
			dumbbells: 'Mancuernas',
			plainPlates: 'Discos simples',
			freePlates: 'Discos sueltos',
			kettlebells: 'Pesas rusas',
			cableMachine: 'Máquina de poleas',
			customIncrements: 'Incrementos personalizados',
		},
		titles: {
			changeEquipment: 'Cambiar equipo',
			equipment: 'Equipo',
			createEquipment: 'Crear equipo',
		},
		placeholders: {
			search: 'Buscar',
			enterName: 'Introduce un nombre',
			noStackedWeights: 'No hay pesos apilados. Añade uno abajo.',
			noWeightsSet: 'No hay pesos configurados. Añade uno abajo.',
			selectTemplate: 'Seleccionar...',
		},
		filters: {
			all: 'Todos',
			suggested: 'Sugeridos',
			showTemplates: 'Mostrar plantillas',
			showMine: 'Mostrar los míos',
		},
		descriptions: {
			barPlates: 'Todos los pares de discos que tienes disponibles para esta barra. Haz una entrada por cada par.',
			plates: 'Discos libres sin barra (como para poner en una máquina o colgar de un cinturón). Los discos se usan de uno en uno, no en pares.',
			stack: 'Pesos apilados en un orden estricto. Normalmente en una máquina. Con discos de microcarga si los tienes.',
			manual: 'Usa esto para pesos que colocarás tú mismo manualmente. Debes poder disponer todos los pesos posibles en los incrementos indicados.',
		},
		notes: {
			barWeight: 'Peso de la barra en sí.',
			bothCollars: 'Ambas abrazaderas juntas pesan {weight}',
			keepEmptyCollars: 'Déjalo vacío si usas abrazaderas muy ligeras o ninguna (como en la mayoría de los gimnasios).',
		},
		buttons: {
			delete: 'Eliminar',
			duplicate: 'Duplicar',
			modify: 'Modificar',
			create: 'Crear',
			createEquipment: 'Crear equipo',
			addStackedWeight: 'Añadir peso apilado',
			addDumbbells: 'Añadir mancuernas',
		},
		messages: {
			wouldYouLike: '¿Te gustaría',
			noEquipmentDefined: 'Aún no has definido ningún equipo.',
			showingOnlyCustom: 'Mostrando solo tu equipo personalizado. Hay {count} elementos ocultos.',
			toCreateEquipment: 'que puedes usar para crear tu equipo',
		},
		emptyState: {
			noResultsTitle: 'No se encontraron resultados',
			noResultsSubtext: 'No encontramos coincidencias para tu búsqueda. Prueba a ajustar las palabras clave o los filtros y busca de nuevo.',
			chooseTemplate: {
				title: 'Elige una plantilla para empezar',
				subtext: 'Selecciona una plantilla de equipo arriba para desbloquear campos adicionales y crear tu nuevo tipo de equipo.',
			},
		},
		links: {
			showTemplates: 'mostrar las plantillas',
		},
		alerts: {
			deleteEquipment: {
				title: '¿Eliminar equipo?',
				subtitle: '¿Seguro que quieres eliminar {name}?',
				usedBy: 'Se usa en: {exercises}',
			},
		},
		errors: {
			unknownMode: 'Modo de búsqueda de equipo desconocido {mode}',
			unknownButton: 'Botón de búsqueda de equipo desconocido {button}',
			attemptToApplyTemplate: 'Intento de aplicar la plantilla {id} como equipo',
		},
		tutorial: {
			nameEquipment: 'Este es tu nuevo equipo basado en una plantilla oficial. Dale un nombre que reconozcas.',
			adjustValues: 'Estos son solo valores de ejemplo. ¡Asegúrate de ajustarlos a tu equipo concreto!',
			saveEquipment: 'Cuando estés seguro de que el equipo es correcto, pulsa aquí para guardarlo.',
		},
		validation: {
			invalidName: 'Nombre no válido',
			incrementHelp: 'Ajusta el "incremento" a la cantidad más pequeña en la que puedes subir el peso. Por ejemplo, si el disco más pequeño de una barra es de 0,5 kg, pon el incremento en 1 kg, porque tendrás que añadir dos discos.',
			minimumHelp: 'Ajusta el mínimo al peso más bajo que puedes usar en este ejercicio. Por ejemplo, el peso de una barra vacía.',
			barWeightRequired: 'El peso de la barra es obligatorio.',
			unknownField: 'Campo desconocido',
			unknownEquipmentType: 'Tipo de equipamiento desconocido',
		},
	},
	subscribe: {
		title: 'Suscribirse',
		restorePurchases: 'Restaurar compras',
		subscriptionTerms: 'El pago se cargará a tu cuenta de Apple ID al final de cualquier prueba gratuita. La suscripción se renueva automáticamente al precio indicado a menos que se cancele al menos 24 horas antes de que termine el periodo actual. Gestiona o cancela en cualquier momento en los ajustes de tu Apple ID.',
		privacyPolicy: 'Política de privacidad',
		eula: 'EULA',
		titles: {
			selectSubscription: 'Seleccionar suscripción',
			tryFree: 'Prueba gratis durante {period}',
			payment: 'Pago',
			subscribe: 'Suscribirse',
			startFreeTrial: 'Iniciar prueba gratuita',
		},
		messages: {
			paymentInitiated: 'Parece que has iniciado un pago que aún no has confirmado del todo.',
			confirmPayment: 'Confirma el pago con tu banco y luego ',
			thisPage: ' esta página.',
			paymentIssues: 'Si tienes cualquier problema con los pagos, no dudes en contactar con ',
			subscriptionInactive: 'Tu suscripción está inactiva. Si deseas renovarla, actualiza tu información de pago.',
			coachLapsedTitle: 'Tu acceso Premium está en pausa',
			coachLapsed: '{coachName} cubría tu acceso Premium, y ese acceso está pausado por ahora.',
			coachLapsedNoName: 'Tu entrenador cubría tu acceso Premium, y ese acceso está pausado por ahora.',
			coachLapsedStillConnected: 'Sigues conectado con tu entrenador. No se ha quitado nada de tu entrenamiento y tu acceso volverá automáticamente en cuanto la cobertura de tu entrenador esté activa de nuevo.',
			coachLapsedSubscribe: 'También puedes iniciar tu propia suscripción abajo.',
			noExpiration: 'Tu suscripción no tiene fecha de vencimiento, por lo que no necesitas extenderla.',
			ifPersists: 'Si esto persiste, contacta con ',
			alreadyHaveAccountPrefix: '¿Ya tienes una cuenta?',
			signIn: 'Iniciar sesión',
			redeemCode: 'Canjear un código de suscripción',
			crossPlatform: 'Tu suscripción está activa. Para gestionarla, usa el dispositivo donde te suscribiste.',
			membershipPaused: 'Tu membresía está en pausa, así que no está activa en este momento. Reanúdala desde tu perfil en lugar de comprar una nueva suscripción.',
			crossPlatformWeb: 'Tu suscripción está activa. Para gestionarla, inicia sesión en nuestro sitio web.',
			signedInAsPrefix: 'Has iniciado sesión como',
			signedInAsSuffix: '.',
			alreadyHaveSubscriptionPrefix: '¿Pagaste con otro correo electrónico?',
			alreadyHaveSubscriptionLink: 'Recibe un enlace de inicio de sesión',
			alreadyHaveSubscriptionSuffix: 'para esa cuenta.',
			installAppPromptTitle: 'Tu suscripción está activa',
			installAppPromptBody: '¿Quieres usar MH Physique también en tu teléfono?',
			continueAfterPurchase: 'Continuar',
			noStoreProductsTitle: 'No se pudieron cargar las opciones de suscripción',
			noStoreProductsBody: 'No pudimos cargar las opciones de suscripción en este dispositivo en este momento. Nuestro equipo ha sido notificado. Inténtalo de nuevo más tarde o contáctanos para recibir ayuda con tu suscripción.',
		},
		links: {
			reload: 'recargar',
		},
		labels: {
			savePrefix: 'Ahorra',
			trialDisclosure: '{period} de prueba gratis, luego {price}/{recurrence}',
		},
		recurrence: {
			month: 'mes',
			year: 'año',
		},
		trialPeriod: {
			days: '{count} {{día|días}}',
			weeks: '{count} {{semana|semanas}}',
			months: '{count} {{mes|meses}}',
			years: '{count} {{año|años}}',
		},
		notes: {
			billingInfo: 'Se cobra al inicio de cada ciclo. Los planes se renuevan automáticamente. Cambia de plan o cancela cuando quieras.',
			billingInfoTrial: '{period} gratis y luego se cobra al inicio de cada ciclo. Los planes se renuevan automáticamente. Cambia de plan o cancela cuando quieras.',
		},
		alerts: {
			emailMismatch: {
				title: 'El correo no coincide',
				message: 'No puedes pagar con un correo distinto al de tu cuenta. Usa el correo de tu cuenta o cierra sesión primero.',
			},
			accountExists: {
				title: 'La cuenta ya existe',
				message: 'Este correo ya está registrado en una cuenta. Primero tenemos que iniciar tu sesión...',
			},
			cantVerifyEmail: {
				title: 'No se puede verificar el correo',
				message: 'No se pudo contactar con nuestro servidor de registro. Inténtalo de nuevo más tarde o contacta con [support@mh-physique.app](mailto:support@mh-physique.app).',
			},
			checkEmail: {
				sendLinkTitle: 'Recibe un enlace de inicio de sesión',
				message: 'Introduce el correo electrónico con el que pagaste y te enviaremos un enlace de inicio de sesión.',
				sendLink: 'Enviar enlace',
				resendFailedTitle: 'No se pudo enviar el correo',
				resendFailedMessage: 'No pudimos enviar el correo de acceso. Comprueba tu conexión e inténtalo de nuevo.',
			},
			pricingFailed: {
				title: 'No se pudieron cargar los precios',
				message: 'No se pudieron cargar los precios de suscripción. Comprueba tu conexión e inténtalo de nuevo.',
			},
			pricingOffline: {
				title: 'Estás sin conexión',
				message: 'Los planes de suscripción no se pueden cargar sin conexión a internet. Conéctate a internet e inténtalo de nuevo.',
				tryAgain: 'Reintentar',
			},
			pricingUnavailable: {
				title: 'No se pudieron cargar los planes',
				message: 'No se pudieron cargar los planes de suscripción. Puede que un bloqueador de anuncios o una restricción de red los esté bloqueando. Inténtalo de nuevo o desactiva cualquier bloqueador de anuncios para este sitio.',
			},
			checkoutUnavailable: {
				title: 'No se pudo abrir el pago',
				message: 'No se pudo abrir el formulario de pago. No se te ha cobrado nada. Inténtalo de nuevo. Si vuelve a ocurrir, escribe a support@mh-physique.app.',
			},
			purchaseFailed: {
				title: 'La compra de la suscripción falló',
				message: 'No se pudo completar la compra de la suscripción. Inténtalo de nuevo.',
			},
			purchaseNotYetConfirmed: {
				title: 'Compra completada: activando',
				message: 'Tu compra se ha realizado correctamente. No hemos podido terminar de confirmarla ahora mismo, pero debería activarse sola en unos minutos. No hace falta que vuelvas a comprar. Si no se ha activado, vuelve a abrir la app o pulsa Restaurar compras.',
			},
			restoreFailed: {
				title: 'La restauración falló',
				message: 'No se encontraron compras existentes. Si crees que esto es un error, contacta con soporte.',
			},
			restoreNotYetConfirmed: {
				title: 'Restauración en curso',
				message: 'La tienda ha encontrado tu compra, pero no hemos podido terminar de confirmarla ahora mismo. Debería activarse sola en unos minutos. No hace falta que vuelvas a comprar.',
			},
			alreadyLinked: {
				title: 'Suscripción vinculada a otra cuenta',
				message: 'Esta suscripción de la tienda ya está vinculada a {email}. Para usarla, cierra sesión e inicia sesión con esa cuenta.',
				signOut: 'Cerrar sesión',
				unknownAccount: 'otra cuenta',
			},
			otherAccount: {
				title: 'Compra hecha con otra cuenta',
				message: 'Esta compra se hizo con otra cuenta de MH Physique. Para usarla, inicia sesión con esa cuenta. Si esa cuenta ya no existe, contacta con soporte y te ayudaremos a tener acceso en esta.',
			},
			storeRefused: {
				title: 'No se pudo confirmar la compra',
				message: 'La tienda no aceptó nuestra solicitud para confirmar esta compra, así que no se ha añadido a tu cuenta. No vuelvas a comprar. Si se te ha cobrado, escribe a support@mh-physique.app y lo resolveremos.',
			},
			registrationSlow: {
				title: 'Registro del pago demorado',
				message: 'Parece que tu pago se procesó, pero el registro está tardando más de lo esperado. Toca Reintentar para recargar. Si el problema persiste, contacta con support@mh-physique.app.',
			},
			paymentBeingConfirmed: {
				title: 'Confirmando el pago',
				message: 'Tu pago aún se está confirmando. Recibirás un correo cuando se procese.',
			},
		},
		temporaryInfoCard: {
			message: 'Confirmando el pago: tu pago está en la cola de revisión manual de PayPro. Tienes acceso completo mientras esperamos. La mayoría de las revisiones se completan en unos minutos.',
		},
		errors: {
			unexpectedCheckout: 'Ocurrió un evento inesperado durante el pago.',
			checkoutAwaitingProcessing: 'Tu pago todavía está pendiente de procesarse. ¿Confirmaste el pago con tu banco?',
			checkoutDeclined: 'Tu banco o proveedor de pagos ha rechazado el pago.',
		},
	},
	unsubscribe: {
		title: '¿Por qué te vas?',
		reasons: {
			highPrice: 'El precio es demasiado alto.',
			noLongerNeed: 'Ya no necesito este producto',
			notSatisfied: 'No estoy satisfecho con el producto.',
			switchedProduct: 'Me cambié a otro producto',
			notPriority: 'No es una prioridad ahora mismo.',
			mistake: 'Me suscribí por error.',
			anotherPlan: 'Me cambio a otro plan de suscripción.',
			other: 'Otras razones.',
		},
		placeholders: {
			customReason: 'Ojalá... (Explica aquí tu motivo.)',
		},
		buttons: {
			unsubscribe: 'Cancelar suscripción',
		},
		alerts: {
			success: 'Has cancelado tu suscripción correctamente. Tu suscripción terminará el {date}.',
			alreadyCanceled: 'Tu suscripción ya ha sido cancelada. No hace falta nada más.',
			unsubscribeFailed: {
				title: 'No pudimos cancelar en este momento',
				message: 'Tu suscripción sigue activa. Inténtalo de nuevo en un momento o contacta con soporte si esto sigue ocurriendo.',
				retry: 'Reintentar',
				contactSupport: 'Contactar con soporte',
			},
		},
	},
	redeemCode: {
		title: 'Canjear código',
		labels: {
			enterCode: 'Introduce el código:',
		},
		placeholders: {
			codeFormat: 'ABCD-EFGH-1234-5678',
		},
		notes: {
			codeWillBeRedeemed: 'El código que introduzcas se aplicará a tu cuenta: \'\'{email}\'\'.',
		},
		buttons: {
			redeem: 'Canjear',
		},
		loading: {
			redeemingCode: 'Canjeando código...',
		},
		alerts: {
			successfullyRedeemed: '¡Canjeado correctamente!',
		},
		errors: {
			loginFailed: 'La clave parece válida, pero el nuevo inicio de sesión falló por un motivo desconocido. Reinicia la app e inténtalo de nuevo o contacta con soporte.',
			activationFailed: 'La clave parece válida, pero la activación falló por un motivo desconocido. Reinicia la app e inténtalo de nuevo o contacta con soporte.',
		},
	},
	referral: {
		settings: {
			inviteRow: 'Invitar a un amigo',
		},
		disclosure: 'El amigo que te ha invitado verá cuándo te unes, cuándo empiezas a entrenar y si te suscribes.',
		invite: {
			headerTitle: 'Te han invitado',
			checking: 'Comprobando tu invitación...',
			title: '{name} te ha regalado un mes gratis',
			subtitle: 'Un mes gratis en la app de Menno Henselmans. Empieza cuando quieras.',
			startButton: 'Empezar mi mes gratis',
			continueButton: 'Continuar',
			invalidTitle: 'Este enlace de invitación ya no es válido.',
			invalidSubtitle: 'Pide a tu amigo un enlace nuevo o crea una cuenta sin él.',
			invalidButton: 'Crear una cuenta',
		},
		hub: {
			title: 'Regala un mes gratis a un amigo',
			subtitle: 'Regálale a alguien un mes gratis en la app. Si sigue con ello, sabrás que le has puesto a entrenar como es debido.',
			messageLabel: 'Tu mensaje',
			linkLabel: 'Tu enlace de invitación',
			codeLabel: 'O dale este código',
			defaultMessage: 'Llevo un tiempo usando la app de entrenamiento de Menno Henselmans. Aquí tienes un mes gratis por si quieres probarla:',
			shareButton: 'Compartir tu invitación',
			copiedToClipboard: 'Invitación copiada al portapapeles.',
			copyFailed: 'No hemos podido copiar tu invitación. Puedes seleccionar el enlace de arriba y copiarlo a mano.',
			loadFailed: 'No hemos podido obtener tu enlace de invitación. Comprueba tu conexión e inténtalo de nuevo.',
			retryButton: 'Reintentar',
			wereYouInvited: {
				title: '¿Te han invitado?',
				subtitle: 'Introduce el código de tu amigo y registraremos quién te invitó.',
				placeholder: 'Introduce el código',
				submitButton: 'Aplicar código',
				accepted: 'Gracias. Hemos registrado quién te invitó.',
				refusals: {
					unknownInvite: 'No reconocemos ese código. Compruébalo con el amigo que te lo envió.',
					selfReferral: 'Ese es tu propio código. Envíaselo a un amigo.',
					alreadyReferredByAnother: 'Ya hay otra persona registrada como el amigo que te invitó.',
					hasSubscription: 'Esta oferta es solo para cuentas nuevas.',
					accountTooOld: 'Esta oferta es solo para cuentas nuevas.',
					inviterGone: 'Ese código ya no pertenece a nadie.',
					unexpectedError: 'Algo ha salido mal. Inténtalo de nuevo.',
				},
			},
			friends: {
				title: 'Amigos que has traído',
				count: '{count} {{amigo|amigos}} hasta ahora',
				empty: 'Todavía nadie. Comparte tu invitación y aparecerán aquí.',
				loadFailed: 'No pudimos cargar tus amigos. Comprueba tu conexión e inténtalo de nuevo.',
				noName: 'Un amigo',
				statusJoined: 'Se ha unido',
				statusTraining: 'Entrenando',
				statusMember: 'Miembro',
			},
		},
		subscribe: {
			freeMonthApplied: 'Tu mes gratis de parte de tu amigo está aplicado.',
			codeEntry: {
				title: '¿Te han invitado?',
				subtitle: 'Introduce el código de tu amigo para conseguir tu mes gratis.',
				placeholder: 'Introduce el código',
				submitButton: 'Aplicar código',
				failed: 'Algo ha salido mal. Inténtalo de nuevo.',
			},
		},
	},
	bodyfatInput: {
		errors: {
			missingSkinfold: 'Introduce al menos un valor para el pliegue cutáneo \'{skinfold}\'.',
			genderRequired: 'Hay que indicar el sexo para calcular la grasa corporal.',
			tapeAllValues: 'Introduce todos los valores de la medición con cinta métrica.',
			tapeInvalid: 'Datos no válidos para la medición con cinta métrica.',
			noMethod: 'No has elegido ningún método para calcular el % de grasa corporal.',
			valuesOutOfRange: 'Revisa bien esos valores. Si son correctos, deberías consultar a un profesional médico.',
		},
		methods: {
			visual: 'Visual',
			caliper: 'Plicómetro',
			tape: 'Cinta métrica',
		},
		descriptions: {
			visual: 'Usa las imágenes de abajo para estimar tu porcentaje.',
		},
		labels: {
			bodyFatPercentage: 'Porcentaje de grasa corporal',
			take5Measurements: 'Toma 5 mediciones de cada punto de pliegue cutáneo.',
			neckCircumference: 'Circunferencia del cuello',
			abdomenCircumference: 'Circunferencia del abdomen',
			waistCircumference: 'Circunferencia de la cintura',
			hipsCircumference: 'Circunferencia de las caderas',
		},
		helpText: {
			neckCircumference: 'Mide por debajo de la nuez, en el punto más estrecho.',
			abdomenCircumference: 'Mide alrededor del ombligo, en el punto más ancho.',
			waistCircumference: 'Mide alrededor o por encima del ombligo, en el punto más estrecho.',
			hipsCircumference: 'Mide alrededor del punto más ancho de las caderas o los glúteos.',
		},
		links: {
			howToMeasure: '¿Cómo mido los pliegues cutáneos?',
		},
		warnings: {
			roughEstimate: 'La cinta métrica es sorprendentemente útil para seguir tu nivel de grasa corporal, pero si consigues un plicómetro, es aún más útil.',
		},
	},
	sendCoachMessage: {
		title: 'Mensaje al entrenador',
		placeholder: 'Escribe un mensaje a tu entrenador...',
		addScreenshot: 'Añadir captura',
		send: 'Enviar',
		sentDescription: 'Tu entrenador recibirá tu mensaje por correo.',
	},
	sendFeedback: {
		title: 'Enviar comentarios',
		headers: {
			howCanWeHelp: '¿Cómo podemos ayudarte hoy?',
		},
		messages: {
			thankYouForFeedback: '¡Gracias por tus comentarios! Te hemos enviado un correo de confirmación.',
			couldNotSend: 'No hemos podido enviar tus comentarios. Tu mensaje sigue aquí: comprueba tu conexión e inténtalo de nuevo.',
			noTitle: 'Sin título',
		},
		buttons: {
			submit: 'Enviar comentarios',
			addScreenshot: 'Añadir captura',
		},
		writeFeedback: {
			title: 'Escribe tus comentarios',
			subtitle: 'Te contactaremos en {email} si es necesario.',
		},
		types: {
			question: {
				title: 'Hacer una pregunta',
				description: 'Estaremos encantados de ayudarte con cualquier pregunta que tengas.',
				placeholder: 'Pregunta lo que quieras sobre tu programa o sobre la app en general y te responderemos lo antes posible.',
			},
			like: {
				title: 'Me gusta algo',
				description: 'Nos alegra saber que hay algo que te gusta de nuestra app.',
				placeholder: 'Cuéntanos qué te gusta de la app o de tu programa.',
			},
			dislike: {
				title: 'No me gusta algo',
				description: 'Si hay algo que no te gusta, dínoslo para que podamos mejorarlo.',
				placeholder: 'Cuéntanos qué no te gusta de la app o de tu programa.',
			},
			issue: {
				title: 'Informar de un problema',
				description: '¿Encontraste un error? Dínoslo y lo solucionaremos lo antes posible.',
				placeholder: 'Describe cómo se ve el problema y cómo reproducirlo (si es posible).',
			},
			suggestion: {
				title: 'Hacer una sugerencia',
				description: 'Siempre buscamos formas de mejorar nuestra app. Dinos cómo podemos hacerlo mejor.',
				placeholder: 'Cuéntanos qué te gustaría ver en la app o cómo podemos mejorarla.',
			},
		},
	},
	flagContent: {
		title: 'Reportar contenido',
		reasons: {
			offensive: 'Ofensivo o inapropiado',
			offensiveDesc: 'Contiene lenguaje soez, discurso de odio o material explícito',
			spam: 'Spam',
			spamDesc: 'Publicidad, contenido sin sentido o duplicado',
			incorrect: 'Información incorrecta',
			incorrectDesc: 'Los datos nutricionales son claramente erróneos o engañosos',
			other: 'Otro',
			otherDesc: 'Algo más que no aparece arriba',
		},
		submit: 'Enviar reporte',
		otherTitle: 'Describe el problema',
		otherPlaceholder: 'Describe el problema...',
		success: 'Reporte enviado. ¡Gracias!',
		error: 'No se pudo enviar el reporte. Inténtalo de nuevo.',
		menuButton: 'Reportar',
	},
	helpPage: {
		title: 'Ayuda',
		placeholders: {
			searchKnowledgeBase: '¿Con qué necesitas ayuda?',
		},
		messages: {
			noMatchesTitle: 'No se encontraron resultados',
			noMatchesSubtext: '¿No encuentras lo que buscas? Prueba a ajustar tu búsqueda, o ponte en contacto <a href="mailto:support@mh-physique.app">escribiendo a soporte</a> o <a href="https://community.mh-physique.app/" target="_blank">uniéndote a la comunidad</a> para recibir ayuda de nuestro equipo y de otros usuarios.',
		},
		faq: {
			title: 'Preguntas frecuentes',
		},
	},
	labelScanner: {
		title: 'Escanear etiqueta',
		noNutrientsTitle: 'No se encontró información nutricional',
		noNutrients: 'No se detectó información nutricional. Comprueba debajo de las solapas, en la base o en la caja exterior, y luego toma otra foto.',
		noNutrientsBlurry: 'La foto está demasiado borrosa u oscura para leerla. Vuelve a tomarla con mejor iluminación y mantén el pulso firme.',
		noNutrientsPartial: 'Solo se encontró información nutricional parcial. La etiqueta completa puede estar bajo una solapa, en la base o en la caja exterior.',
		retakeButton: 'Repetir foto',
		cameraErrorTitle: 'Cámara no disponible',
		error: 'No se pudo analizar la etiqueta. Inténtalo de nuevo.',
		quotaTitle: 'Límite de escaneos alcanzado',
		cameraPermissionDenied: 'Se necesita acceso a la cámara para escanear etiquetas.',
		modelsAgree: '{count} modelo(s) coinciden',
		acceptResult: 'Aceptar este resultado',
		labelType: 'Tipo de etiqueta',
		confidence: 'Confianza',
		jsonRepaired: 'La respuesta se truncó y se reparó automáticamente; verifica los nutrientes',
		doneButton: 'Hecho',
		photoHintExtract: 'Cuanto más captures, mejor: información nutricional, frente del paquete e ingredientes.',
		photoHintImage: 'La mejor foto se convierte en la imagen del alimento.',
		providerErrorTitle: 'Servicio no disponible temporalmente',
		providerErrorMessage: 'El servicio de escaneo no está disponible temporalmente. Inténtalo de nuevo en un momento o contacta con soporte si esto se repite.',
		incompleteTitle: 'El escaneo no terminó',
		incompleteMessage: 'El escaneo no terminó. Inténtalo de nuevo: tus fotos siguen aquí.',
		quotaAccountLocked: 'El escaneo de etiquetas está desactivado temporalmente para tu cuenta.',
		quotaRateLimited: 'Demasiados escaneos en poco tiempo. Espera un momento.',
		quotaDailyCooldown: 'Demasiados escaneos fallidos hoy. Inténtalo de nuevo mañana.',
		quotaQualityWarning: 'La mayoría de tus escaneos están fallando; comprueba la calidad de la imagen y el contenido.',
		retryingDifferentServer: 'Con problemas: probando con otro servidor...',
		offlineTitle: 'Estás sin conexión',
		offlineMessage: 'Conéctate a internet e inténtalo de nuevo.',
		statusReadingPackaging: 'Leyendo el empaque...',
		statusExtractingProductInfo: 'Extrayendo información del producto...',
		statusAnalyzingNutrients: 'Analizando nutrientes...',
		statusCheckingIngredients: 'Comprobando ingredientes...',
		statusDetectingServingSizes: 'Detectando tamaños de porción...',
		statusAlmostThere: 'Ya casi está...',
	},
	mealPhotoScanner: {
		title: 'Escanear comida',
		analyzeButton: 'Analizar comida',
		analyzing: 'Identificando alimentos...',
		retryingDifferentServer: 'Reintentando con otro modelo...',
		addToMeal: 'Añadir {count} alimento(s) a la comida',
		replaceInMeal: 'Reemplazar con {count} alimento(s)',
		noFoodsDetected: 'No se detectó comida en esta foto. Prueba a tomar una foto más nítida de tu comida.',
		noFoodsBlurry: 'La foto está demasiado borrosa u oscura. Vuelve a tomarla con mejor iluminación.',
		barcodeDetectedTitle: 'Código de barras detectado',
		barcodeDetectedMessage: 'Esto parece el código de barras de un producto, no un plato de comida. Escanea el código de barras para registrar este producto envasado.',
		nutritionLabelDetectedTitle: 'Etiqueta nutricional detectada',
		nutritionLabelDetectedMessage: 'Esto parece la etiqueta nutricional de un producto, no un plato de comida. Escanea la etiqueta para registrar este producto envasado.',
		scanBarcodeButton: 'Escanear código de barras',
		scanLabelButton: 'Escanear etiqueta',
		retakeButton: 'Repetir foto',
		changeButton: 'Cambiar',
		searchButton: 'Buscar',
		addFoodButton: 'Añadir alimento',
		errorTitle: 'Error en el análisis',
		error: 'No se pudo analizar la foto de la comida. Inténtalo de nuevo.',
		estimatedGrams: '{grams} g estimados',
		estimatedToMeasured: '{estimated} g estimados → {measured} g medidos',
		addedGrams: '{grams} g añadidos por ti',
		quotaTitle: 'Límite de escaneos alcanzado',
		quotaAccountLocked: 'El escaneo de comidas está desactivado temporalmente para tu cuenta.',
		quotaRateLimited: 'Demasiados escaneos en poco tiempo. Espera un momento.',
		quotaDailyCooldown: 'Demasiados escaneos fallidos hoy. Inténtalo de nuevo mañana.',
		cameraPermissionDenied: 'Se necesita acceso a la cámara para escanear comidas.',
	},
	equipmentScanner: {
		title: 'Escanear equipamiento',
		analyzeButton: 'Analizar',
		retakeButton: 'Repetir foto',
		photoHintCapture: 'Captura desde varios ángulos para obtener el mejor resultado.',
		photoHintLabel: 'Asegúrate de que los números de peso impresos se puedan leer.',
		analyzingReadingPlates: 'Leyendo pesos...',
		analyzingMatchingType: 'Identificando el tipo de equipamiento...',
		analyzingFinalising: 'Finalizando...',
		retryingDifferentServer: 'Reintentando con otro modelo...',
		cameraPermissionDenied: 'Se necesita acceso a la cámara para escanear equipamiento.',
		errorTitle: 'Error al escanear',
		errorCamera: 'La cámara no se pudo iniciar. Inténtalo de nuevo.',
		errorNetwork: 'No se pudo conectar con el escáner. Comprueba tu conexión e inténtalo de nuevo.',
		errorGeneric: 'No se pudo analizar el equipamiento. Inténtalo de nuevo.',
		errorIncomplete: 'El escaneo no se completó. Inténtalo de nuevo: tus fotos siguen aquí.',
		errorBadImage: 'Se rechazó la imagen. Asegúrate de que las fotos sean nítidas y no demasiado grandes.',
		errorUnsupportedType: 'Este tipo de equipamiento no se puede escanear.',
		noEquipmentDetected: 'No se detectó equipamiento en las fotos. Prueba con ángulos más claros o mejor iluminación.',
		noEquipmentBlurry: 'Las fotos están demasiado borrosas u oscuras. Prueba a repetirlas con mejor iluminación.',
		noEquipmentMixed: 'Las fotos parecen mostrar equipamientos distintos. Repite las fotos del MISMO equipamiento desde diferentes ángulos.',
		lowConfidenceTooltip: 'La IA no estaba segura de este valor: puede haberlo interpolado o costarle leerlo. Compruébalo antes de aplicarlo.',
		confidenceTooltip: 'Cuánta confianza tiene la IA en esta lectura. Los valores por debajo del 70 % se marcan con una advertencia.',
		types: {
			barbell: 'Barra',
			dumbbells: 'Mancuernas',
			plates: 'Discos sueltos',
			kettlebells: 'Pesas rusas',
			cableMachine: 'Máquina de poleas',
			unknown: 'Desconocido',
		},
		detectedHeader: 'Detectado ({count} elementos)',
		applyModeHeader: 'Cómo aplicar',
		applyMode: {
			replace: 'Reemplazar',
			replaceHelp: 'Sobrescribe todos los valores existentes con los valores detectados marcados.',
			merge: 'Combinar',
			mergeHelp: 'Añade los valores detectados que aún no están presentes (dentro de 0,05 kg).',
			append: 'Agregar',
			appendHelp: 'Añade todos los valores detectados marcados a la lista existente (se permiten duplicados).',
		},
		barGroup: 'Barra',
		collarGroup: 'Cierre',
		platesGroup: 'Discos',
		microPlatesGroup: 'Microdiscos',
		currentValues: {
			showStack: 'Mostrar la pila resultante ({count} incrementos)',
			headerStack: 'Pila resultante ({count} incrementos)',
			showPlates: 'Mostrar los discos resultantes ({count} discos)',
			headerPlates: 'Discos resultantes ({count} discos)',
			showBar: 'Mostrar la configuración de barra resultante ({count} discos)',
			headerBar: 'Configuración de barra resultante ({count} discos)',
			showFixed: 'Mostrar los pesos resultantes ({count})',
			headerFixed: 'Pesos resultantes ({count})',
		},
		afterApply: 'Tras aplicar: {count} elemento(s)',
		usingChecked: 'Usando {checked} de {total} detectados',
		typeMismatchBanner: 'Se detectó {detected}, pero este equipamiento es {current}.',
		unknownTypeBanner: 'No pudimos identificar con seguridad el tipo de equipamiento en las fotos.',
		quotaTitle: 'Límite de escaneos alcanzado',
		quotaAccountLocked: 'El escaneo de equipamiento está desactivado temporalmente para tu cuenta.',
		quotaRateLimited: 'Demasiados escaneos en poco tiempo. Espera un momento.',
		quotaDailyCooldown: 'Demasiados escaneos fallidos hoy. Inténtalo de nuevo mañana.',
	},
	workoutPlanScanner: {
		title: 'Escanear entrenamiento',
		analyzeButton: 'Analizar',
		retakeButton: 'Repetir foto',
		photoHintCapture: 'Fotografía o haz una captura de tu entrenamiento. Lo mejor es un día de entrenamiento por imagen.',
		photoHintBatch: 'Hasta 5 imágenes por escaneo. Para programas más largos, escanea por lotes y agrégalos.',
		analyzingReadingWorkout: 'Leyendo el entrenamiento...',
		analyzingMatchingExercises: 'Identificando ejercicios...',
		analyzingFinalising: 'Finalizando...',
		retryingDifferentServer: 'Reintentando con otro modelo...',
		cameraPermissionDenied: 'Se necesita acceso a la cámara para escanear un entrenamiento. También puedes subir capturas de pantalla con el botón +.',
		errorTitle: 'Error al escanear',
		errorCamera: 'La cámara no se pudo iniciar. Inténtalo de nuevo.',
		errorNetwork: 'No se pudo conectar con el escáner. Comprueba tu conexión e inténtalo de nuevo.',
		errorGeneric: 'No se pudo analizar el entrenamiento. Inténtalo de nuevo.',
		errorIncomplete: 'El escaneo no se completó. Inténtalo de nuevo: tus fotos siguen aquí.',
		errorApply: 'Algo salió mal al añadir el entrenamiento escaneado. Puede que se haya añadido una parte: revisa tus entrenamientos abajo o cancela Editar entrenamientos para descartar los cambios.',
		errorBadImage: 'Se rechazó la imagen. Asegúrate de que las fotos sean nítidas y no demasiado grandes.',
		noWorkoutDetected: 'No se encontró ningún entrenamiento en las imágenes. Prueba con fotos o capturas más claras.',
		noWorkoutBlurry: 'Las imágenes están demasiado borrosas u oscuras para leerlas. Prueba a repetirlas con mejor iluminación.',
		quotaTitle: 'Límite de escaneos alcanzado',
		quotaAccountLocked: 'El escaneo de entrenamientos está desactivado temporalmente para tu cuenta.',
		quotaRateLimited: 'Demasiados escaneos en poco tiempo. Espera un momento.',
		quotaDailyCooldown: 'Demasiados escaneos fallidos hoy. Inténtalo de nuevo mañana.',
		detectedSummary: 'Se detectaron {days} día(s) con {exercises} ejercicio(s).',
		willCreateCustomSummary: 'Se crearán {count} ejercicio(s) como nuevos ejercicios personalizados al aplicar.',
		willCreateCustom: 'Este ejercicio no está en la base de datos de ejercicios de la app. Se creará como un nuevo ejercicio personalizado con el nombre escaneado.',
		willCreateCustomSimilar: 'Este ejercicio no está en la base de datos de ejercicios de la app. Se creará como un nuevo ejercicio personalizado con el nombre escaneado, configurado como similar a {name}.',
		useScannedButton: 'Mantener nombre escaneado',
		useSuggestionButton: 'Usar sugerencia',
		changeButton: 'Cambiar',
		resolveButton: 'Resolver',
		scannedAs: 'Escaneado como «{name}»',
		suggestedAs: 'Sugerido «{name}»',
		customBadge: 'Personalizado',
		matchedBadge: 'Coincidencia',
		matchedBadgeTooltip: 'Es el mismo ejercicio que el escaneado, solo que posiblemente con otro nombre en la base de datos de ejercicios de la app.',
		suggestedMatchBadge: 'Sugerido',
		suggestedMatchTooltip: 'No es el ejercicio escaneado, sino uno similar de la base de datos de ejercicios de la app, sugerido como reemplazo.',
		alreadyInPlan: 'Ya está en tu programa: al aplicar se actualizarán sus series y repeticiones en todos los lugares donde se use.',
		setsLabel: 'Series',
		targetRepsLabel: 'Repeticiones objetivo',
		applyModeHeader: 'Cómo aplicar',
		applyModeMessage: 'Agregar añade el día o los días escaneados a tus entrenamientos actuales. Reemplazar elimina primero tus entrenamientos actuales. No se guarda nada hasta que guardes la página Editar entrenamientos.',
		applyingLoading: 'Añadiendo a tu programa…',
		applyMode: {
			append: 'Agregar',
			replace: 'Reemplazar',
		},
	},
	recipeScanner: {
		title: 'Escanear receta',
		emptyRecipeHint: '¿Tienes una receta a mano? Escanea una foto y rellenaremos los ingredientes por ti.',
		analyzeButton: 'Analizar',
		retakeButton: 'Repetir foto',
		analyzing: 'Leyendo la receta...',
		retryingDifferentServer: 'Reintentando con otro modelo...',
		photoHintCapture: 'Haz una foto a una tarjeta de receta, la página de un libro de cocina, una pantalla o una nota.',
		photoHintBatch: 'Hasta 4 fotos: una por página.',
		photoHintImage: 'Una foto del plato terminado se convierte en la imagen de la receta.',
		cameraPermissionDenied: 'Se necesita acceso a la cámara para escanear una receta. También puedes subir fotos con el botón +.',
		nameLabel: 'Nombre de la receta',
		namePlaceholder: 'Nombre de la receta',
		imageLabel: 'Imagen de la receta',
		servingsLabel: 'Rinde {count} porción(es)',
		instructionsLabel: 'Instrucciones',
		useRecipeButton: 'Usar {count} ingrediente(s)',
		changeButton: 'Cambiar',
		searchButton: 'Buscar',
		estimatedGrams: '{grams} g estimados',
		estimatedToMeasured: '{estimated} g estimados → {measured} g medidos',
		errorTitle: 'Error al escanear',
		error: 'No se pudo leer la receta. Inténtalo de nuevo.',
		noRecipeDetected: 'No se encontró ninguna receta en estas fotos. Prueba con fotos más claras de la receta completa.',
		noRecipeBlurry: 'Las fotos están demasiado borrosas u oscuras para leerlas. Prueba a repetirlas con mejor iluminación.',
		quotaTitle: 'Límite de escaneos alcanzado',
		quotaAccountLocked: 'El escaneo de recetas está desactivado temporalmente para tu cuenta.',
		quotaRateLimited: 'Demasiados escaneos en poco tiempo. Espera un momento.',
		quotaDailyCooldown: 'Demasiados escaneos fallidos hoy. Inténtalo de nuevo mañana.',
	},
	cameraPermission: {
		title: 'Cómo activar la cámara',
		nativeAndroidStep1: 'Abre la app de Ajustes de tu teléfono',
		nativeAndroidStep2: 'Toca Aplicaciones y luego MH Physique',
		nativeAndroidStep3: 'Toca Permisos y luego Cámara',
		nativeAndroidStep4: 'Elige "Permitir solo mientras se usa la aplicación"',
		nativeAndroidStep5: 'Vuelve aquí y abre el escáner de nuevo',
		nativeIosStep1: 'Abre la app Ajustes en tu dispositivo',
		nativeIosStep2: 'Baja y toca MH Physique',
		nativeIosStep3: 'Activa Cámara',
		nativeIosStep4: 'Vuelve aquí y abre el escáner de nuevo',
		webStep1: 'Haz clic en el icono del candado junto a la barra de direcciones',
		webStep2: 'Busca «Cámara»',
		webStep3: 'Cambia el permiso a «Permitir»',
		webStep4: 'Cierra y vuelve a abrir esta pantalla',
		webIosStep1: 'Abre la app Ajustes en tu dispositivo',
		webIosStep2: 'Desplázate hacia abajo y toca Safari',
		webIosStep3: 'Toca Cámara (en «Ajustes de sitios web»)',
		webIosStep4: 'Selecciona la opción Preguntar o Permitir',
		webIosStep5: 'Vuelve aquí y recarga la página',
		webIosOtherBrowserStep1: 'Abre la app Ajustes en tu dispositivo',
		webIosOtherBrowserStep2: 'Desplázate hacia abajo y toca el navegador que estés usando, como Chrome o Firefox',
		webIosOtherBrowserStep3: 'Activa Cámara',
		webIosOtherBrowserStep4: 'Vuelve aquí y recarga la página',
		macSafariStep1: 'En el menú Safari, elige «Ajustes para este sitio web»',
		macSafariStep2: 'Cambia Cámara a «Permitir»',
		macSafariStep3: 'Recarga esta página',
		macSafariStep4: '¿Sigue bloqueada? Abre Ajustes del Sistema, luego Privacidad y seguridad, luego Cámara, y activa Safari',
	},
	barcodeScanner: {
		title: 'Escanear código de barras',
		tabs: {
			scan: 'Escanear',
			enterManually: 'Introducir manualmente',
		},
		manualEntry: {
			title: 'Introducir código de barras',
			findFood: 'Buscar alimento',
		},
		messages: {
			cameraPermissionDenied: 'Tendrás que permitir que la app use tu cámara para que esta función funcione correctamente.',
			initializingCamera: 'Inicializando la cámara',
			cannotInitializeCamera: 'No se puede inicializar la cámara.',
			noBarcodeFound: '¿No se encuentra el código de barras? Prueba {remedies}.',
		},
		remedies: {
			betterLighting: 'mejor iluminación',
			differentDistance: 'otra distancia',
			enablingFlash: 'activar el flash',
			zoomingInOut: 'acercar o alejar el zoom',
			switchingCameras: 'cambiar de cámara',
		},
	},
	helpCard: {
		title: 'Información sobre...',
	},
	changelog: {
		title: 'Registro de cambios',
		comingSoon: 'Próximamente',
	},
	sso: {
		loggingIntoCommunity: 'Iniciando sesión en la comunidad...',
		communityForSubscribersOnly: 'La Comunidad es solo para suscriptores. Suscríbete para unirte a la conversación.',
	},
	nutrients: {
		names: {
			energy: 'Energía',
			protein: 'Proteína',
			fat: 'Grasa',
			carbohydrates: 'Carbohidratos',
			fiber: 'Fibra',
			cholesterol: 'Colesterol',
			fatSaturated: 'Grasa, saturada',
			fatMonounsaturated: 'Grasa, monoinsaturada',
			fatPolyunsaturated: 'Grasa, poliinsaturada',
			omega3: 'Omega-3',
			omega6: 'Omega-6',
			omega9: 'Omega-9',
			transsaturatedFat: 'Grasa trans',
			carbohydratesTotal: 'Carbohidratos, total',
			sugarsTotal: 'Azúcares, total',
			sugarAdded: 'Azúcar, añadido',
			starch: 'Almidón',
			saltNacl: 'Sal (NaCl)',
			alcohol: 'Alcohol',
			water: 'Agua',
			caffeine: 'Cafeína',
			theobromine: 'Teobromina',
			calciumCa: 'Calcio (Ca)',
			ironFe: 'Hierro (Fe)',
			magnesiumMg: 'Magnesio (Mg)',
			phosphorusP: 'Fósforo (P)',
			potassiumK: 'Potasio (K)',
			sodiumNa: 'Sodio (Na)',
			zincZn: 'Zinc (Zn)',
			copperCu: 'Cobre (Cu)',
			fluorideF: 'Flúor (F)',
			manganeseMn: 'Manganeso (Mn)',
			seleniumSe: 'Selenio (Se)',
			iodineI: 'Yodo (I)',
			vitaminAIu: 'Vitamina A (UI)',
			retinol: 'Retinol',
			vitaminARae: 'Vitamina A RAE',
			caroteneBeta: 'Caroteno, beta',
			caroteneAlpha: 'Caroteno, alfa',
			vitaminEAlphaTocopherol: 'Vitamina E (alfa-tocoferol)',
			vitaminD: 'Vitamina D',
			vitaminD2Ergocalciferol: 'Vitamina D2 (ergocalciferol)',
			vitaminD3Cholecalciferol: 'Vitamina D3 (colecalciferol)',
			vitaminCTotalAscorbicAcid: 'Vitamina C, ácido ascórbico total',
			thiaminVitaminB1: 'Tiamina (vitamina B-1)',
			riboflavinVitaminB2: 'Riboflavina (vitamina B-2)',
			niacinVitaminB3: 'Niacina (vitamina B-3)',
			pantothenicAcid: 'Ácido pantoténico',
			vitaminB6: 'Vitamina B-6',
			folateTotal: 'Folato, total',
			vitaminB12: 'Vitamina B-12',
			cholineTotal: 'Colina, total',
			vitaminKPhylloquinone: 'Vitamina K (filoquinona)',
			folicAcid: 'Ácido fólico',
			ash: 'Cenizas',
			biotinVitaminH: 'Biotina (vitamina H)',
			chromiumCr: 'Cromo (Cr)',
			molybdenumMo: 'Molibdeno (Mo)',
			fattyAcidsLinoleic: 'Ácidos grasos, linoleico',
			fattyAcidsAlphaLinolenic: 'Ácidos grasos, alfa-linolénico',
			epa: 'EPA',
			dha: 'DHA',
			fattyAcidsArachidonic: 'Ácidos grasos, araquidónico',
			sorbitol: 'Sorbitol',
			maltitol: 'Maltitol',
			mannitol: 'Manitol',
			isomalt: 'Isomalt',
			lactitol: 'Lactitol',
			xylitol: 'Xilitol',
			erythritol: 'Eritritol',
			polyolsSugarAlcoholsTotal: 'Polioles (alcoholes de azúcar), total',
		},
		short: {
			energy: 'Cal',
			protein: 'Prot',
			fat: 'Gras',
			carbohydrates: 'Carb',
			fiber: 'Fib',
			cholesterol: 'Cole',
		},
		threeLetter: {
			energy: 'Cal',
			protein: 'Pro',
			fat: 'Gra',
			carbohydrates: 'Car',
			fiber: 'Fib',
		},
	},
	authRoles: {
		unknown: {
			name: 'Gratis',
			userExplanation: 'Tu suscripción no está activa ahora mismo. Necesitas una suscripción Premium para acceder a todas las funciones de entrenamiento y de planificación de comidas.',
		},
		paid: {
			name: 'Premium',
			userExplanation: 'Como usuario Premium, tienes acceso a todas las funciones, incluidos el programa de entrenamiento automático y la planificación de comidas.',
		},
		vip: {
			name: 'VIP',
			userExplanation: 'Como usuario VIP, tienes acceso a todas las funciones Premium, incluidos el programa de entrenamiento automático y la planificación de comidas. Es una suscripción recurrente de cortesía que gestiona manualmente el equipo de MH Physique.',
		},
		mod: {
			name: 'Moderador',
			userExplanation: 'Como Moderador, tienes acceso a todas las funciones Premium y además puedes moderar las contribuciones de la comunidad. Es una suscripción recurrente de cortesía que gestiona manualmente el equipo de MH Physique.',
		},
		dev: {
			name: 'Desarrollador',
			userExplanation: 'Esta es una licencia básica de desarrollador; consulta a tu jefe de producción para saber qué incluye.',
		},
		officer: {
			name: 'Oficial',
			userExplanation: 'Como Oficial, puedes editar los parámetros de funcionamiento del sistema (los solvers de entrenamientos y comidas, los ejercicios oficiales, etc.), moderar las contribuciones de la comunidad y también editar y eliminar usuarios.',
		},
		serverdev: {
			name: 'Dev de servidor',
			userExplanation: 'Como Desarrollador de Servidor, no necesitas que te expliquemos qué significa esto.',
		},
	},
	exerciseStates: {
		active: {
			title: 'Activo',
			description: 'Este ejercicio forma parte de tu programa actual.',
		},
		plateaued: {
			title: 'Estancado',
			description: 'Has llegado a un estancamiento (un pico temporal de rendimiento) en este ejercicio. Se volverá a usar más adelante, cuando tu progreso lo pida.',
		},
		unsuitable: {
			title: 'No adecuado',
			description: 'Hemos visto que este ejercicio no era óptimo para ti. Se volverá a usar más adelante, cuando tu progreso lo pida.',
		},
		avoided: {
			title: 'Evitado',
			description: 'Pediste cambiar este ejercicio por una alternativa, por una lesión o por falta de equipo. Te lo volveremos a recomendar pronto para ver si la situación ha cambiado.',
		},
		ready: {
			title: 'Listo',
			description: 'Ya has usado o intentado este ejercicio antes. Ahora vuelve a estar listo y esperando a usarse en cuanto haga falta.',
		},
		unused: {
			title: 'Sin usar',
			description: 'Todavía no te hemos sugerido este ejercicio. Lo haremos cuando tu progreso lo pida.',
		},
	},
	exerciseStats: {
		setNumber: '{number}',
		importantNotice: 'Aviso importante',
		exerciseProgress: 'Progreso del ejercicio',
		log: 'Registro',
		exportAsCsv: 'Exportar como CSV',
		buttons: {
			allow: 'Permitir',
			shareLink: 'Compartir enlace',
			stopSharing: 'Dejar de compartir',
		},
		toasts: {
			linkCopied: 'Enlace copiado al portapapeles',
		},
		tabs: {
			log: 'Historial',
			instructions: 'Instrucciones',
			settings: 'Ajustes',
		},
		settings: {
			equipment: 'Equipamiento',
			notSelectedYet: 'Aún sin seleccionar',
			myoReps: 'Myo-reps',
			myoRepsTooltip: 'Las myo-reps usan una serie principal seguida de mini-series con descansos cortos para un crecimiento muscular más rápido y eficaz.',
			myoRepsLearnMore: 'Más información',
			useMyoReps: 'Usar',
			useMyoRepsNote: 'Usa las myo-reps siempre que sea posible para que los entrenamientos sean más rápidos sin perder eficacia. Si un ejercicio no encaja bien, la app usará series normales.',
			dontUseMyoReps: 'No usar',
			dontUseMyoRepsNote: 'No uses nunca myo-reps para este ejercicio. El entrenamiento se basará en series normales tradicionales.',
			autoMyoReps: 'Automático',
			autoMyoRepsNote: 'Determina automáticamente si usar myo-reps para este ejercicio según las preferencias generales del objetivo y el progreso actual.',
			rmTesting: 'Prueba de máximo de repeticiones (RM)',
			rmTestingTooltip: 'La prueba de RM usa una serie pesada de 2 a 5 repeticiones con buena técnica para medir la fuerza. Después, la app estima tu 1RM y elige tu peso inicial.',
			rmTestingLearnMore: 'Más información',
			useRMTesting: 'Usar',
			useRMTestingNote: 'Usar siempre las pruebas de RM para este ejercicio. Harás tu máximo de 2 a 5 repeticiones para que la app pueda estimar tu fuerza y fijar los pesos adecuados.',
			dontUseRMTesting: 'No usar',
			dontUseRMTestingNote: 'No usar nunca las pruebas de RM para este ejercicio. La app se basará en tu rendimiento registrado.',
			autoRMTesting: 'Automático',
			autoRMTestingNote: 'Determina automáticamente si usar las pruebas de RM según tu ajuste general.',
		},
		options: {
			exerciseStatus: 'Estado del ejercicio',
		},
		alerts: {
			stopAvoidingTitle: 'Dejar de evitar',
			stopAvoidingMessage: '¿Has cambiado de opinión? Esto no empezará a usar de inmediato este ejercicio en tu programa, pero lo dejará disponible para planificaciones o cambios futuros.',
		},
		filters: {
			weight: 'Peso',
			oneRM: '1 RM',
			tonnage: 'Tonelaje',
			includeRMTests: 'Incluir pruebas de RM',
		},
		emptyState: {
			noProgressData: 'Sin datos de progreso',
			noProgressDataSubtext: 'Los datos de tu ejercicio se mostrarán aquí una vez que hayas realizado el movimiento.',
			noLogHistory: 'Sin historial de registros',
			noLogHistorySubtext: 'Tus ejercicios registrados y tus notas se mostrarán aquí una vez que hayas realizado el movimiento.',
			noDataInRange: 'Sin datos en el rango',
			noDataInRangeSubtext: 'No se encontraron datos de ejercicio para el rango de fechas seleccionado. Prueba a elegir otro período de tiempo.',
			loadFailed: 'No se pudieron cargar los datos del ejercicio',
			loadFailedSubtext: 'Algo salió mal al cargar. Inténtalo de nuevo.',
		},
		logTable: {
			date: 'FECHA',
			loggedSets: 'SERIES REGISTRADAS',
			notes: 'NOTAS',
		},
		logDetail: {
			sets: 'Series',
			notes: 'Notas',
		},
		chart: {
			weight: 'Peso',
			oneRMEstimate: 'Estimación de 1RM',
			tonnage: 'Tonelaje',
			weightAxis: 'Peso ({unit})',
			oneRMAxis: '1RM ({unit})',
			tonnageAxis: 'Tonelaje ({unit})',
		},
	},
	trendChart: {
		last7Days: 'Últimos 7 días',
		seeAll: 'Ver todo',
		noData: 'Sin datos',
	},
	markdownEditor: {
		buttons: {
			unlink: 'Quitar enlace',
		},
		placeholders: {
			url: 'URL',
		},
	},
	planHandler: {
		macrosOnTarget: 'Macros en objetivo',
	},
	programSettings: {
		title: 'Ajustes del programa',
		tabs: {
			training: 'Entrenamiento',
			nutrition: 'Nutrición',
		},
		settings: {
			title: 'Ajustes',
		},
		advancedTraining: {
			title: 'Métodos de entrenamiento avanzados',
			edit: 'Editar',
		},
		moreSettings: {
			toggle: 'Más ajustes',
			info: 'Los cambios aquí pueden sugerir optimizaciones del programa. Siempre puedes conservar tus entrenamientos actuales.',
		},
		schedule: {
			title: 'Horario',
			frequency: 'Frecuencia de entrenamiento',
			days: 'Días de entrenamiento',
			daysPerWeek: 'días por semana',
			hoursPerNight: 'horas por noche',
			sleep: 'Sueño',
		},
		lifestyle: {
			title: 'Estilo de vida',
			activityLevel: 'Nivel de actividad',
			stressLevel: 'Nivel de estrés',
		},
		volume: {
			title: 'Volumen de entrenamiento',
			priority: 'Prioridad de físico',
			setsPerWeek: 'Series por semana por grupo muscular',
			setsPerWeekCurrentPlanTooltip: 'Tus entrenamientos siguen diseñados para {volume} series por semana. Usa Ver y optimizar en Volumen muscular para acercarlos a tu objetivo.',
		},
		nutrition: {
			goal: 'Objetivo',
			primaryGoal: 'Objetivo principal',
			schedule: 'Horario',
			mealFrequency: 'Frecuencia de comidas',
			mealsPerDay: '{count} comidas al día',
			mealTimes: 'Horas de las comidas',
			energyBalance: 'Balance energético',
			calorieSurplus: 'Superávit calórico',
			calorieDeficit: 'Déficit calórico',
			energyBalanceCustomText: '{sign}{percent}% ({sign}{adjustment} kcal)',
		},
		buttons: {
			update: 'Actualizar',
			updateProgram: 'Actualizar programa',
			volumeDetails: 'Ver y optimizar',
		},
	},
	system: {
		messages: {
			recompiling: 'Angular: Recompilando...',
		},
	},
	workoutDetail: {
		volumeAutoregulation: {
			title: 'Autorregulación del volumen',
			message: 'Según tus datos, en particular tu índice de fatiga{intensityInfo}, te recomendamos {direction} el volumen de series de {exerciseName} en 1 serie.',
			intensityHighRep: ' en la sesión de altas repeticiones',
			intensityMediumRep: ' en la sesión de repeticiones medias',
			intensityLowRep: ' en la sesión de bajas repeticiones',
			directionIncreasing: 'aumentar',
			directionDecreasing: 'reducir',
			buttons: {
				accept: 'Aceptar',
				decline: 'Rechazar',
				decideLater: 'Lo decidiré más tarde',
			},
		},
	},
	cliAuth: {
		allowAccess: '¿Permitir acceso?',
		description: 'MH Physique CLI (GitHub) solicita permiso para:',
		permissions: {
			downloadData: 'Descargar instantáneas de la base de datos del usuario',
			actOnBehalf: 'Realizar acciones en tu nombre',
		},
		confirmAccess: '¿Permitir acceso para {email}?',
		authorizing: 'Autorizando...',
		approved: 'Acceso concedido',
		approvedDetail: 'Puedes cerrar esta página y volver a la terminal.',
		denied: 'Acceso denegado',
		deniedDetail: 'La solicitud fue denegada. Puedes cerrar esta página.',
		buttons: {
			deny: 'Denegar',
			allow: 'Permitir',
		},
		errors: {
			noSession: 'No se encontró ninguna sesión de autorización. Vuelve a iniciar la herramienta de la CLI.',
			notSignedIn: 'Inicia sesión en la app primero y luego inténtalo de nuevo.',
		},
	},
	muscles: {
		bodyParts: {
			glutes: 'Glúteo mayor',
			glutemed: 'Glúteo medio',
			quads: 'Cuádriceps',
			hams: 'Isquiotibiales',
			calves: 'Gemelos (gastrocnemios y sóleo)',
			shoulders: 'Hombros (todos los haces)',
			chest: 'Pecho',
			lats: 'Dorsales',
			traps: 'Trapecios',
			triceps: 'Tríceps',
			biceps: 'Bíceps',
			abs: 'Abdominales',
		},
		volumeTable: {
			chest: 'Pecho',
			ldelt: 'Deltoides laterales',
			rdelt: 'Deltoides posteriores',
			utraps: 'Trapecio superior',
			lats: 'Dorsales',
			biceps: 'Bíceps',
			triceps: 'Tríceps',
			erectors: 'Lumbares',
			quads: 'Cuádriceps',
			hams: 'Isquiotibiales',
			glutes: 'Glúteos',
			glutemed: 'Glúteo medio',
			gastrocnemius: 'Gemelos (gastrocnemio)',
			soleus: 'Gemelos (sóleo)',
			abs: 'Abdominales',
		},
	},
	coach: {
		manageClientOffline: {
			title: 'Estás sin conexión',
			message: 'Gestionar un cliente necesita conexión a internet. Conéctate a internet e inténtalo de nuevo.',
		},
		formerCoachBadge: {
			label: 'Antiguo entrenador',
			tooltip: 'Creado por tu antiguo entrenador {coachName}. Puedes seguir usándolo o elegir otra versión.',
			editPageBody: 'Creado por tu antiguo entrenador {coachName}.',
		},
		detachExerciseNotice: 'Tu programa todavía usa los ejercicios de tu antiguo entrenador. Abre el selector para volver a tu propia versión si lo deseas.',
		title: 'Entrenamiento',
		addClient: 'Añadir cliente',
		unnamedClient: 'Cliente sin nombre',
		clientGoneMessage: 'Este cliente ya no está en tu lista.',
		slotsRemaining: '{remaining} plazas de cliente restantes',
		perSeatSlots: 'Añade clientes en cualquier momento — se factura por plaza',
		checkout: {
			billingTitle: 'Cómo funciona la facturación del entrenamiento',
			billingInfo: 'Esta es una suscripción mensual que se factura por plaza de cliente. Empiezas con una plaza —la tuya—, que también incluye tu membresía Premium. Cada cliente que entrenes añade una plaza a tu factura mensual, y quitar un cliente elimina su plaza. Los cambios de plazas se prorratean en tu próxima factura.',
		},
		emptyState: {
			title: 'Todavía no hay clientes',
		},
		editProgram: 'Editar programa',
		manageClient: 'Gestionar cliente',
		managingBannerLabel: 'Gestionando',
		backToMyAccount: 'Volver a mi cuenta',
		status: {
			pending: 'Pendiente',
			claimed: 'Activo',
		},
		nicknamePrompt: {
			createTitle: 'Nuevo cliente',
			renameTitle: 'Renombrar cliente',
			message: 'Elige un apodo para tu referencia. Tu cliente no verá este nombre.',
			placeholder: 'Apodo del cliente',
			create: 'Crear',
			rename: 'Renombrar',
			cancel: 'Cancelar',
		},
		rename: 'Renombrar cliente',
		removeClient: {
			button: 'Quitar cliente',
			confirmTitle: 'Quitar cliente',
			confirmMessage: 'Esto eliminará permanentemente esta plaza de cliente.',
			confirmMessageClaimed: 'Esto desconectará al cliente de tu entrenamiento. Conservará su programa actual.',
			confirm: 'Quitar',
			cancel: 'Cancelar',
			removing: 'Quitando cliente…',
		},
		intakeChoice: {
			title: '¿Cómo quieres empezar?',
			subtext: 'Puedes rellenar tú mismo el formulario, o enviar un formulario en blanco al cliente y dejar que lo responda por su cuenta.',
			fillMyself: 'Rellenaré yo el formulario',
			fillMyselfSubtext: 'Tú respondes cada paso y preparas el programa. El cliente recibe un enlace para reclamar el programa terminado.',
			sendBlank: 'Enviar formulario en blanco al cliente',
			sendBlankSubtext: 'El cliente reclama el enlace, responde el formulario por su cuenta, y tú revisas y finalizas el programa dentro de su cuenta.',
		},
		clientFills: {
			invitedTitle: 'Esperando al cliente',
			invitedSubtext: 'La invitación se ha enviado. El cliente rellenará el formulario en su propia cuenta. Recibirás una notificación cuando termine.',
			fillMyself: 'Rellenar yo el formulario',
			submittedTitle: 'Formulario listo para revisar',
			submittedSubtext: 'Tu cliente ha terminado su formulario. Revisa sus respuestas, define el volumen de entrenamiento y el balance energético, y genera el programa.',
			reviewIntake: 'Revisar formulario',
		},
		awaiting: {
			headerTitle: 'Tu programa',
			title: 'Tu entrenador está finalizando tu programa',
			subtext: 'Te avisaremos en cuanto tu programa esté listo. Puedes cerrar la app y volver más tarde.',
			subtextWithCoach: '{coachName} está revisando tu formulario y preparando tu plan de entrenamiento y nutrición. Te avisaremos en cuanto esté listo. Puedes cerrar la app y volver más tarde.',
		},
		invite: {
			title: 'Invitar cliente',
			share: 'Compartir',
			linkCopied: 'Enlace copiado',
			linkCopiedMessage: 'El enlace de invitación se ha copiado en tu portapapeles. Compártelo con tu cliente para que empiece.',
			ok: 'Aceptar',
			description: 'Comparte este enlace con tu cliente. Podrá registrarse y recibir el programa que preparaste.',
			creatingLink: 'Creando el enlace de invitación. Esto puede tardar unos segundos.',
			linkFailed: 'No hemos podido crear el enlace de invitación.',
		},
		claim: {
			title: 'Invitación de entrenador',
			description: '{coachName} ha preparado un programa de entrenamiento y nutrición para ti. Al aceptar, tu entrenador podrá ver tus datos de entrenamiento y ajustar tu programa.',
			descriptionBlankIntake: '{coachName} te ha invitado a entrenar. Responde unas preguntas para que pueda crear tu programa de entrenamiento y nutrición. Al aceptar, tu entrenador podrá ver tus datos de entrenamiento y ajustar tu programa.',
			accept: 'Aceptar',
			overwriteWarning: 'Ya tienes un programa activo. Al aceptar, se reemplazará tu programa actual. Tus registros, alimentos, ejercicios y equipo se conservarán.',
			connected: 'Ahora estás conectado con {coachName}.',
			invalidToken: 'Este enlace de invitación no es válido o ya se ha usado.',
			couldNotCheckToken: 'No hemos podido comprobar tu enlace de invitación en este momento. Tu enlace sigue siendo válido, así que revisa tu conexión e inténtalo de nuevo.',
			couldNotComplete: 'No hemos podido terminar de configurar tu programa. Tu enlace de invitación sigue siendo válido, así que ábrelo de nuevo. Si sigue sin funcionar, ponte en contacto con tu entrenador.',
			connectedSetupUnfinished: 'Ya estás conectado con tu entrenador, pero no hemos podido terminar de copiar tu programa. Vuelve a abrir la aplicación y ponte en contacto con tu entrenador si tu programa sigue sin aparecer.',
			settingUp: 'Configurando tu programa...',
			activationTimeout: 'Tu acceso de entrenador está tardando más de lo esperado en activarse. Inténtalo de nuevo en un momento, o contacta con soporte si el problema persiste.',
		},
		settingsSection: {
			title: 'Entrenamiento',
			coachName: 'Tu entrenador',
			leaveCoaching: 'Abandonar el entrenamiento',
		},
		selfDetach: {
			confirmTitle: 'Abandonar el entrenamiento',
			confirmMessage: 'Se te desconectará de {coachName}. Conservarás tus datos de entrenamiento, registros de comidas y ejercicios, pero perderás tu acceso a la suscripción. Esto no se puede deshacer.',
			confirmButton: 'Abandonar',
			successToast: 'Se te ha desconectado de {coachName}.',
			deleteAccountButton: 'Abandona el entrenamiento primero',
		},
		deleteBlocked: {
			message: 'Actualmente te está entrenando {coachName}. Pide a tu entrenador que te quite, o contacta con soporte, antes de eliminar tus datos.',
		},
		workoutViewOnly: 'Estás viendo este entrenamiento como entrenador. La ejecución del entrenamiento la gestiona el cliente.',
		weighInViewOnly: 'Estás viendo este pesaje como entrenador. Los datos de peso los gestiona el cliente.',
		offlineOverlay: {
			title: 'Conexión perdida',
			message: 'Esperando para reconectar. Todos los cambios se sincronizarán cuando se restablezca la conexión.',
		},
		presence: {
			online: 'En línea',
			lastSeen: 'Visto por última vez hace {time}',
			coachViewing: 'Tu entrenador está viendo tu programa en este momento',
		},
		checkup: {
			submitToCoach: 'Enviar al entrenador',
			submittedToast: 'Se te avisará cuando tu entrenador complete la revisión.',
			willBeSentForReview: 'Tu revisión se enviará a tu entrenador para que la revise. Verás los objetivos actualizados después de que tu entrenador la revise.',
			awaitingReview: 'Esperando la revisión del entrenador',
			reviewTitle: 'Revisar chequeo',
			currentTarget: 'Objetivo actual',
			recommendedTarget: 'Objetivo recomendado',
			accept: 'Aceptar',
			modify: 'Modificar',
			decline: 'Rechazar',
			customCalories: 'Objetivo de calorías personalizado',
			reviewActionPrompt: 'Valora la revisión semanal de tu cliente y decide cómo ajustar el objetivo de calorías.',
			kcalDelta: '{sign}{diff} kcal',
			kcalDeltaWithPercent: '{delta}, {percent}%',
			tabDecision: 'Decisión',
			tabBodyComposition: 'Composición corporal',
			intakeReportedByClient: 'Ingesta indicada por el cliente',
			weightChange: 'Cambio de peso',
			weightChangeWithPercent: '{perWeek} ({percent}%)',
			kcalValue: '{value} kcal',
			bfPercent: '~{value}%',
			resolveError: 'No se pudo resolver esta revisión. Inténtalo de nuevo.',
			decisionChoice: {
				accept: 'Aceptar el objetivo de la app',
				acceptHelp: 'El plan de tu cliente pasa a la recomendación de la app.',
				modify: 'Fijar otro objetivo',
				modifyHelp: 'Elige tú el número, en kcal o como un cambio en porcentaje.',
				decline: 'Mantener el objetivo actual',
				declineHelp: 'El plan de tu cliente se queda como está esta semana.',
			},
		},
		dashboard: {
			refresh: 'Actualizar',
			statusOnTrack: 'En camino',
			statusOffTrack: 'Desviado',
			statusUndetermined: 'Sin determinar',
			statusUnknown: 'Desconocido',
			itemsNone: '—',
			pendingSectionTitle: 'Invitaciones pendientes',
			actionItemsSectionTitle: 'Acciones pendientes',
			actionItemCheckupTitle: 'Revisión semanal',
			actionItemStrengthTestTitle: 'Test de fuerza',
			actionItemSubtext: 'Esperando tu valoración',
			actionItemTimeAgo: 'hace {time}',
			handoverIncompleteBadge: 'Configuración incompleta',
			handoverIncompleteExplanation: 'Este cliente aceptó tu invitación, pero su cuenta nunca terminó de recibir el programa que preparaste. Abre Gestionar cliente para comprobar qué tiene realmente, o pídele que vuelva a abrir su enlace de invitación.',
		},
		billing: {
			title: 'Facturación',
			headerAffordance: 'Abrir el panel de facturación',
			refresh: 'Actualizar',
			activeSlotsLine: '{count} plazas de cliente activas',
			runoutLine: 'A tu ritmo actual, tus créditos se agotarán alrededor del {date}.',
			balance: {
				remaining: '{amount} meses-cliente restantes',
				dueWithBilling: '{amount} meses-cliente pendientes',
				locked: 'Cuenta bloqueada',
			},
			history: {
				sectionTitle: 'Extractos',
				consumed: 'Consumidos {amount} meses-cliente',
				settled: 'Liquidado',
				unsettled: 'Sin liquidar — no hay método de pago registrado',
				empty: 'Aún no hay extractos. Verás una fila aquí el 3 de cada mes.',
			},
			loadError: {
				title: 'No se pudo cargar la facturación',
				subtext: 'No pudimos cargar tu panel de facturación. Comprueba tu conexión e inténtalo de nuevo.',
				retry: 'Reintentar',
			},
			unmigrated: {
				title: 'Facturación muy pronto',
				subtext: 'Tu cuenta usa la concesión anterior por plazas. Te avisaremos cuando el nuevo sistema de facturación esté activado para ti.',
			},
			seat: {
				heading: 'Entrenando a {count} {{cliente|clientes}}',
				billedMonthly: 'Se factura mensualmente, prorrateado a medida que añades o quitas clientes.',
				nextPayment: 'Próximo pago: {amount} el {date}',
				manageNote: 'Tu suscripción de entrenador incluye tu propio plan más una plaza por cliente. Para dejar de entrenar, cancela tu suscripción de entrenador.',
			},
			recordedHistory: {
				chartTitle: 'Clientes a lo largo del tiempo',
				range6: '6 meses',
				range12: '12 meses',
				rangeAria: 'Periodo',
				active: 'Activos',
				asleep: 'En pausa',
				mostClientsNote: 'El número máximo de clientes que tuviste cada mes.',
				capNote: 'Línea discontinua: el límite de tu plan cada mes (ahora {cap} {{cliente|clientes}}).',
				chartAria: 'Clientes por mes, de {from} a {to}: {values}',
				chartAriaWithCap: 'Clientes por mes, de {from} a {to}: {values}; límite del plan {cap}',
				paymentsTitle: 'Pagos anteriores',
				invoice: 'Factura',
				testBadge: 'Prueba',
				paddleLine: '{amount} · {seats} {{plaza|plazas}} de cliente',
				amountOnly: '{amount}',
				storeLine: '{amount} · plan de {cap} clientes · {store}',
				storeLineNoPlan: '{amount} · {store}',
				appStore: 'App Store',
				googlePlay: 'Google Play',
				receiptsApple: 'Los recibos están en tu historial de compras de App Store.',
				receiptsGoogle: 'Los recibos están en tu historial de compras de Google Play.',
				emptyHistory: 'Aún no hay historial. A partir de ahora se registran los cambios en tus clientes.',
				emptyPayments: 'Aún no hay pagos.',
				loadError: 'No se pudo cargar el historial de tus clientes.',
				retry: 'Reintentar',
				invoiceUnavailable: 'La factura no está disponible en este momento. Inténtalo de nuevo en un minuto.',
				invoiceBlocked: 'Tu navegador bloqueó la pestaña de la factura. Permite las ventanas emergentes para este sitio y toca Factura de nuevo.',
			},
		},
		tier: {
			becomeCoach: 'Hazte entrenador',
			noTiersAvailable: 'Los planes de entrenador no están disponibles ahora mismo. Inténtalo de nuevo más tarde.',
			tierOption: '{count} clientes · {price}',
			purchaseFailed: 'No pudimos completar tu compra. Inténtalo de nuevo.',
			purchaseNotYetConfirmed: 'Tu compra se ha realizado, pero no hemos podido terminar de confirmarla ahora mismo, así que puede que tu plan de entrenador aún no esté activo. No vuelvas a comprar. Puede que se active solo la próxima vez que abras la app. Si después de un par de días sigue sin estar activo, escribe a soporte.',
			crossProviderConflict: 'Ya tienes una membresía activa en otro canal de pago. Cancélala primero y luego configura el entrenamiento aquí.',
			purchaseSuccess: 'Todo listo — tu plan de entrenador ya está activo.',
			alreadyOwned: 'Ya tienes este plan. Usa Cambiar plan para pasar a uno diferente.',
			tierName: '{count} clientes',
			usageLine: 'Usando {used} de {cap} plazas de cliente',
			changePlan: 'Cambiar plan',
			changePlanSubtext: 'Sube o baja el número de clientes a los que puedes entrenar.',
			changeFailed: 'No pudimos cambiar tu plan. Inténtalo de nuevo.',
			changeNotYetConfirmed: 'Tu cambio de plan se ha realizado en la tienda, pero no hemos podido terminar de confirmarlo ahora mismo, así que puede que tu nuevo plan aún no aparezca. No vuelvas a intentarlo. Puede que se aplique solo la próxima vez que abras la app. Si después de un par de días tu nuevo plan sigue sin aparecer, escribe a soporte.',
			changeScheduled: 'Tu cambio de plan está programado y se aplicará al final de tu periodo de facturación actual.',
			changeSuccess: 'Tu plan se ha actualizado.',
			pauseWarning: {
				title: 'Algunos clientes quedarán en pausa',
				message: 'Este plan cubre {cap} {{cliente|clientes}}, y ahora mismo tienes más. Si continúas, {count} {{cliente quedará|clientes quedarán}} en pausa: {names}. Un cliente en pausa conserva su cuenta, su programa y su historial, pero deja de recibir el acceso Premium que le das, y no podrás abrirlo. Puedes reactivar a cualquiera de ellos más adelante, siempre que tu plan tenga espacio.',
				confirm: 'Continuar',
			},
			pausedNowSuffix: '{count} {{cliente quedó|clientes quedaron}} en pausa: {names}. Puedes reactivarlos desde tu lista de clientes cuando tu plan tenga espacio.',
			pauseScheduledNotice: {
				title: 'Algunos clientes quedarán en pausa al renovar',
				body: 'Tu plan cambia a {cap} {{cliente|clientes}} el {date}. En ese momento {count} {{cliente quedará|clientes quedarán}} en pausa: {names}. Hasta entonces no cambia nada.',
				bodyNoDate: 'Tu plan cambiará a {cap} {{cliente|clientes}} en tu próxima renovación. En ese momento {count} {{cliente quedará|clientes quedarán}} en pausa: {names}. Hasta entonces no cambia nada.',
			},
			crossChannel: {
				appBlock: 'Tu membresía se gestiona en la web. Puedes hacerte entrenador desde nuestro sitio web.',
				webBlock: 'Tu membresía está en {store}. Para hacerte entrenador, puedes comprar un plan de entrenador en la app — o, por un precio más bajo, cancelar tu membresía de la tienda y pasar a la facturación web.',
				webBlockPayPro: 'Tu membresía todavía se cobra a través de nuestro proveedor de pago anterior, así que aún no se puede configurar el entrenamiento con ella. Primero hay que pasar tu membresía a nuestro proveedor actual — escríbenos y nos encargamos nosotros, sin ninguna interrupción de tu membresía.',
			},
		},
		branding: {
			title: 'Marca',
			headerAffordance: 'Personaliza tu marca',
			logoLabel: 'Logo',
			logoHelp: 'Sube tu logo. Aparece en la app de tus clientes.',
			brandNameLabel: 'Nombre de la marca',
			brandNamePlaceholder: 'El nombre de tu negocio',
			accentLabel: 'Color de acento',
			accentHelp: 'Elige un preajuste o introduce tu propio color hex. Creamos una familia de tonos legible a partir de él automáticamente.',
			contrastWarning: 'El texto puede ser difícil de leer sobre este color. Lo mantenemos legible automáticamente, pero un color más fuerte se lee mejor.',
			previewLabel: 'Vista previa',
			previewButton: 'Botón de ejemplo',
			previewLink: 'Enlace de ejemplo',
			save: 'Guardar marca',
			saveConfirmTitle: '¿Aplicar la marca?',
			saveConfirmMessage: 'Esta marca se aplicará a todos tus clientes la próxima vez que abran la app.',
			saveSuccess: 'Marca guardada.',
			savePartial: 'Marca guardada, pero no se pudo actualizar a {count} cliente(s). Vuelve a guardar para reintentarlo.',
			saveError: 'No se pudo guardar la marca. Comprueba tu conexión e inténtalo de nuevo.',
			reset: 'Restablecer a los valores por defecto',
			resetConfirmTitle: '¿Quitar la marca?',
			resetConfirmMessage: 'Esto quita tu marca para todos tus clientes. Su app vuelve al aspecto por defecto de MH Physique la próxima vez que la abran.',
			resetSuccess: 'Marca restablecida a los valores por defecto.',
			resetPartial: 'Marca restablecida, pero no se pudo actualizar a {count} cliente(s). Vuelve a restablecer para reintentarlo.',
			resetError: 'No se pudo restablecer la marca. Comprueba tu conexión e inténtalo de nuevo.',
			poweredByMh: 'Con la tecnología de MH Physique',
		},
		sleepClient: {
			button: 'Pausar cliente',
			confirmTitle: '¿Pausar a este cliente?',
			confirmMessage: 'Conserva su cuenta, su programa y su historial, y puedes reactivarlo cuando quieras. Mientras esté en pausa vuelve a la experiencia gratuita, no puedes abrir su cuenta y deja de ocupar una plaza en tu plan.',
			confirm: 'Pausar',
			cancel: 'Cancelar',
			working: 'Pausando al cliente…',
		},
		wakeClient: {
			button: 'Reactivar cliente',
			confirmTitle: '¿Reactivar a este cliente?',
			confirmMessage: 'Recupera el acceso completo de inmediato y puedes volver a abrir su cuenta. Volverá a ocupar una plaza en tu plan.',
			confirm: 'Reactivar',
			cancel: 'Cancelar',
			working: 'Reactivando al cliente…',
		},
		clientAsleep: {
			badge: 'En pausa',
			badgeSince: 'En pausa desde hace {days} {{día|días}}',
			badgeSinceToday: 'En pausa desde hoy',
			refusedTitle: 'Este cliente está en pausa',
			refusedMessage: 'No puedes abrir la cuenta de un cliente en pausa. Reactívalo para continuar.',
			becausePlanFull: 'En pausa porque tu plan está lleno',
			becausePlanFullSince: 'En pausa desde hace {days} {{día|días}} porque tu plan está lleno',
			becausePlanFullToday: 'En pausa desde hoy porque tu plan está lleno',
		},
	},
	pageTitles: {
		login: 'Iniciar sesión',
		fatalError: 'Error grave',
		subscribe: 'Suscribirse',
		unsubscribe: 'Cancelar suscripción',
		changelog: 'Novedades',
		home: 'Inicio',
		editMeal: 'Comida',
		workoutDetail: 'Entrenamiento',
		equipmentEdit: 'Editar equipamiento',
		editWeighIn: 'Pesaje',
		training: 'Entrenamiento',
		editWorkouts: 'Editar entrenamientos',
		nutrition: 'Nutrición',
		programSettings: 'Ajustes del programa',
		advancedTrainingMethods: 'Métodos de entrenamiento avanzados',
		nutritionOptions: 'Opciones de nutrición',
		scheduleTips: 'Consejos de horario',
		equipmentSearch: 'Equipamiento',
		foods: 'Alimentos',
		barcodeScanner: 'Escanear código de barras',
		labelScanner: 'Escanear etiqueta',
		mealPhotoScanner: 'Escanear comida',
		equipmentScanner: 'Escanear equipamiento',
		workoutPlanScanner: 'Escanear entrenamiento',
		recipeScanner: 'Escanear receta',
		mealPlan: 'Plan de comidas',
		editFood: 'Alimento',
		editNutritionPlan: 'Editar objetivo diario de nutrición',
		editIngredient: 'Editar ingrediente',
		exerciseSwitch: 'Cambio de ejercicio',
		editExercise: 'Editar ejercicio',
		viewExercise: 'Ejercicio',
		exerciseConfiguration: 'Configuración del ejercicio',
		exerciseDiff: 'Actualización disponible',
		muscleVolume: 'Volumen muscular',
		editTrainingGoal: 'Editar objetivo de entrenamiento',
		updatePlanOptions: 'Actualiza tu programa',
		weeklyCheckup: 'Revisión semanal',
		exerciseStats: 'Estadísticas del ejercicio',
		progress: 'Progreso',
		userProfile: 'Perfil de usuario',
		settings: 'Ajustes',
		appSettings: 'Ajustes de la aplicación',
		notificationSettings: 'Ajustes de notificaciones',
		customizeHomepage: 'Personalizar la pantalla de inicio',
		redeemCode: 'Canjear código',
		referralInvite: 'Invitación',
		referralHub: 'Invitar a un amigo',
		intakeForm: 'Cuestionario inicial',
		introCarousel: 'Carrusel de introducción',
		awaitingCoach: 'Esperando al entrenador',
		helpCard: 'Ayuda',
		mealSuggestions: 'Sugerencias de comidas',
		note: 'Nota',
		purchaseSuccess: 'Suscripción activa',
		nutritionInfo: 'Información nutricional',
		taskCalendar: 'Calendario de tareas',
		inputCalendar: 'Calendario',
		changeWorkout: 'Cambiar entrenamiento',
		trainingOverview: 'Resumen de entrenamiento',
		sendFeedback: 'Enviar comentarios',
		sendCoachMessage: 'Mensaje al entrenador',
		help: 'Ayuda y preguntas frecuentes',
		cliAuth: 'Autorización de CLI',
		coachSettings: 'Entrenamiento personal',
		coachClientDetail: 'Detalle del cliente',
		coachBilling: 'Facturación del entrenador',
		coachCheckout: 'Hazte entrenador',
		coachBranding: 'Marca',
		coachClaim: 'Solicitud de entrenador',
	},
	coachingTips: {
		scheduleItems: {
			training: 'Entrenamiento',
			wakeUp: 'Despertarse',
			goToSleep: 'Irse a dormir',
			weeklyCheckup: 'Revisión semanal',
		},
	},
} satisfies Translation;

export default es;
